import SourceFlight from "containers/backend/layout/SourceFlight";
import { clearCache } from "services/hotelService";
import { success } from "toastr";

export const defineLang = {
  vi: {
    titLng: "Tiếng Việt",
    lang: "vi",
    notfound: "Không tìm thấy trang",
    welcome: "Chào mừng bạn đến với VinFast",
    title: "VinFast",
    login: "Đăng nhập",
    logout: "Đăng Xuất",
    currency: "VNĐ",
    currencySymbol: "đ",
    validation: {
      code: "Vui lòng nhập đúng định dạng code",
      type: "Vui lòng chọn ít nhất một loại",
      isValidInstallment: "Phải chọn thông tin phí trả góp và Thời hạn trả góp",
      email: "Vui lòng nhập đúng email",
      password:
        "Mật khẩu gồm ký tự thường, ký tự viết hoa, ký tự số, ký tự đặt biệt và trên 6 ký tự",
      image: "File phải là hình",
      video: "File phải là video",
      required: "Dữ liệu không được rỗng",
      requiredImage: "Vui lòng chọn hình",
      string: "Dữ liệu phải là ký tự",
      number: "Dữ liệu phải là số",
      priceRequired: "Vui lòng nhập giá",
      invalidDate: "Ngày tháng không hợp lệ",
      salePriceLessThenPrice: "Giá giảm phải thấp hơn giá gốc",
      sureUse: "Bạn chắc chắn muốn sử dụng ?",
      sureResetSetting: "Bạn chắc chắn muốn đặt lại tất cả cài đặt?",
      image1pic: "Vui lòng chọn 1 tấm hình",
      maxImage: "Tối đa 5 tấm hình",
      passwordRequired: "Mật khẩu không được rỗng",
      currentPasswordRequired: "Mật khẩu cũ không được rỗng",
      newPasswordRequired: "Mật khẩu mới không được rỗng",
      confirmPasswordRequired: "Mật khẩu xác nhận không được rỗng",
      usernameRequired: "Tài khoản không được rỗng",
      usernameOrPasswordNotMatch: "Tài khoản hoặc mật khẩu không đúng",
      userLocked: "Sai thông tin đăng nhập hoặc tài khoản bị khoá",
      connectFail: "Kết nối bị lỗi, máy chủ không phản hồi!",
      voucherInvalid: "Mã số voucher không hợp lệ",
      userNameExists: "Tài khoản đã tồn tại!",
      uploadFail: "Tải tập tin không thành công",
      percent: "Không được quá 100%",
      percent_negative: "Không được nhỏ hơn -100%",
      minOrderValue: "Dữ liệu phải nhỏ hơn đơn hàng tối đa",
      maxPhone: "Không được quá 12 ký tự",
      minPhone: "Dữ liệu phải từ 8 ký tự trở lên",
      minpassword: "Dữ liệu phải từ 6 ký tự trở lên",
      quantity: "Số lượng ít nhất là 1",
      LessThenZero: "Dữ liệu phải lớn hơn 0",
      MinValue: "Dữ liệu phải lớn hơn",
      isPhone: "Vui lòng nhập đúng số điện thoại",
      isSpecialString: "Vui lòng không nhập ký tự đặc biệt",
      isUrl: "Vui lòng nhập đúng đường dẫn",
      recaptcha: "Vui lòng xác nhận trước khi đăng nhập",
      comparePassword: "Mật khẩu xác nhận không trùng khớp",
      nameRequired: "Tên không được rỗng",
      codeRequired: "Code không được rỗng",
      starRequired: "Hạng không được để trống",
      checkForm: "Vui lòng kiểm tra lại dữ liệu",
      maxSaleOrderQuantity: "Số lượng không được lớn hơn tổng voucher",
      minSaleOrderQuantity: "Vui lòng nhập số lượng vé",
      limitSalePrice: "Giá vé khuyến mãi không được lớn hơn giá vé gốc",
      limitPercentPrice: "% khuyến mãi phải nằm trong khoảng 0 -> 100%",
      unknowError: "Lỗi không xác định",
      tourLineTicketNull: "Vui lòng tạo vé",
      getCouponFail: "Mã không hợp lệ hoặc đã hết hạn",
      validateNotePromotion: "Ghi chú không được để trống",
      syncSuccess: "Đồng bộ dữ liệu thành công",
      clearCacheSuccess: "Clear cache thành công",
      syncDifferentDataCancelPolicy:
        "Dữ liệu cancel policy hiện tại RRM khác với dữ liệu lưu trữ trên VPT",
      minMaxInvalid: "Số lượng tối thiểu đang lớn hơn số lượng tối đa",
      minTicketInvalid:
        "Số lượng tối thiểu phải lớn hơn hoặc bằng bội số và phải chia hết cho bội số",
      maxTicketInvalid: "Số lượng tối đa phải chia hết cho bội số",
      promotion: {
        NOT_FOUND: "Mã promotion * %s * không hợp lệ",
      },
      queryWithTime30Days: "Mỗi lần tìm kiếm tối đa 30 ngày",
      maxCodeVWTag: "Dữ liệu không được quá 20 ký tự",
      minCodeVWTag: "Dữ liệu phải từ 3 ký tự trở lên",
      statusCode: {
        code: {
          200: "Tải dữ liệu thành công",
          201: "Tạo thành công",
          204: "Cập nhật dữ liệu thành công",
          203: "Xoá dữ liệu thành công",
          400: "Truy xuất không hiệu lực nhé",
          401: "Bạn chưa đăng nhập!",
          403: "Bạn chưa được cấp quyền vào trang này!.",
          404: "Không tìm thấy trang",
          405: "Không hỗ trợ",
          408: "Lỗi kết nối đến máy chủ, vui lòng thử lại sau.",
          500: "Đã có lỗi xảy ra. Vui lòng liên hệ với admin hệ thống để được hỗ trợ. Xin cám ơn",
          1: "%s không được để trống",
          2: "%s phải là số",
          3: "%s quá giới hạn",
          4: "Không được quá %s ký tự",
          5: "Không được quá %s file",
          6: "Chưa có dữ liệu",
          7: "Bạn chắc chắn muốn xoá %s",
          8: 'Giá trị không được lớn hơn "%s"',
          9: "Hình ảnh tối đa là %s tấm hình",
          10: "Vui lòng nhập %s",
          11: "Vui lòng chọn %s",
          12: "Vui lòng chọn ít nhất %s tấm hình",
          13: "Vui lòng chọn ít nhất %s",
          14: "Vui lòng không nhập số lượng lớn hơn %s",
          15: "Bạn chắc chắn muốn sao chép %s",
          1001: "Can not refund order",
          16: "Vui lòng không nhập giá trị lớn hơn %s",
          1208: "Tài khoản hoặc mật khẩu không hợp lệ",
          1403: "Tài khoản hoặc mật khẩu không hợp lệ",
          1406: "Số điện thoại không hợp lệ",
          1409: "Vui lòng chọn trạm",
          1404: "Tài khoản hoặc email đã tồn tại!",
          1414: "Thông tin đăng nhập không đúng !",
          1210: "Thông tin đăng nhập không đúng !",
          1417: "Bạn không thể cập nhật nhân viên này!",
          1418: "Mã nhân viên không được trùng",
          1555: "Vui lòng nhập lý do hủy phiếu!",
          1563: "Nhân viên được giao không có quyền thực hiện phiếu yêu cầu",
          8001: "Tài khoàn hoặc mật khẩu của bạn không đúng. Vui lòng thử lại",
          8002: "IP đã bị chặn truy cập vào đường dẫn trên. Vui lòng quay lại sau",
          8003: "Tài khoản đã bị tạm khóa trong vòng 15'. Vui lòng quay lại sau",
          8004: "Bạn không có quyền để hủy ticket này",
          8005: "Dữ liệu phải lớn hơn 0",
          8006: "%s phải lớn hơn 0",

          RATE_DESCRIPTION_PROMOTIONAL_REQUIRED: "Mô tả (Dịch vụ đính kèm) không được để trống",
          RATE_DESCRIPTION_TERMS_CONDITIONS_REQUIRED: "Mô tả (Điều khoản) không được để trống",

          // Group: 10000
          10001: "Không thể tìm được chương trình",
          GROUP_NOT_FOUND: "Không thể tìm được chương trình",
          10002: "Cơ sở không tồn tại",
          GROUP_PROPERTY_IDS_NOT_EXIST: "Cơ sở không tồn tại",
          10003: "Sản phẩm không tồn tại",
          GROUP_PRODUCT_IDS_NOT_EXIST: "Sản phẩm không tồn tại",
          10004: "Chương trình đang được bán",
          GROUP_IS_RUNNING: "Chương trình đang được bán",
          10005: "Chương trình đã kết thúc",
          GROUP_WAS_ENDED: "Chương trình đã kết thúc",
          10006: "Ngày giờ mở bán không được nhỏ hơn ngày giờ hiện tại",
          START_DATE_LESS_THAN_NOW:
            "Ngày giờ mở bán không được nhỏ hơn ngày giờ hiện tại",
          10007:
            "Ngày bắt đầu/Ngày mở bán không được lớn hơn ngày kết thúc/Ngày ngừng bán",
          10010:
            "Thời gian bắt đầu lưu trú không được lớn hơn thời gian bắt đầu lưu trú",
          START_DATE_LARGER_THAN_END_DATE:
            "Ngày bắt đầu/Ngày mở bán không được lớn hơn ngày kết thúc/Ngày ngừng bán",
          10008: "Ngày ngừng bán không được lớn hơn ngày kết thúc",
          10009: "Ngày check-in không được lớn hơn ngày check-out",
          SALE_START_DATE_LARGER_THAN_SALE_END_DATE:
            "Ngày ngừng bán không được lớn hơn ngày kết thúc",
          10101: "Ngày bắt đầu không được nhỏ hơn ngày hiện tại",
          SALE_END_DATE_LARGER_THAN_END_DATE:
            "Ngày bắt đầu không được nhỏ hơn ngày hiện tại",
          DATE_LESS_THAN_NOW: "Ngày giờ không được nhỏ hơn ngay giờ hiện tại",
          MIN_PRICE_LARGER_THAN_MAX_PRICE:
            "Giá thấp nhất không được lớn hơn giá cao nhất",
          // Voucher: 11000
          11001: "Mã voucher không hợp lệ",
          SERIAL_NUMBER_INVALID: "Mã voucher không hợp lệ",
          11002: "Không tìm thấy voucher",
          VOUCHER_NOT_FOUND: "Không tìm thấy voucher",
          11003: "Voucher đã được sử dụng",
          VOUCHER_USED: "Voucher đã được sử dụng",
          11004: "Voucher đã bị khoá",
          VOUCHER_LOCKED: "Voucher đã bị khoá",
          11005: "Voucher đã hết số lần sử dụng",
          VOUCHER_USED_UP: "Voucher đã hết số lần sử dụng",
          11006: "Chương trình tạm dừng",
          GROUP_UNAVAILABLE: "Chương trình tạm dừng",
          11007: "Voucher đã hết hạn",
          VOUCHER_WAS_EXPIRED: "Voucher đã hết hạn",
          11008: "Chương trình chưa bắt đầu",
          GROUP_NOT_STARTED_YET: "Chương trình chưa bắt đầu",
          11009: "Voucher chưa đến ngày sử dụng",
          VOUCHER_NOT_STARTED_YET: "Voucher chưa đến ngày sử dụng",
          11010: "Voucher không thể sử dụng tại cơ sở này",
          VOUCHER_PROPERTY_ERROR: "Voucher không thể sử dụng tại cơ sở này",
          // User: 12000
          12001: "Không tìm thấy tài khoản hoặc tài khoản đã bị khoá",
          12002: "Tài khoản đã tồn tại",
          ID_USER_EXISTED: "Tài khoản đã tồn tại",
          SITEINFO_NOT_FOUND: "Không tìm thấy thông tin",
          SITEINFO_KEY_EXISTED: "Key đã tồn tại",
          AGENT_NOT_FOUND: "Không tìm thấy đại lý",
          AGENT_USED: "Đại lý đang được sử dụng",
          INVAID_MODEL_REQUEST: "Model request cannot be null or empty",
          INVALID_IP_ADDRESS: "IP address invalid format",
          INVALID_PROPERTY_INFORMATIONS: "Property invalid information",
          IP_ADDRESS_ALREADY_REGISTERED: "IP address already registered",
          CREATE_WHITE_LIST_IP_EXCEPTION: "WhiteList Ip Exception",
          12003: "Cơ sở không tồn tại hoặc đã bị xoá",
          12004: "Quyền hạn chưa được cập nhật hoặc không tồn tại",
          12005: "Tài khoản không thể xoá",
          12006: "Tài khoản sẽ bị khoá nếu đăng nhập sai nhiều lần",
          ID_USER_LOCK_WARNING:
            "Tài khoản sẽ bị khoá nếu đăng nhập sai nhiều lần",
          12007: "Email chưa được xác nhận",
          12008: "Tài khoản đã bị khoá",
          ID_USER_LOCKED: "Tài khoản đã bị khoá",
          12010: "Mã xác nhận sai",
          ID_WRONG_OLD_PASSWORD: "Mật khẩu cũ không chính xác",
          12011: "Mật khẩu cũ không chính xác",
          12012: "Email đã tồn tại",
          // Cart: 13000
          13001: "Chương trình không tồn tại",
          13002: "Voucher không đủ",
          13003: "Không tìm thấy giỏ hàng",
          13004: "Cart item not found",
          //ImportData: 14000
          14001: "Nhập dữ liệu thất bại",
          FAILED_TO_IMPORT_DATA: "Nhập dữ liệu thất bại",
          FILE_NOT_FOUND: "Không tìm thấy file",
          NOT_EXCEL_FORMAT: "Không đúng định dạng excel",
          // UploadFile: 15000 (Storage)
          15001: "Tải dữ liệu thất bại",
          15002: "Không tìm thấy dữ liệu",
          15003: "Dữ liệu không được chấp nhận, Vui lòng chọn lại",
          15004: "Dung lượng dữ liệu bị giới hạn",
          // Banner: 16000 (Storage)
          16001: "Không tìm thấy hình ảnh",
          // Order: 17000 (Booking)
          17001: "Không tìm thấy đơn hàng",
          17002: "Đặt hàng thất bại",
          17003: "Đơn hàng đã được thanh toán",
          17004: "Không đủ voucher",
          // Property: 18000
          18001: "Không tìm thấy cơ sở",
          PROPERTY_NOT_FOUND: "Không tìm thấy cơ sở",
          PROPERTY_USED: "Cơ sở đang được sử dụng",
          // Product: 19000
          19001: "Không tìm thấy sản phẩm",
          PRODUCT_NOT_FOUND: "Không tìm thấy sản phẩm",
          PRODUCT_USED: "Sản phẩm đang được sử dụng",
          // Customer: 20000
          20001: "Không tìm thấy khách hàng",

          21001: "Chỉ được xem trong vòng 90 ngày",
          21002:
            "Ngày bắt đầu không được lớn hơn ngày kết thúc hoặc ngày hiện tại",
          //Role
          22001: "Vai trò không tồn tại",
          22002: "Vai trò đã tồn tại",
          22003: "Vai trò đã được sử dụng",

                    //Flight
                    30001: "Thời hạn đặt vé chiều về không được lớn hơn Thời hạn đặt vé chiều đi",
                    SCRIPT_TAG: '%s không được chứa thẻ <script>',
                    UNDEFINED_ERROR: 'Lỗi không xác định',
                    INVALID_CAPTCHA: 'Sai mã xác thực',
                    PAGE_NOT_FOUND: "Không tìm thấy trang",
                    CATEGORY_NOT_FOUND: "Không tìm thấy danh mục",
                    CATEGORY_EXISTED: "Danh mục đã tồn tại",
                    CATEGORY_USED: "Danh mục đã sử dụng",
                    CATEGORY_IDS_NOT_EXIST: "Một số danh mục đã tồn tại",
                    TAG_NOT_FOUND: "Không tìm thấy thẻ",
                    TAG_EXISTED: "Thẻ tồn tại",
                    TAG_USED: "Thẻ đã dùng",
                    BANNER_NOT_FOUND: "Không tìm thấy banner",
                    FILE_UPLOAD_FAILED: "Tải lên bị lỗi",
                    FILE_TYPE_NOT_ACCEPTED: "Loại file không hỗ trợ",
                    FILE_LENGTH_OVER_LIMIT: "File quá giới hạn kích thước",
                    ZERO_FILE_LENGTH: "File rỗng",
                    DIRECTORY_NOT_ALLOW: 'Thư mục không được phép thao tác',
                    URL_SLUG_ALREADY_EXISTS: 'Đường dẫn website đã tồn tại',
                    AIRPORT_EXIST: 'Mã sân bay đã tồn tại',
                    BOOKING_PERIOD_LESS_THAN_NOW: 'Hạn cuối cũng phải đặt không được nhỏ hơn ngày hiện tại',
                    BOOKING_PERIOD_LARGER_THAN_END_DATE: 'Hạn cuối cũng phải đặt không được lớn hơn ngày kết thúc',
                    VOUCHER_USED_CANNOT_CHANGE_STATUS: 'Không thể chuyển sang trạng thái %s vì voucher đã được sử dụng',
                    TICKET_USED: 'Vé đang được sử dụng nên không thể xóa !',
                    TS_INVALID_DEPARTURE_DATE: "Ngày khởi hành không hợp lệ",
                    EXISTED: 'Loại vé đã tồn tại',
                    TICKET_DUPLICATE: 'Loại vé đã bị trùng. Vui lòng kiểm tra lại',
                    NOT_FOUND: 'Không tìm thấy dữ liệu',
                    AMENITY_EXISTED: 'code tiện ích đã tồn lại',
                    TOUR_PRICE_FAILED: 'Vé trẻ em không tồn tại',
                    ITEM_TYPE_NOT_EXIST: 'Loại đơn không tồn tại',
                    CANNOT_CHANGE_STATUS: 'Không thể thay đổi trạng thái',
                    CANNOT_LOCK_ITEM: 'Không thể khóa voucher',
                    ITEM_LOCKED: 'Đơn hàng đã khóa',
                    VOUCHER_WAS_CANCELLED: 'Voucher đã bị hủy',
                    VOUCHER_WAS_REFUNDED: 'Voucher đã được hoàn lại',
                    APPLY_PROMOTION_CODE_FAILED: 'Mã giảm giá không hợp lệ hoặc đã hết hạn',
                    TAG_GROUP_DETAIL_EXISTED: 'Tên nhóm thẻ đã tồn tại',
                    TAG_GROUP_DETAIL_USED: 'Không thể xoá Thông tin nhóm thẻ đã link với SKUs',
                    TICKET_TOUR_PRICE_REQUIRED: '%s hoặc %f phải lớn hơn 0',
                    OBJECT_TYPE_CODE_EXISTED: 'Mã đối tượng không được trùng lặp',
                    ACTIVATED_BUNDLE: "Bạn chắc chắn muốn kích hoạt %s",
                    DEACTIVATED_BUNDLE: "Bạn chắc chắn muốn ngừng kích hoạt %s",
                    PROMOTION_CODE_EXISTED: "Mã khuyến mãi đã tồn tại",
                    EXCEEDED_NUMBER_OF_CODE: "Mã khuyến mãi vượt quá số lượng cho phép",
                    VIN_WONDER_SITECODE_NOT_FOUND: "Không thể tìm thấy Vinwonder site code",
                    RECOMMIT_TOURS_SEATS_IS_OUT_OF_STOCK: "Số lượng tour hiện tại không khả dụng",
                    RECOMMIT_APPLY_FOR_ALL_ORDER_ITEMS_FAILED_ONLY: "Trạng thái các đơn hàng không khả dụng",
                    RECOMMIT_APPLY_ORDER_TOUR_ONLY: "Chỉ khả dụng đối với đơn hàng tour đã thanh toán và trạng thái đơn hàng không thành công",
                    APPLY_PROMOTION_FAILED: "Mã khuyến mãi không hợp lệ",
                    ACTION: "Bạn có chắc chắn thực hiện hành động này",
                    FILE_INVALID: "Tệp tin không đúng định dạng!",
                    //campaign
                    INVALID_TYPE_LOYALTY: 'Mã promotion đang map với loyalty dùng unique code ',
                    LOYALTY_HAVE_TO_UNLIMITED: 'Mã promotion map với loyalty sử dụng code có giới hạn',
                    PAYMENT_MUST_CHOOSE_CUSTOMIZE_TYPE: 'Bắt buộc chọn định dạng code tùy chỉnh',
                    MUST_ONE_CODE_ONLY: 'Số lượng code = 1',
                    PAYMENT_INVALID_DATA: 'Thông tin tạo chương trình không hợp lệ',
                    PROMOTION_BANK_PAYMENT_METHOD_REQUIRED: 'Vui lòng chọn ít nhất một phương thức thanh toán',
                    PROMOTION_BANK_DISCOUNT_VALUE_INVALID: 'Giá trị giảm phải lớn hơn 0 và phần trăm không được vượt quá 100',
                    PROMOTION_BANK_MAX_DISCOUNT_INVALID: 'Giá trị giảm tối đa phải lớn hơn 0 khi giảm theo phần trăm',
                    PROMOTION_BANK_MIN_ORDER_VALUE_INVALID: 'Tổng tiền đơn hàng tối thiểu không được nhỏ hơn 0',
                    PROMOTION_BANK_BUDGET_INVALID: 'Tổng ngân sách chiến dịch không được nhỏ hơn 0',
                    PROMOTION_BANK_BUDGET_LESS_THAN_USED: 'Tổng ngân sách chiến dịch không được nhỏ hơn ngân sách đã dùng',
                    PROMOTION_BANK_CONTRIBUTION_PERCENT_INVALID: 'Tỷ lệ ngân hàng chi trả phải từ 0 đến 100',
                    PROMOTION_BANK_CONTRIBUTION_TYPE_REQUIRED: 'Vui lòng chọn tỷ lệ tài trợ còn lại',
                    PROMOTION_TYPE_INVALID: 'Kiểu mã code không hợp lệ',
                    DISCOUNT_TYPE_INVALID: 'Kiểu giảm giá không hợp lệ',
                    DISCOUNT_VALUE_INVALID: 'Giá trị giảm giá không hợp lệ',
                    DISCOUNT_MODE_INVALID: 'Kiểu thưởng không hợp lệ',
                    CANNOT_DELETE_CAMPAIGN_STARTED: 'Không thể xóa chiến dịch đang hoạt động.',
                    CANNOT_DELETE_CAMPAIGN_HAD_PROMOTION_CODE: 'Không thể xóa chiến dịch đã tạo mã khuyến mãi.',
                    //bundle
                    LOYALTY_HAVE_ONE_CODE_ONLY: 'Promotion map với loyalty có nhiều hơn một code general',
                    REDIRECT_LINK_RECURSIVE: 'Đường dẫn liên kết đã tồn tại trên hệ thống',
                    REDIRECT_TO_LINK_ERROR: 'Đường dẫn liên kết không hợp lệ',
                    TICKET_CODE_EXISTED: 'Mã vé đã tồn tại',
                    UPDATE_RESERVATION_FAILED: 'Cập nhật đặt chỗ không thành công',
                    VOUCHER_CODE_INVALID: 'Mã voucher không hợp lệ',
                    WH_NOT_RECEIPT: 'Please goods receipt first!',
                    RESERVATION_NOT_FOUND: 'Không tìm thấy thông tin đặt chỗ',
                    //ratecode
                    CAMPAIGN_NOT_FOUND: 'Nhóm chương trình không hợp lệ',
                    CAMPAIGN_NAME_DUPLICATE: 'Nhóm chương trình đã tồn tại',
                    RATE_CODE_DUPLICATE: 'Code mã giá đã tồn tại',
                    RATE_CODE_NOT_FOUND: 'Mã giá không được tìm thấy',
                    RATE_CODE_NOT_CHANGE: 'Ratecode chỉ có thể thay đổi khi thay đổi mã và các thành phần sản phẩm',
                    RATE_CODE_PRODUCT_DUPLICATE: 'Mã giá tích hợp Vinwonder không được nhiều hơn 1 sản phẩm vinwonder',
                    NOT_ADD_RATE_CODE_NOT_VINWONDER: 'Mã giá Tour/Voucher không được thêm sản phẩm vinwonder',
                    TS_SUPPLIER_PRODUCT_NOT_FOUND: "Sản phẩm nhà cung cấp không tìm thấy",
                    TS_SUPPLIER_NOT_FOUND: "Sản phẩm không tìm thấy",
                    SUPPLIER_PRODUCT_MATCH_RATECODE: "Sản phẩm nhà cung cấp đã được link với mã giá",
                    INVALID_PRODUCT_CODE: "Product code không hợp lệ",
                    DUPLICATE_PRODUCT_CODE: "Product code đã tồn tại",
                    UPDATE_RESERVATION_FAILED: 'Cập nhật đặt chỗ không thành công',
                    VOUCHER_CODE_INVALID: 'Mã bảo mật không hợp lệ',
                    RESERVATION_NOT_FOUND: 'Không tìm thấy thông tin đặt chỗ',
                    MIN_CHAR: 'ít nhất %s ký tự',
                    VOUCHER_LOCKED: 'Voucher đã bị khoá',
                    VOUCHER_NOT_STARTED_YET: 'Voucher chưa tới ngày sử dụng',
                    VOUCHER_WAS_EXPIRED: 'Voucher đã hết hạn sử dụng',
                    TOUR_TICKET_ITEM_DEFAULTPRICE_ALEASTONE: 'Vui lòng chọn giá hiển thị trên website',
                    OBJECT_TYPE_USED: 'Không thể xoá đối tượng đang được sử dụng',
                    CANNOT_ADD_SHEDULE_VINWONDER: 'Winwonder product can not add shedule',
                    LENGTH_OF_STAY_INVALID: 'Length of stay must be greater than Length of stay base',
                    LENGTH_OF_STAY_EXISTS: 'Length of stay already exists, Please try again!',
                    MINIMUM_UNIT_SCHEDULE_INVALID: 'Length of stay/room/adult,child invalid, please try again!',
                    //supplier category
                    CATEGORY_DUPLICATE: 'Nhóm sản phẩm đã tồn tại',
                    CATEGORY_NOT_FOUND: 'Không tìm thấy nhóm sản phẩm',
                    CATEGORY_IN_USED: 'Nhóm sản phẩm đã được sử dụng',
                    CATEGORY_KEY_DUPLICATE: 'Key List đã tồn tại',
                    CATEGORY_KEY_NOT_FOUND: 'Không tìm thấy Key List',
                    //product code
                    DUPLICATE_PRODUCT_CODE: "Mã sản phẩm đã tồn tại",
                    MAXIMUM_PRODUCT_CODE_GENERATED: "Product Code generated reach limit 000 - 999",
                    SUPPLIER_CODE_INVALID: "Supplier code is not valid, must be contain letter and number, length = 5",
                    SUPPLIER_CODE_EXISTED: "Mã nhà cung cấp đã tồn tại",
                    RATE_CODE_USED_TOUR_TICKET: 'Mã giá đã được sử dụng cho vé',
                    //config PHS
                    PHS_CONFIG_NOT_VALID: 'Thời gian PHS không được nhỏ hơn thời gian payment',
                    BUNDLE_NOT_LINKED_TO_LOYALTY: 'Không liên kết được với Loyalty',
                    PROMOTION_CODE_DUPLICATED: 'Mã khuyến mãi bị trùng lặp',
                    CODE_TYPE_IS_INVALID: 'Định dạng code không hợp lệ',
                    PROMOTION_CODE_IS_INVALID: 'Mã khuyến mãi không hợp lệ',
                    CANNOT_CREATE_LOYALTY_VOUCHER: 'Không thể tạo voucher',
                    LOYALTY_BENEFIT_CODE_IS_REQUIRED: 'Vui lòng nhập mã ưu đãi',
                    LOYALTY_BENEFIT_CODE_EXISTED: 'Mã ưu đãi đã tồn tại',
                    ORDER_CODES_CANNOT_EMPTY: 'Vui lòng nhập mã đơn hàng',
                    VIN_WONDER_TICKET_ITEM_ALREADY_EXISTS: 'Loại vé đã tồn tại',
                    REDEEM_NEED_ITBOOKING_NUMBER: 'Vui lòng nhập ITI Booking ID',
                    REDEEM_NO_NEED_ITBOOKING_NUMBER: 'Không cần nhập ITI Booking ID',
                    MRU_BUNDLE_STAY_FROM_DATE_GREATER_THAN_TO_DATE: "Stay from date greater than stay to date",
                    MRU_BUNDLE_STAY_FROM_DATE_IN_PASS: "Stay from date invalid",
                    MRU_BUNDLE_CAMPAIN_NAME_IS_EMPTY: "Tên chiến dịch không được để trống",
                    MRU_BUNDLE_CAMPAIN_NAME_IS_EXISTED: "Tên chiến dịch bị trùng",
                    MRU_BUNDLE_BOOK_FROM_DATE_GREATER_THAN_TO_DATE: "Book from date greater than book to date",
                    MRU_BUNDLE_MARKUP_VALUE_STAY_DATE_MUST_GREATER_THAN_ZERO: "Giá trị markup phải lớn hơn 0",
                    MRU_BUNDLE_TOTAL_MARKUP_VALUE_MUST_GREATER_THAN_ZERO: "Giá trị markup phải lớn hơn 0",
                    MRU_BUNDLE_BOOK_DATE_IS_OVERLAP: "Ngày đặt không được trùng",
                    MRU_BUNDLE_CANNOT_CREATE_MARKUP_CONFIG: "Error while insert new markup config",
                    MRU_BUNDLE_CANNOT_UPDATE_MARKUP_CONFIG: "Error while update data markup config",
                    MRU_BUNDLE_CANNOT_CREATE_MARKUP_BOOK_DATE: "Error while insert new markup book date",
                    MRU_BUNDLE_CANNOT_CREATE_MARKUP_RATE_PLAN: "Error while insert new markup rate plan",
                    MRU_BUNDLE_RATE_PLAN_IS_EMPTY: "Rate plan không được để trống",
                    MRU_BUNDLE_BOOK_DATE_IS_EMPTY: "Bookdate không được để trống",
                    MRU_BUNDLE_RATE_PLAN_EXISTED_OTHER_CAMPAIN: "Đã tồn tại chiến dịch bị trùng Staydate & RatePlan . Vui lòng kiểm tra lại .",
                    MRU_BUNDLE_MARKUP_CONFIG_ID_REQUIRED_IN_UPDATE: "Markup config Id required when update data",
                    MRU_BUNDLE_PRICES_HAD_CHANGED: "Tổng giá tiền đã thay đổi, vui lòng thử tìm kiếm lại!",
                    ORDER_CODES_CANNOT_EMPTY: 'Vui lòng nhập mã đơn hàng',
                    NOT_ENOUGH_QUANTITY: 'Không đủ số lượng vé bán',
                    ORDER_NOT_FOUND: 'Mã đơn hàng không tồn tại',
                    PHS_RESET_COUNT_TIME_INVALID: 'Số lần chọn vé phải từ 0 tới 10',
                    CATEGORY_VALIDATION_ERROR: 'Sản phẩm nhà cung cấp bị trùng',
                    CANT_ACTIVE_RATE_UNUSAGE: 'Không thể đổi trạng thái của rate plan đang không trong trạng thái sử dụng',
                    RATE_NAME_REQUIRED: 'Tên không được bỏ trống',
                    RATE_DESCRIPTION_REQUIRED: 'Mô tả không được bỏ trống',
                    TRANSACTION_INVALID: 'Transaction code không hợp lệ',
                    SURCHARGE_TRANSACTION_CODE_NOT_VALID: 'Lỗi transaction code trong phụ thu không hợp lệ',
                    SURCHARGE_PMS_CODE_NOT_VALID: 'Lỗi transaction code trong phụ thu không hợp lệ',
                    SURCHARGE_PMS_CODE_REQUIRED: 'Phụ thu này yêu cầu transaction code',
                    SYS_SURCHARGE_EXCEED_CHECKOUT_DATE: 'Phụ thu chỉ thực hiện được đến hết ngày checkout',
                    COMBINE_RATE_CODE_DIFFERENCE_INTEREST_TYPE: "Loại lãi suất của mã lãi suất là chênh lệch, không thể tạo mã lãi suất mới",
                    COMBINE_RATE_CODE_INVALID_PARAMS_INPUT: "Đầu vào tham số không được rỗng hoặc trống",
                    COMBINE_RATE_CODE_NOT_FOUND_IN_LIST_IDS: "Không tìm thấy bất kỳ mã tỷ lệ nào trong danh sách",
                    COMBINE_RATE_CODE_CANNOT_GENERATE_NEW_CODE: "Không thể tạo mã mới",
                    COMBINE_RATE_CODE_SELL_COST_LESS_THAN_COST: "Giá bán không được nhỏ hơn giá vốn",
                    RATECODE_NOT_VALID: "Rate code không hợp lệ",
                    CANNOT_CHANGE_RATE: "Không thể thay đổi Rate code",
                    LTR_CATEGORY_VALIDATION_ERROR: "Rate code không thể không có 2 sản phẩm thuộc danh mục LTR",
                    MKR_PROMOTION_IS_NULL: "Promotion campaign type is markup, promotion markup info cannot be null",
                    MKR_PROMOTION_ROOMNIGHT_NUMBER_INVALID: "Min room night cannot larger than max room night",
                    MKR_PROMOTION_MARKUP_CONFIG_ID_IS_EMPTY: "Data markup config cannot contains markup config id is null or empty",
                    MKR_PROMOTION_MARKUP_CONFIG_HOTEL_RATE_IS_EMPTY: "Data markup config cannot contains hotel id or rate plan id is null or empty",
                    MKR_PROMOTION_MARKUP_DISCOUNT_MODE_MUST_BE_ALL: "Promotion for markup must have discount mode is all",
                    MKR_PROMOTION_MARKUP_DISCOUNT_TYPE_INVALID: "Promotion for markup must have discount type is cash or percentage",
                    MKR_PROMOTION_MARKUP_CAMPAIGN_NOT_FOUND: "Cannot found any markup campaign",
                    MKR_PROMOTION_MARKUP_CAMPAIGN_INACTIVED: "Markup campaign inactived: ",
                    MKR_PROMOTION_MARKUP_NOT_MATCH_DISCOUNT_TYPE: "Promotion campaign and markup campaign has difference discount type",
                    MKR_PROMOTION_VALUE_GREATER_THAN_MARKUP_MIN_VALUE: "Promotion discount value greater than minimum markup value",
                    MKR_PROMOTION_MARKUP_VALUE_MUST_GREATER_THAN_ZERO: "Markup campaign existing markup value zero",
                    MKR_PROMOTION_MARKUP_HOTEL_NOT_FOUND: "Cannot find any promotion markup for hotel",
                    MKR_PROMOTION_MARKUP_BUNDLE_NOT_FOUND: "Cannot find any promotion markup for bundle",
                    MKR_PROMOTION_MARKUP_FLIGHT_NOT_FOUND: "Cannot find any promotion markup for flight",
                    MKR_PROMOTION_CODE_NOT_FOUND: "Promotion code not found",
                    MKR_PROMOTION_CODE_NOT_MATCH_ANY_MARKUP_CAMPAIGN: "Promotion code not match with any markup campaign",
                    MKR_PROMOTION_HOTEL_REQUEST_CONDITIONS_INVALID: "Promotion markup hotel request conditions to check invalid",
                    MKR_PROMOTION_CHECK_CODE_MISSING_HOTEL_IDS: "Promotion markup hotel request missing hotel ids",
                    MKR_PROMOTION_APPLY_CODE_MISSING_RATEPLAN_IDS: "Promotion markup hotel request missing rateplan ids",
                    MKR_PROMOTION_NOT_APPLY_FOR_LIST_HOTEL_REQUEST: "Promotion code not apply for any hotel in request list",
                    MKR_PROMOTION_NOT_APPLY_FOR_LIST_RATE_REQUEST: "Promotion code not apply for any rate in request list",
                    COMBINE_RATE_CODE_DIFFERENCE_INTEREST_TYPE: "Loại lãi suất của mã lãi suất là chênh lệch, không thể tạo mã lãi suất mới",
                    COMBINE_RATE_CODE_INVALID_PARAMS_INPUT: "Đầu vào tham số không được rỗng hoặc trống",
                    COMBINE_RATE_CODE_NOT_FOUND_IN_LIST_IDS: "Không tìm thấy bất kỳ mã tỷ lệ nào trong danh sách",
                    COMBINE_RATE_CODE_CANNOT_GENERATE_NEW_CODE: "Không thể tạo mã mới",
                    COMBINE_RATE_CODE_SELL_COST_LESS_THAN_COST: "Giá bán không được nhỏ hơn giá vốn",
                    RATECODE_NOT_VALID: "Rate code không hợp lệ",
                    CANNOT_CHANGE_RATE: "Không thể thay đổi Rate code",
                    LTR_CATEGORY_VALIDATION_ERROR: "Rate code không thể không có 2 sản phẩm thuộc danh mục LTR",
                    RECOMMIT_HOTEL_BUNDLE_INVALID: 'Xuất bán chỉ áp dụng cho đơn hotel, bundle với trạng thái thất bại và trong thời gian giữ chỗ',
                    SURCHARGE_NOT_FOUD: "Phụ thu không tồn tại hoặc đã bị hủy. Không thể thực hiện được thao tác",
                    FLIGHT_BOOKING_INFO_NOT_FOUND: "Lỗi không tìm thấy Thông tin chuyến bay",
                    INVALID_COMMIT_FIXED_CHARGE_CONDITION: "Đơn hàng sai điều kiện đẩy fixcharge",
                    FIXEDCHARGE_COMMIT_FAIL: "Commit fixcharge thất bại",
                    UNEXPECTED_ERROR: "Có lỗi xảy ra",
                    GET_BOOKING_FAILED: "Lấy thông tin booking thất bại",
                    INVALID_URL_SLUG: 'Đường dẫn ảnh không được để trống',
                    TOUR_ITEM_NOT_FOUND: "Không tìm thấy tour này",
                    // Order
                    AMOUNT_NOT_VALID: '%s không hợp lệ',
                    FLIGHT_TRACKING_EXIST: "Đã có dữ liệu tracking",
                    LOYALTY_EMAIL_NOT_EXIST: "Email người nhận không có trên Loyalty",
                    LOYALTY_ORDER_EMAIL_NOT_EXIST: "Email chủ đơn hàng không có trên loyalty",
                    REFUND_AMOUNT_INVALID: "Số tiền refund không hợp lệ",
                    ORDER_ITEM_INVALID: "Không xác định",
                    inventoryDeliveryType: {
                        isRequired: "Vui lòng chọn phương thức xuất kho"
                    },
                    SYS_SURCHARGE_MISSING_USING_DATE: "Ngày sử dụng là bắt buộc",
                    SURCHARGE_ISSUE_STOCK_FAILED: "Thêm phụ thu không thành công",
                    SURCHARFE_OUT_OF_STOCK: "Phụ thu không hợp lệ",
                    SYS_INVALID_REQUEST: "Kiểm tra lại dữ liệu trong các trường bắt buộc",
                    SYS_NOT_FOUND_SURCHARGE_GI_INFO: "Không tìm thấy phụ thu",
                    SYS_NOT_FOUND_GR_INFO: "Không tìm thấy Goods recipts",
                    SYS_CREATE_SOME_GR_FAILED: "Không tạo được goods receipts",
                    SURCHARGE_BACK_STOCK_FAILED: "back stock không thành công",
                    SURCHARGE_BACKSTOCK_OUTDATE_FAILED: "Không thể xóa phụ thu đã quá hạn, vui lòng bỏ chọn backstock để tiếp tục",
                    SURCHARGE_INVALID_QTY: "Số lượng tồn không hợp lệ",
                    SYS_TOUR_HOLDING_FAILED: "Giữ chỗ thất bại",
                    CHECK_RATE_CODE_STOCK_INVALID_REQUEST: "Dữ liệu không hợp lệ",
                    CHECK_RATE_CODE_STOCK_NOT_FOUND: "Không tìm thấy dữ liệu tồn của mã giá này",
                    CHECK_RATE_CODE_STOCK_OUT_OF_STOCK: "Đã hết tồn kho",
                    USINGDATE_INVALID: "Ngày sử dụng không hợp lệ",
                    //Package rate
                    LAST_BOOKING_DATE_IS_EXPIRED: "Chỉ cập nhật được khi chưa kết thúc ngày mở bán của giai đoạn cuối cùng",
                    PACKAGE_RATE_NOT_DELETE: "Chỉ xóa được khi tới ngày mở bán của giai đoạn đầu tiên",
                    PACKAGE_RATE_CANNOT_COPY: "Không thể copy Package rate này",
                    PACKAGE_RATE_CANNOT_UPDATE: "Không thể cập nhật Package rate này",
                    BOOKABLE_PACKAGE_RATE_MAX_LENGTH_NAME: "Chỉ được tối đa 50 ký tự",
                    PACKAGE_RATE_CODE_EXISTS: "Mã gói đã tồn tại",
                    PACKAGE_RATE_BOOKING_TIME_OVERLAP: "Các giai đoạn thời gian bán không được trùng nhau",
                    PACKAGE_RATE_STAY_TIME_OVERLAP: "Các giai đoạn thời gian sử dụng không được trùng nhau",
                    PACKAGE_RATE_MAX_LENGTH_TITLE: "Tiêu đề tốt đa 100 kí tự",
                    PACKAGE_RATE_CANNOT_CREATE_PRODUCT: "Đã xảy ra lỗi khi tạo, vui lòng thử lại!",
                    PACKAGE_RATE_CONFIRM_TIME_CANNOT_COPY: "Đã xảy ra lỗi khi copy thời gian bán, vui lòng thử lại!",
                    PACKAGE_RATE_PRORUCT_EXPIRED: "Thời gian bán đã đã bắt đầu",
                    PACKAGE_RATE_PRORUCT_NOT_EXISTED: "Sản phẩm của package rate không tồn tại",
                    PACKAGE_RATE_NOT_CANNOT_ACTIVE: "Package rate này không thể hoạt động",
                    PACKAGE_RATE_NOT_FOUND: "Không tìm thấy Package rate này",
                    PACKAGE_RATE_CODE_NOT_EXISTS: "Code của Package rate không tồn tại",
                    PACKAGE_RATE_BOOKING_TIME_VALUE_MUST_GREATER_THAN_STAY_TIME: "Thời gian bán sản phẩm phải nhỏ hơn thời gian sử dụng sản phẩm",
                    PACKAGE_RATE_PRORUCT_MARKUP_VALUE_MUST_GREATER_THAN_ZERO: "Giá trị gói sản phẩm phải lớn hơn hoặc bằng 0",
                    VALUE_MUST_GREATER_THAN_ZERO: "Giá trị gói sản phẩm phải lớn hơn hoặc bằng 0",
                    RATE_CODE_PRODUCT_NOT_MATCH: "Sản phẩm trong mã giá không trùng khớp",
                    TICKET_OBJECTYPE_INVALID: "Số lượng (tối thiểu/tối đa) phải chia hết cho bội số",
                    ORDER_ITEM_INVALID: "Không xác định",
                    CATEGORY_VALIDATION_ERROR_LTR: "SPNCC không thể tồn tại 2 nhóm sản phầm lưu trú",
                    SUPPLIER_MATCH_SUPPLIER_PRODUCT_ACTIVE: "Không thể xoá NCC đã được gán với Sản phẩm NCC",
                    FLIGHT_TRACKING_INVALID_REQUEST: "Dữ liệu tracking không hợp lệ",
                    PACKAGE_RATE_MUST_UPSELL: "Package rate này phải upsell",
                    // Affiliate
                    INVALID_ORDER_ID: "Order Id cannot be null or empty",
                    AFF_SID_EMPTY: "Affiliate SId is empty",
                    ORDER_NOT_PAID: "Order was not paid",
                    ORDER_NOT_CONTAINS_VWS: "Order was not contains any item is vinwonder new",
                    ORDER_CHANNEL_INVALID: "Order not belong website vinwonder",
                    ORDER_AFFILIATE_SOURCE_INVALID: "Affiliate source invalid: {order.AffiliateSource}",
                    '00': "success",
                    '01': "conversion_id null",
                    '02': "conversion items null",
                    '03': "conversion not exits",
                    '04': "exceptions",
                    '05': "conversion exits not create order",
                    '06': "conversion not change status",
                    RATE_COMPARE_NOT_VALID: "Rate đã tồn tại ở cấu hình khác!",
                    CreateInventory: "Đã trùng kế hoạch bán, xin vui lòng kiểm tra lại",
                    UpdateInventory: "Đã trùng kế hoạch bán, xin vui lòng kiểm tra lại",
                    TAG_GROUP_NOT_FOUND: "Không tìm thấy sản phẩm vinwonder",
                    TAG_GROUP_CODE_EXISTED: "Mã sản phẩm vinwonder đã tồn tại",
                    TAG_GROUP_TRANSLATION_REQUIRED: "Phiên dịch không được để trống",
                    TAG_GROUP_LANGUAGE_DEFAULT_REQUIRED: "Tên sản phẩm mặc định không được để trống",
                    TAG_GROUP_TRANSLATION_DUPLICATED: "Trùng tên phiên dịch",
                    TAG_GROUP_SUPPLIER_DUPLICATED: "Trùng NCC",
                }
            }
        },
    paginate: {
      showLine: "Số dòng 1 trang",
      first: "Trang đầu",
      last: "Trang cuối",
      previous: "Trang trước",
      next: "Trang kế",
      of: "trong",
      items: "kết quả",
      jumpTo: "Đi tới trang",
      itemsPerPage: "kết quả/trang",
      page: "trang",
    },
    translate: {
      title: "Phiên dịch",
      language: "Ngôn ngữ",
      defaultLanguage: "Ngôn ngữ mặc định",
      languages: {
        vi: "Tiếng Việt",
        en: "Tiếng Anh",
        ko: "Tiếng Hàn",
        zh: "Tiếng Trung",
        ru: "Tiếng Nga",
        hi: "Tiếng Ấn",
        all: "Tất cả",
      },
      translatedLanguages: "Ngôn ngữ đã được dịch",
    },
    navigation: {
      option: "Option",
      condiment: "Condiment",
      flightTracking: "Chuyến bay",
      markupBundles: "Markup Bundle",
      packageRate: "Package Rate",
      createPackageRate: "Tạo mới Package Rate",
      updatePackageRate: "Cập nhật Package Rate",
      viewPackageRate: "Xem Package Rate",
      createMarkupBundle: "Tạo mới Markup",
      updateMarkupBundle: "Cập nhật Markup",
      receiptspayslip: "Tạo phiếu thu/chi",
      receiptsPayslipCreate: "Tạo phiếu thu/chi",
      cashflowFiltered: "Danh sách theo mã đơn hàng",
      transportation: "Vận chuyển",
      redirectlink: "Cấu hình Redirect URL",
      createRedirectLink: "Tạo mới Redirect URL",
      updateRedirectLink: "Cập nhật Redirect URL",
      filterdTicketSold: "Vé đã bán",
      ticketSold: "Vé đã bán",
      objectTypes: "Đối tượng",
      updateObjectTypes: "Cập nhật đối tượng",
      createObjectTypes: "Thêm đối tượng",
      "tour-properties": "Cơ sở",
      checkPromotion: "Kiểm tra Promotion code",
      amenities: "Tiện ích",
      createAmenity: "Tạo mới tiện ích",
      updateAmenity: "Cập nhật tiện ích",
      rates: "Rates",
      bookablePackageRates: "Bookable Package Rate",
      updateRates: "Cập nhật Rate",
      createRates: "Tạo mới Rate",
      airports: "Sân bay",
      createAirport: "Tạo sân bay",
      updateAirport: "Cập nhật sân bay",
      fareRules: "Điều kiện vé",
      createFareRule: "Tạo thêm điều kiện",
      updateFareRule: "Cập nhật điều kiện",
      baggages: "Hành lý",
      createBaggage: "Tạo thêm hành lý",
      updateBaggage: "Cập nhật hành lý",
      agents: "Đại lý",
      createAgents: "Tạo mới đại lý",
      updateAgents: "Cập nhật đại lý",
      home: "Trang chủ",
      dashboard: "Tổng quan",
      users: "Thành viên",
      userMembers: "Quản lý người dùng",
      createUsers: "Tạo thành viên",
      updateUsers: "Cập nhật thành viên",
      tours: "Sản phẩm",
      titleTour: "Sản phẩm",
      pointchangehistory: "Lịch sử biến đổi điểm hệ thống",
      warehousemanagement: "Quản lý Inventory",
      createWarehousemanagement: "Tạo mới phiếu nhập kho",
      updateWarehousemanagement: "Cập nhật phiếu nhập kho",
      createTours: "Tạo sản phẩm",
      updateTours: "Cập nhật sản phẩm",
      tourTickets: "Loại vé",
      createTourTickets: "Tạo loại vé",
      updateTourTickets: "Cập nhật loại vé",
      banners: "Ảnh Banner",
      createBanners: "Tạo banner",
      updateBanners: "Cập nhật banner",
      orders: "Đơn hàng",
      orderDetail: "Chi tiết đơn hàng",
      products: "Sản phẩm",
      createProducts: "Tạo sản phẩm",
      updateProducts: "Cập nhật sản phẩm",
      groups: "Chương trình",
      createGroups: "Tạo chương trình",
      updateGroups: "Cập nhật chương trình",
      checkVoucher: "Kiểm tra voucher",
      vouchers: "Voucher",
      voucherCodes: "Mã Voucher",
      createVouchers: "Tạo voucher",
      updateVouchers: "Cập nhật voucher",
      properties: "Cơ sở",
      importVouchers: "Nhập voucher",
      roles: "Vai trò",
      updateRoles: "Cập nhật vai trò",
      createRoles: "Tạo mới vai trò",
      createProperties: "Tạo mới cơ sở",
      updateProperties: "Cập nhật cơ sở",
      hotels: "Khách sạn",
      createHotels: "Tạo mới khách sạn",
      updateHotels: "Cập nhật khách sạn",
      golf: "Sân Golf",
      updateGolfCourse: "Cập nhật sân Golf",
      createGolfCourse: "Tạo mới sân Golf",
      homestays: "Homestay",
      createHomestays: "Tạo mới homestay",
      updateHomestays: "Cập nhật homestay",
      roomTypes: "Loại phòng",
      createRoomTypes: "Tạo mới loại phòng",
      updateRoomTypes: "Cập nhật loại phòng",
      locations: "Địa điểm",
      createLocations: "Tạo mới địa điểm",
      updateLocations: "Cập nhật địa điểm",
      customPrices: "Giá tùy chỉnh",
      createCustomPrices: "Tạo mới giá tùy chỉnh",
      updateCustomPrices: "Cập nhật giá tùy chỉnh",
      popularPlaces: "Địa điểm nổi bật",
      createPopularPlaces: "Tạo mới địa điểm nổi bật",
      updatePopularPlaces: "Cập nhật địa điểm nổi bật",
      contents: "Nội dung",
      websites: "Website",
      categories: "Chuyên mục",
      createCategories: "Tạo mới Chuyên mục",
      updateCategories: "Cập nhật Chuyên mục",
      pages: "Trang",
      createPages: "Tạo mới trang",
      updatePages: "Cập nhật trang",
      posts: "Bài viết Blog",
      createPosts: "Tạo mới bài viết",
      updatePosts: "Cập nhật bài viết",
      ratings: "Đánh giá",
      siteInfos: "Thông tin Site",
      createSiteInfos: "Tạo mới thông tin site",
      updateSiteInfos: "Cập nhật thông tin site",
      detailPosts: "Chi tiết đánh giá",
      priceMakeup: "Cấu hình giá",
      flights: "Vé máy bay",
      priceMakeupFlight: "Cấu hình giá vé máy bay",
      priceConfigFlight: "Cài đặt giá bán",
      reports: "Báo cáo",
      saleReports: "Báo cáo doanh thu",
      saleReportsByOrder: "Báo cáo doanh thu theo đơn hàng",
      saleReportsBySKU: "Báo cáo đơn hàng theo SKU",
      redemptionReports: "Tình hình sử dụng voucher",
      collaborator: "Báo cáo CTV",
      cashflow: "Báo cáo dòng tiền",
      orderDetailReportsBySku: "Báo cáo chi tiết sản phẩm cho SKU",
      orderDetailReportsByHotel: "Báo cáo chi tiết cho đơn hàng Hotel",
      reportBundle: "Báo cáo Bundle",
      btbOrder: "Báo cáo đơn hàng BTB",
      btbUseRoom: "Báo cáo sử dụng phòng BTB",
      indexWelcomeTitle: "Chào mừng đến với Vinpearl Travel",
      groupCategories: "Phân loại chương trình",
      updateGroupCategories: "Cập nhật loại chương trình",
      createGroupCategories: "Tạo mới loại chương trình",
      suppliers: "Nhà cung cấp",
      usagePlan: "Lịch sử dụng",
      supplierproducts: "Sản phẩm cung cấp",
      createSuppliers: "Tạo mới nhà cung cấp",
      updateSuppliers: "Cập nhật nhà cung cấp",
      usagePlanProducts: "Kế hoạch sử dụng mã giá",
      productUsageHistory: "Lịch sử dụng sản phẩm",
      usagePlanRateCodes: "Lịch sử dụng mã giá",
      createSupplierProduct: "Tạo mới sản phẩm nhà cung cấp",
      updateSupplierProduct: "Cập nhật sản phẩm nhà cung cấp",
      tickets: "Ticket",
      updateTickets: "Cập nhật ticket",
      ratecode: "Quản lý mã giá",
      createRateCode: "Tạo mới mã giá",
      updateRateCode: "Cập nhật mã giá",
      usagePlanRateCode: "Lịch sử dụng",
      customerServices: "Chăm sóc khách hàng",
      myTickets: "Trực ticket",
      ticketAssignConfigs: "Cài đặt lịch trực",
      updateTicketAssignConfigs: "Cập nhật cài đặt lịch trực",
      createTicketAssignConfigs: "Tạo mới cài đặt lịch trực",
      systems: "Hệ thống",
      exchangeRates: "Tỷ giá",
      emailTemplate: "Mẫu email CSKH",
      updateEmailTemplate: "Cập nhật mẫu email CSKH",
      createEmailTemplate: "Tạo mới mẫu email CSKH",
      vinWonders: "VinWonder",
      createVinWonder: "Tạo mới VinWonder",
      updateVinWonder: "Cập nhật VinWonder",
      vinWonderTickets: "VinWonder Ticket",
      createVinWonderTicket: "Tạo mới VinWonder Ticket",
      updateVinWonderTicket: "Cập nhật Ticket",
      vinWonderPrice: "Giá tùy chỉnh",
      createVinWonderPrice: "Tạo mới giá tùy chỉnh",
      updateVinWonderPrice: "Cập nhật giá tùy chỉnh",
      checkVinWonder: "Check mã VinWonder",
      surcharge: "Quản lý phụ thu",
      productFeed: "Product Feed",
      tagGroupDetails: "Thông tin nhóm thẻ",
      updateTagGroupDetails: "Cập nhật thông tin nhóm thẻ",
      createTagGroupDetails: "Tạo mới thông tin nhóm thẻ",
      linkSkuTagGroupDetails: "Link SKUs vào thông tin nhóm thẻ",
      productReindex: "Re-Index sản phẩm",
      promotions: "Promotions",
      promotionsManagerment: "Quản lý mã",
      campaigns: "Quản lý chiến dịch",
      createCampaign: "Tạo mới chiến dịch",
      updateCampaign: "Cập nhật chiến dịch",
      createGroupPromotions: "Tạo nhóm khuyến mãi",
      updateGroupPromotions: "Cập nhật nhóm khuyến mãi",
      autoFill: "Autofill code",
      createAutoFill: "Tạo mới autofill code",
      updateAutoFill: "Cập nhật autofill code",
      createSupplierCategory: "Tạo mới nhóm sản phẩm",
      updateSupplierCategory: "Cập nhật nhóm sản phẩm",
      createSupplierCategoryVW: "Tạo mới nhóm sản phẩm VW",
      updateSupplierCategoryVW: "Cập nhật nhóm sản phẩm VW",
      category: "Nhóm sản phẩm",
      categoryvw: "Nhóm sản phẩm VW",
      payAtHotel: "Cấu hình PayAtHotel",
      configPHS: "Quản lý PHS",
      flight: "Thông tin chuyến bay",
      recommendation: "Recommendation",
      app: "App",
      appui: "Cấu hình UI",
      whitelistIp: "Whitelist IP",
      appUIUpdate: "Cập nhật nội dung",
      appUICreate: "Tạo mới nội dung",
      rateCompare: "Rate Compare",
      homestayRates: "Rates",
      homestayRoomTypes: "Loại phòng",
      configSourceFlight: "Cài đặt nguồn vé",
      clearCache: "Clear cache",

      vinpearlGolf: "Vinpearl Golf",
      golfCourse: "Sân Golf",
      golfAddOnServices: "Dịch vụ mua thêm",
      golfAddOnServicesCategory: "Nhóm dịch vụ mua thêm",
      golfSpecialOffers: "Ưu đãi đặc biệt",
      golfOrder: "Đơn hàng",
      golfProductRevenueReport: "Báo cáo doanh thu sản phẩm Golf",
      golfPromotions: "Promotions",
      golfBookingAccount: "Quản lý tài khoản Booking",
      FnB: "FNB",
      menu: "Menu",
      menuItems: "Menu Items",
      fnbProduct: "Sản phẩm FNB",
      outlets: "Outlets",
    },
    placeHolderForm: {
      input: "Vui lòng nhập",
      select: "Vui lòng chọn",
      dropImage: "Kéo và thả hình ảnh ở đây",
      dropVideo: "Kéo và thả video ở đây",
      startDate: "Ngày bắt đầu",
      endDate: "Ngày kết thúc",
      selectDate: "Vui lòng chọn ngày",
      calculateUnit: "Đơn vị tính",
    },
    action: {
      back: "Quay về",
      redeem: "Sử dụng",
      changeRateCote: "Đổi mã giá",
      check: "Kiểm tra",
      info: "Thông tin",
      export: "Xuất file",
      import: "Nhập file",
      exportFileSample: "Tải mẫu",
      create: "Tạo mới",
      confirm: "Xác nhận",
      update: "Cập nhật",
      show: "Xem",
      remove: "Xoá",
      clone: "Sao chép",
      action: "Thao tác",
      exit: "Thoát",
      close: "Đóng",
      lock: "Khoá",
      unlock: "Mở khoá",
      refreshData: "Làm mới dữ liệu",
      autoResize: "Auto resize",
      syncMenuItems: "Đồng bộ menu items",
      destroy: "",
      backIndex: "Quay về trang chủ",
      statusHide: "Không hiển thị",
      statusShow: "Hiển thị",
      uploadImage: "Tải Hình ảnh",
      collapse: "Thu gọn",
      detail: "Chi tiết",
      noData: "Không có dữ liệu",
      cancel: "Hủy",
      edit: "Chỉnh sửa",
      add: "Thêm",
      addMulti: "Thêm nhiều",
      save: "Lưu",
      send: "Gửi",
      use: "Sử dụng",
      resendEmail: "Gửi lại email",
      exportVoucher: "Xuất file",
      approve: "Cho phép",
      unapprove: "Không cho phép",
      translate: "Phiên dịch",
      unlink: "Xóa liên kết",
      maximize: "Toàn màn hình",
      minimize: "Thoát toàn màn hình",
      loading: "Đang tải...",
      reset: "Đặt lại",
      done: "Xong",
      openInNewTab: "Mở trong tab mới",
      downloadable: "Có thể tải về",
      formatCode: "Định dạng code",
      vertical: "Hiển thị theo chiều dọc",
      horizontal: "Hiển thị theo chiều ngang",
      showReview: "Hiện xem trước",
      hideReview: "Ẩn xem trước",
      pageReview: "Xem trước toàn trang",
      newSurchange: "Thêm phụ thu",
      sort: "Sắp xếp danh sách",
      changeStatus: "Đổi trạng thái",
      lockItem: "Khóa",
      unlockItem: "Mở khóa",
      linkSkus: "Link SKUs vào",
      search: "Tìm kiếm",
      reindex: "Re-Index",
      deactive: "Huỷ mã",
      active: "Kích hoạt mã",
      sync: "Đồng bộ dữ liệu",
      syncMenuItems: "Đồng bộ menu items",
      updateStatus: "Cập nhật trạng thái",
      all: "Tất cả",
      select: "Lựa chọn",
      bundleViewCode: "Xem mã khuyến mãi",
      bundleDeactivated: "Ngừng kích hoạt",
      bundleActivated: "Kích hoạt",
      bundleEditCode: "Chỉnh sửa bundle",
      updateActiveByExcel: "Active/Deactive group",
      viewListCode: "Mã vé",
      changeRate: "Đổi sản phẩm",
      saveChangeRate: "Xác nhận",
      syncLanguage: "Không tồn tại ngôn ngữ",
      pushFixedCharge: "Đẩy FixCharge",
      usagePlan: "Lịch sử dụng",
      usageSchdule: "Kế hoạch sử dụng",
      clearCache: "Clear cache",
      retry: "Thử lại",
    },
    notification: {
      title: "Thông báo",
      cloneSuccess: "Sao chép dữ liệu thành công",
      building: "Tính năng đang được phát triển",
      notInternet: "Kết nối bị lỗi, máy chủ không phản hồi!",
      createSuccess: "Thêm dữ liệu thành công",
      updateSuccess: "Cập nhật dữ liệu thành công",
      removeSuccess: "Xoá dữ liệu thành công",
      checkSuccess: "Kiểm tra thành công",
      uploadSuccess: "Tải dữ liệu thành công",
      resendMailSuccess: "Gởi email thành công",
      changePasswordSuccess: "Đổi mật khẩu thành công",
      assigneeSuccess: "Yêu cầu đã được chuyển",
      cancelTicketSuccess: "Đã huỷ yêu cầu",
      sureRemove: "Bạn chắc chắn muốn xóa ?",
      sureDeActive: "Bạn muốn vô hiệu tài khoản ?",
      sureUse: "Bạn chắc chắn muốn sử dụng ?",
      sureLogout: "Bạn chắc chắn muốn thoát?",
      changePassword: "Bạn chắc chắn muốn đổi mật khẩu?",
      usedvouchersuccess: "Bạn đã sử dụng voucher thành công",
      resendmailsuccess: "Gửi email thành công",
      unsaveUpdate: "Những thay đổi chưa được lưu",
      confirmExit: "Bạn có chắc chắn muốn thoát?",
      confirmBack: "Bạn có chắc chắn muốn quay về?",
      downloadSuccess: "Tải về file thành công.",
      youCantAccessThisPage: "Bạn không thể vào trang này!",
      maxFileSize: "Kích thước file tối đa",
      tableConfigVisible: "Cài đặt hiển thị bảng",
      columnVisibilities: "Cột hiển thị",
      columnResizeLocked: "Khóa kích thước cột",
      acceptSort: "Bạn có thể kéo thả sắp xếp lại các mục trong danh sách",
      infoSort:
        "Nhấn vào nút sắp xếp danh sách để có thể điều chỉnh lại vị trí của các dòng",
      successCoupon: "Áp dụng mã khuyến mãi thành công",
      lockSuccess: "Khóa dữ liệu thành công",
      unLockSuccess: "Mở khóa dữ liệu thành công",
      changeRateCodeSuccess: "Đổi mã giá thành công",
      pushFixedChargeSuccess: "Đẩy FixCharge thành công",
      cantSelectTwoRateCode: "Không thể chọn 2 mã giá", 
      repushAffiliateSuccess: "Cập nhật thông tin Affiliate thành công",
      clearCacheSuccess: "Xóa cache thành công",
      autoTranslateSuccess: "Auto translate thành công",
      confirmSyncData: "Bạn có chắc chắn muốn đồng bộ dữ liệu menu cho outlet này?",
      confirmSyncDataCondiment: "Bạn có chắc chắn muốn đồng bộ dữ liệu condiment cho property này?",
      confirmSyncDataOption: "Bạn có chắc chắn muốn đồng bộ dữ liệu option cho property này?",
      confirmSyncProductFnb: "Bạn có chắc chắn muốn đồng bộ dữ liệu?",
      syncSuccess: "Đồng bộ dữ liệu thành công",
    },
    permission: {
      redeem: "Redeem vé",
      changeRateCode: "Thay đổi mã giá",
      view: "Xem",
      viewList: "Xem danh sách",
      create: "Thêm",
      update: "Sửa",
      delete: "Xóa",
      approve: "Cho phép",
      resendEmail: "Gửi lại email",
      exportVoucher: "Xuất file voucher",
      saleOrder: "Xuất bán",
      useVoucher: "Sử dụng",
      updatePrice: "Sửa giá",
      export: "Xuất file excel",
      check: "Kiểm tra",
      viewDetail: "Xem chi tiết",
      updateItemStatus: "Cập nhật trạng thái item",
      updateaccountantstatus: "Cập nhật trạng thái đơn hàng kế toán",
      lockItem: "Khóa item",
      mapsku: "Gắn SKU",
      reindex: "Re-Index",
      deactive: "Huỷ mã khuyến mại",
      sync: "Đồng bộ dữ liệu",
      updateStatus: "Cập nhật trạng thái",
      bundleView: "Xem nhóm khuyến mãi",
      bundleCreate: "Tạo nhóm khuyến mãi",
      bundleUpdate: "Cập nhật nhóm khuyến mãi",
      recommit: "Xuất lại vé",
      updateActiveByExcel: "Cập nhật trạng thái theo Excel",
      exportExcludeUserInfo: "Xuất file excel (Không thông tin khách hàng)",
      receiptsPayslipCreate: "Tạo phiếu thu/chi",
      confirm: "Xác nhận",
      cancel: "Hủy",
      topup: "Topup",
      flightTracking: "Chuyến bay",
      flightTracking: {
        view: "Xem chuyến bay",
        create: "Tạo chuyến bay",
        update: "Cập nhật chuyến bay",
        delete: "Xoá chuyến bay",
      },
      refund: "Hoàn điểm",
    },
    item: {
      app: {
        ipAddress: "IP Address",
        name: "Name",
        url: "Url",
        properties: "Properties",
        backgroundImage: "Ảnh Background",
        backgroundName: "Tên ảnh Background",
        screen: "Màn hình",
        status: "Trạng thái",
        order: "Thứ tự",
        translations: "Phiên dịch",
        action: "Thao tác ",
        delete: "Delete",
        isDisplay: "Hiển thị",
        isUnDisplay: "Không hiển thị",
        welcome: "Màn hình Welcome",
        home: "Trang chủ",
        title: "Tiêu đề",
        descriptions: "Mô tả",
        screenType: "Loại màn hình",
        logoImageNameUpload: "Tải Logo",
        subTitleLogoImageNameUpload: "(Upload logo dung lượng dưới 5MB)",
        backgroundImageNameUpload: "Tải Background",
        subTitleBackgroundImageNameUpload:
          "(Upload ảnh có tỉ lệ 375 x 812 và dung lượng dưới 5MB)",
        uploadFile: "Tải hình ảnh",
        uploading: "Đang tải lên",
        tourTypeId: "Đối tượng",
        topic_home: "Du lịch theo chủ để - Trang chủ app",
        whitelistIpAddress: "IP Address",
        whitelistIpName: "Name",
        whitelistIpUrl: "Url",
        whitelistIpProperties: "Lựa chọn properties",
        whitelistIpErrors: {
          emptyIpAddress: "IP address không được để trống",
          emptyName: "Name không được để trống",
          emptyUrl: "URL không được để trống",
          emptyProp: "Xin hãy chọn Property cho IP",
        },
      },
      receiptsPayslip: {
        title: "Tạo phiếu thu/chi",
      },
      login: {
        email: "Email",
        password: "Mật khẩu",
        login: "Đăng nhập",
      },
      markupBundle: {
        active: "Hoạt động",
        deactive: "Không hoạt động",
        title: "Markup bundle",
        titleHotel: "Markup hotel",
        name: "Tên chiến dịch",
        campaignName: "Tên chiến dịch",
        countRatePlan: "Nhóm rate",
        stayDateFrom: "",
        stayDate: "StayDate",
        bookDates: "BookDate",
        ratePlanConfigs: "",
        productType: "Kiểu sản phẩm",
        markupType: "Kiểu markup",
        markupValue: "Markup Hotel",
        markupFlightValue: "Markup Flight",
        createdDate: "Ngày tạo",
        isActived: "Trạng thái",
        typeOfMultipleRoom: "Kiểu tính giá trị markup",
        action: "Thao tác",
        productTypeLang: {
          1: "Hotel",
          2: "Bundle",
        },
        markupTypeLang: {
          0: "Tiền mặt",
          1: "Phần trăm",
        },
        placeHolderForm: {
          markupValue: "Nhập giá trị",
        },
        bookDateFrom: "Từ ngày",
        bookDateTo: "Đến ngày",
        bundle: "Bundle",
        hotel: "Hotel",
      },
      amenity: {
        title: "Tiện ích",
        code: "Code",
        name: "Tên",
        description: "Mô tả",
        isActive: "Hoạt động",
        refId: "REF ID",
        thumbImage: "Hình",
        active: "Hiệu lực",
        deactive: "Khóa",
        translations: "Phiên dịch",
        action: "Thao tác",
      },
      // warehousemanagement: {
      //     title: 'Quản lý Inventory',
      // },
      pointchangehistory: {
        title: "Lịch sử biến đổi điểm hệ thống",
      },
      warehousemanagement: {
        title: "Quản lý Inventory",
      },
      group: {
        tag: "Tag",
        discount: "Khuyến mãi",
        numberOfBookingPeriod: "Hạn khách phải đặt trước",
        bookingPeriod: "Hạn cuối cùng phải đặt",
        title: "Chương trình",
        name: "Tên chương trình",
        groupCode: "Mã chương trình",
        times: "Thời gian",
        hours: "Giờ",
        minutes: "Phút",
        startDate: "Ngày bắt đầu hiệu lực mã voucher",
        saleStartDate: "Ngày bắt đầu bán chương trình",
        endDate: "Ngày kết thúc hiệu lực mã voucher",
        saleEndDate: "Ngày kết thúc bán chương trình",
        stayStartDate: "Thời gian bắt đầu lưu trú ",
        stayEndDate: "Thời gian kết thúc lưu trú ",
        property: "Cơ sở",
        properties: "Cơ sở",
        product: "Loại sản phẩm",
        productIds: "Loại sản phẩm",
        remainVoucher: "Tổng voucher",
        remainVouchers: "Tổng voucher",
        originalPrice: "Giá",
        price: "Giá bán",
        salePrice: "Giá giảm",
        available: "Trạng thái",
        isAvailable: "Hiệu lực",
        isUnAvailable: "Không hiệu lực",
        importdate: "Ngày tạo chương trình",
        highlight: "Điểm nổi bật",
        conditionOfUse: "Điều khoản sử dụng",
        description: "Mô tả",
        images: "Hình ảnh (Tối đa 5 tấm)",
        action: "Thao tác",
        status: "Trạng thái",
        voucherType: "Loại",
        discountValue: "Giảm",
        limitNumberOfTimes: "Số lần sử dụng",
        limitNumberOfSalesPerUser: "Giới hạn số lượng mua",
        minOrderValue: "Đơn hàng tối thiểu",
        maxOrderValue: "Đơn hàng tối đa",
        maxDiscountValue: "Giá giảm tối đa",
        fullname: "Tên người mua",
        createvouchernumber: "Số lượng",
        groupcode: "Mã chương trình",
        phone: "Số điện thoại",
        note: "Ghi chú",
        email: "Email",
        createvoucher: "Tạo voucher",
        accepttitle: "Xin hãy kiểm tra lại thông tin voucher",
        acceptcheck: "* Tôi xác nhận đã kiểm tra thông tin voucher",
        gift: "Tặng",
        money: "Tiền",
        percent: "%",
        clearfilter: "Xoá hiển thị",
        optionfilter: "Tuỳ chọn hiển thị",
        exportsale: {
          title: "Xuất bán",
          group: "Chương trình",
          filterCustomer: "Tìm khách hàng",
          customer: "Khách hàng",
          address: "Địa chỉ",
          isCreateCustomer: "Tạo mới",
          totalPrice: "Tổng tiền",
        },
        showInfo: {
          info: "1. Thông tin chung",
          available: "2. Hiệu lực",
          condition: "3. Điều kiện voucher",
          introduce: "4. Giới thiệu voucher",
          installment: "Trả góp",
        },
        installmentFee: "Phí trả góp",
        installmentFee_enum: {
          UN_KNOW: "Vui lòng chọn",
          CUS: "Khách trả phí",
          VIN: "Vinpearl trả phí",
        },
        installmentLimit: "Thời hạn trả góp",
        installmentLimit_enum: {
          UN_KNOW: "Vui lòng chọn",
          SIX_MONTH: "6 tháng",
          TWELVE_MONTH: "12 tháng",
          SIX_TWELVE_MONTH: "6 tháng 12 tháng",
        },
        creditPoint: "Credit Point",
        quantity: "Số lượng",
        isSaleToWeb: "Hiển thị trên website",
        acceptInfo: "Vui lòng xác nhận thông tin",
        operationManuals: "Hướng dẫn vận hành",
        isSpecial: "Voucher nổi bật",
        shortDescription: "Mô tả ngắn",
        order: "Trọng số",
        thumbImage: "Ảnh đại diện",
        cantDeleteGroupStarted: "Không thể xóa chương trình đã bắt đầu bán.",
        categories: "Loại chương trình",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        prices: "Giá bán",
        currencies: {
          VND: "Việt Nam Đồng",
          USD: "Đô La Mỹ",
          KRW: "Won Hàn Quốc",
        },
        priceLocales: {
          VND: "Giá thị trường Việt Nam",
          USD: "Giá thị trường Mỹ",
          KRW: "Giá thị trường Hàn Quốc",
        },
        groupPricesMinimum: "Phải có ít nhất một loại giá",
        urlSlug: "Đường dẫn website",
      },
      bundleReport: {
        orderCode: "Mã đơn hàng",
        orderId: "Mã giao dịch",
        paymentType: "Hình thức thanh toán",
        paymentStatus: "Trạng thái thanh toán",
        orderStatus: "Trạng thái đơn hàng",
        saleChannel: "Kênh bán",
        channel: "Nguồn",
        orderItemType: "Cấu phần",
        createdDate: "Ngày tạo",
        fullname: "Họ và tên khách đại diện",
        email: "Thư điện tử",
        phoneNumber: "Số điện thoại",
        fullnameCustomer: "Họ và tên khách mua",
        emailCustomer: "Thư điện tử khách mua",
        phoneNumberCustomer: "Số điện thoại khách mua",
        memberShipCode: "Hạng hội viên",
        couponCode: "Mã giảm giá",
        couponValue: "Số tiền khuyến mại",
        subTotal: "Giá trị đơn hàng gốc",
        surcharge: "Tổng tiền phụ thu",
        surchargeDetail: "Chi tiết phụ thu",
        totalAmount: "Thành tiền",
        note: "Lưu ý",
        startPoint: "Điểm khởi hành",
        endPoint: "Điểm đến",
        airlineCode: "Hãng bay",
        pnr: "Mã PNR",
        checkInDate: "Ngày CI",
        checkOutDate: "Ngày CO",
        hotelName: "Khách sạn",
        roomType: "Loại phòng",
        quickTaskStatus: "QuickTask",
        ratePlanName: "Mã giá",
        priceRoom: "Giá vốn phòng",
        markUpPriceRoom: "Mark up phòng",
        ticketPrice: "Giá vốn vé",
        totalMarkUpTicket: "Lãi vé",
        salePrice: "Giá bán",
      },
      user: {
        title: "Thành viên",
        roleId: "Vai trò",
        status: "Trạng thái",
        active: "Hiệu lực",
        deActive: "Khóa",
        deactiveUser: "Khoá thành viên",
        deactivated: "Trạng thái",
        changePassword: "Đổi mật khẩu",
        fullname: "Họ và tên",
        phoneNumber: "Số điện thoại",
        email: "Email đăng nhập",
        firstname: "Tên",
        lastname: "Họ",
        password: "Mật khẩu",
        oldPassword: "Mật khẩu cũ",
        newPassword: "Mật khẩu mới",
        confirmPassword: "Xác nhận mật khẩu",
        action: "Thao tác",
        editUser: "Thay đổi thông tin người dùng",
        username: "Tên tài khoản",
        propertyIds: "Cơ sở",
        properties: "Cơ sở",
        avatar: "Hình đại diện",
        roleName: "Vai trò",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        vgid: "VinGroup ID",
        deviceId: "Lastest Device ID",
        mfaEnabled: "MFA Status",
        forceMfa: "Force MFA",
        forceMfaOn: "Bật",
        forceMfaOff: "Tắt",
        accountSecurity: "Bảo mật tài khoản",
        newLabel: "MỚI",
        mfaStatusDescription: "Trạng thái xác thực đa yếu tố do người dùng tự cấu hình",
        forceMfaDescription: "Bắt buộc người dùng cấu hình/xác thực MFA ở lần đăng nhập kế tiếp",
      },
      redirectLink: {
        title: "Redirect URL",
        fromLink: "Link",
        toLink: "Redirect to link",
        isActive: "Trạng thái",
        active: "Hiệu lực",
        deactive: "Khóa",
        createdDate: "Ngày tạo",
        action: "Thao tác",
      },
      configPHS: {
        hotel: "Hotel",
        bundle: "Bundle",
        title: "Cấu hình placeholder session",
        isActive: "Trạng thái",
        sessionLiveTime: "Thời gian PHS",
        paymentTime: "Thời gian payment",
        changeStatusTime: "Chuyển trạng thái",
        onePayPaymentTime: "Thời gian thanh toán Onepay",
        countOfReset: "Số lần chọn vé",
        countUnit: "Lần",
        edit: "Chỉnh sửa",
        save: "Lưu",
        cancel: "Hủy bỏ",
        turnOff: "Tắt",
        turnOn: "Bật",
        timeUnit: "Phút",
        warningEdit: "Không được để trống mục nào",
      },
      pointchangehistory: {
        title: "Dữ liệu",
        creditPoint: "Điểm",
        createdDate: "Thời gian",
        act: "Hành động",
        fromAccount: "Từ tài khoản",
        toAccount: "Cho tài khoản",
        createdBy: "Người tạo",
        orderCode: "Mã đơn hàng",
        activityCode: "ActivityCode",
        updatedDate: "LastUpdate",
        updatedBy: "Người update",
        status: "Trạng thái",
        action: "Thao tác",
        actionStatus: {
          1: "Chuyển tiền",
          2: "Hoàn tiền",
        },
        actionColor: {
          1: "green",
          2: "blue",
        },
        statusList: {
          1: "Đợi xác nhận",
          2: "Xác nhận",
          3: "Hủy",
          4: "Đang xử lý",
        },
        statusColor: {
          1: "orange",
          2: "green",
          3: "red",
          4: "blue",
        },
        statusCode: {
          code: {
            confirm: "Bạn có chắc muốn xác nhận %s này",
            CONFIRM_SUCCESS: "Xác nhận dữ liệu thành công",
            cancel: "Bạn có chắc muốn hủy %s này",
            CANCEL_SUCCESS: "Hùy dữ liệu thành công",
            SYS_CANCEL_REFUND_INVALID_STATUS:
              "Tất cả các mục trạng thái trong cùng một mã hoạt động phải chờ xác nhận",
            SYS_CANCEL_REFUND_NOT_FOUND_ACTIVITY_CODE:
              "Không tìm thấy mã hoạt động",
            SYS_CONFIRM_REFUND_INVALID_STATUS:
              "Tất cả các mục trạng thái trong cùng một mã hoạt động phải chờ xác nhận",
            SYS_CONFIRM_REFUND_MISSING_ITEM_ACTION_REFUND:
              "Mã hoạt động không tìm thấy mục có hành động được hoàn lại tiền",
            SYS_EMAIL_NOT_FOUND:
              "Không thể lấy thông tin người dùng qua email hoặc số lượng userInfo không khớp với số lượng email yêu cầu",
            SYS_EMAIL_TOPUP_NOT_FOUND:
              "Người dùng nạp tiền không tìm thấy hoặc không tồn tại crmId: {returnItem.ToAccount}",
            SYS_CONFIRM_REFUND_NOT_FOUND_ACTIVITY_CODE:
              "Không tìm thấy mã hoạt động",
            REFUND_REQUEST_VGID_CANNOT_BE_NULL_OR_EMPTY:
              "VgId không được rỗng hoặc trống",
            REFUND_REQUEST_ORDER_AMOUNT_CANNOT_MUST_BE_LARGER_THAN_ZERO:
              "Số tiền đặt hàng phải lớn hơn 0",
            REFUND_REQUEST_FAILED: "Điểm nạp không thành công",
            SPEND_POINT_FAIL: "Spend loyalty point failed",
            UNDEFINED_ERROR: "Lỗi không xác định",
            SYS_REFUND_ITEM_VPT_FAILED: "Hoàn điểm không thành công",
            inventoryDeliveryType: {
              isRequired: "Vui lòng chọn phương thức xuất kho",
            },
            RATE_CODE_PRODUCT_NOT_MATCH:
              "Sản phẩm trong mã giá không trùng khớp",
          },
        },
      },
      warehousemanagement: {
        title: "Phiếu nhập kho",
        goodReceiptCode: "Mã phiếu nhập",
        materialCode: "Mã sản phẩm",
        materialName: "Tên sản phẩm",
        supplierCode: "Mã nhà cung cấp",
        supplierName: "Nhà cung cấp",
        rangeDate: "Khoảng thời gian sử dụng",
        createDate: "Ngày khởi tạo",
        creator: "Tên người nhập",
        quantity: "Tổng số lượng",
        addMultiQuantity: "Thêm nhiều số lượng",
        usagePlan: "Kế hoạch sử dụng",
        receiptsPayslipCreateDate: "Thời gian tạo phiếu",
        createdByName: "Người tạo phiếu",
        action: "Thao tác",
        heading: "Phiếu nhập kho sản phẩm nhà cung cấp",
        errorCode: {
          UNDEFINED_ERROR: "Lỗi không xác định",
          TS_SUPPLIER_PRODUCT_NOT_FOUND:
            "Không tìm thấy sản phẩm của nhà cung cấp",
          VALIDATE_EMPTY_DATE: "Vui lòng nhập khoảng thời gian sử dụng",
          INVALID_GOOD_RECEIPT_CODE: "Đã có lỗi xảy ra khi lấy mã phiếu nhập",
          WH_INVALID_REQUEST: "Một hoặc nhiều thông tin yêu cầu đang để trống",
          WH_INVALID_QTY:
            "Tổng số lượng trong kế hoạch sử dụng không khớp với số lượng",
          WH_INVALID_PLAN_SALE_DATE:
            "Ngày sử dụng gói không được nhỏ hơn Ngày bắt đầu hoặc lớn hơn Ngày kết thúc",
          WH_INVALID_PLAN_SALE_DATE_DUPLICATED:
            "Ngày sử dụng kế hoạch bị trùng lặp",
          WH_GR_DUPLICATED_CODE: "Đã xảy ra lỗi, mã biên nhận tốt bị trùng lặp",
          WH_GR_NOT_FOUND: "Không tìm thấy sản phẩm của nhà cung cấp",
          WH_GR_UPDATE_MISSING_CODE:
            "Mã phiếu nhập là bắt buộc trong quy trình chỉnh sửa",
          WH_GR_CODE_INVALID_FORMAT: "Mã phiếu nhập không đúng định dạng",
          WH_GR_MISSING_MATERIAL_CODE: "Material code is required",
          WH_GR_MISSING_MATERIAL_NAME: "Material name is required",
          WH_GR_MISSING_SUPPLIER_ID: "Supplier Id is required",
          WH_GR_USE_DATE_FROM_IN_PAST:
            "Use date from invalid, cannot in the past",
          WH_GR_USE_DATE_TO_IN_PAST: "Use date to invalid, cannot in the past",
          WH_GR_USEDATEFROM_LARGER_THAN_USEDATETO:
            "Use date from cannot larger than user date to",
          WH_GR_TOTAL_QTY_MUST_LARGER_THAN_ZERO:
            "Quantity invalid, must be larger than zero",
          WH_GR_CANNOT_DELETE_GR_USED:
            "Sản phẩm đã được sử dụng, không thể xóa",
          WH_PRODUCT_ITEM_IN_TEMPORARY:
            "Mặt hàng sản phẩm đang ở trong kho tạm thời",
        },
        successCode: {
          UPDATE_SUCCESS: "Cập nhật thành công",
          CREATE_SUCCESS: "Tạo mới thành công",
          DELETE_SUCCESS: "Xóa dữ liệu thành công",
        },
      },
      tour: {
        titleContent: "Tiêu đề",
        content: "Nội dung",
        totalSoldQuantity: "Tổng số lượng đã bán",
        soldQuantity: "Số lượng đã bán",
        title: "Sản phẩm",
        bookingDate: "Ngày khởi hành",
        totalPrice: "Tổng giá",
        outStock: "Hết vé",
        adultTicket: "Số lượng người lớn",
        childTicket: "Số lượng trẻ em",
        productTypes: "Loại sản phẩm",
        operationManuals: "Hướng dẫn vận hành",
        propertyName: "Cơ sở lưu trú",
        saleDate: "Ngày bán",
        stayDate: "Ngày lưu trú",
        saleStartDate: "Ngày mở bán",
        saleEndDate: "Ngày ngừng bán",
        stayStartDate: "Ngày bắt đầu lưu trú",
        stayEndDate: "Ngày kết thúc lưu trú",
        effectiveDate: "Ngày hiệu lực",
        effectiveStartDate: "Ngày bắt đầu hiệu lực",
        effectiveEndDate: "Ngày kết thúc hiệu lực",
        voucherBookingPeriod: "Hạn cuối đặt dịch vụ",
        voucherBookingPeriodPlaceHolder: "Chọn hạn cuối đặt dịch vụ",
        cutOffDate: "Số ngày phải đặt trước",
        createTicket: "Tạo ticket",
        updateTicket: "Cập nhật",
        ticketName: "Tên",
        uploadFile: "Tải hình ảnh",
        uploadFileVideo: "Tải hình ảnh/video",
        uploading: "Đang tải lên",
        imageSlug: "Đường dẫn ảnh",
        tourTitle: "Tiêu đề",
        tourCode: "Mã sản phẩm",
        tourName: "Tên sản phẩm",
        useObjectHeader: "Lựa chọn hạng thẻ",
        images: "Hình ảnh",
        thumbImage: "Ảnh đại diện",
        departure: "Điểm khởi hành",
        destination: "Điểm đến",
        groupSize: "Size đoàn",
        order: "Trọng số",
        countryId: "Địa điểm",
        stateOrProvinceId: "Mã vùng",
        duration: "Thời gian",
        description: "Mô tả",
        service: "Dịch vụ",
        cancelCondition: "Điều kiện huỷ",
        cancellationPolicy: "Điều kiện hoàn hủy",
        departureDateItem: "Ngày khởi hành",
        productType: "Loại tour",
        from: "Ngày đi",
        to: "Ngày về",
        seat: "Số chỗ ngồi",
        originalPrice: "Giá",
        salePrice: "Giá khuyến mãi",
        priceTypeHeader: "Loại giá",
        highlight: "Điểm nổi bật",
        itinerary: "Lịch trình",
        serviceIncluded: "Dịch vụ bao gồm",
        serviceExcluded: "Dịch vụ không bao gồm",
        note: "Lưu ý",
        noted: "Ghi chú",
        checklist: "Checklist khởi hành",
        hotel: "Khách sạn",
        airline: "Nhà cung cấp",
        days: "Số ngày",
        day: "Ngày",
        nights: "Số đêm",
        night: "Đêm",
        isSpecial: "Sản phẩm nổi bật",
        adultOriginalPrice: "Giá vé mặc định",
        adultSalePrice: "Giá vé người lớn khuyến mãi",
        childOriginalPrice: "Giá vé trẻ em",
        childSalePrice: "Giá vé trẻ em khuyến mãi",
        action: "Thao tác",
        lengthOfTour: "Độ dài kỳ nghỉ",
        enumLengthOfTour: "days ngày nights đêm",
        active: "Kích hoạt",
        deactive: "Ngưng kích hoạt",
        priceType: {
          ADULT: "Người lớn",
          OLDSTER: "Người cao tuổi trên 65",
          CHILD: "Trẻ em từ 4 - 11 tuổi",
          NEWBORN: "Trẻ em dưới 4 tuổi",
          ANIMAL: "Động vật",
        },
        limitNumberOfSale: "Giới hạn số lượng mua",
        step: "Chu kỳ (ngày)",
        errorCode: {
          2: "Ngày khởi hành không được nhỏ hơn ngày khởi hành của hành trình đã tồn tại",
          TS_DEPARTURE_DATE_EXIST: "Ngày khởi hành đã tồn tại",
          UNDEFINED_ERROR: "Lỗi không xác định. Vui lòng thử lại!",
          TS_TOUR_NOT_FOUND: "Không tìm thấy tour",
          // TS_INVALID_MAXDATE: 'Ngày khởi hành được chọn không được lớn hơn ngày khởi hành sau cùng của tour',
          TS_INVALID_MAXDATE: "Ngày khởi hành đã tồn tại",
          TS_TOUR_TYPE_IN_USED:
            "Lỗi: Không thể xóa, đối tượng sử dụng đang được sử dụng bởi tour khác",
        },
        generalInfo: "Thông tin chung",
        tripItinerary: "Lịch trình",
        tripItineraryContent: "Nội dung lịch trình",
        tourInfo: "Thông tin Tour",
        vinwondersInfo: "Thông tin VinWonders",
        productInfo: "Sản phẩm",
        sellPlan: "Kế hoạch bán",
        tourTickets: "Vé và biến đổi giá",
        defaultPrice: "Giá mặc định",
        departureDate: "Ngày khởi hành",
        departureDates: "Các ngày khởi hành",
        destinationDate: "Ngày kết thúc",
        tourOperationType: "Loại sản phẩm",
        channel: "Kênh bán",
        showTicketInfo: {
          title: "Lựa chọn thông tin trong hiển thị vé QR",
          note: "Lưu ý: mặc định hiển thị Mã Booking, Ngày sử dụng & Loại vé",
        },
        inbound: "Nội địa",
        outbound: "Quốc tế",
        tourTypes: "Đối tượng sử dụng",
        tagSKUVW: "Tag SKU VWBK",
        tag: "Tag",
        selectTourTypes: "Chọn dòng các đối tượng sử dụng",
        selectTagSKUVW: "Chọn dòng các tag SKU VWBK",
        tourTypeName: "Tên đối tượng sử dụng",
        tagSKUVWName: "Tên tag SKU VWBK",
        isHotTour: "Sản phẩm hot",
        attribute: "Thuộc tính",
        isWebsitePublished: "Hiển thị trên website",
        isWebsiteNotPublished: "Chưa lên website",
        isCrossSell: "Hiển thị bán CrossSell",
        publishDateTime: "Ngày đưa lên website",
        urlSlug: "Đường dẫn website",
        specialImage: "Ảnh nổi bật",
        slideShowImages: "Ảnh/video trình chiếu",
        checklistContent: "Nội dung checklist",
        checkListEmptyTitle: "Chưa có tiêu đề",
        isEnabled: "Hiệu lực",
        isEnabledTitle: "Trạng thái",
        isDisabled: "Tắt",
        currency: "Đơn vị tiền tệ",
        shortDescription: "Mô tả ngắn",
        months: "Tháng",
        vehicle: "Nhà cung cấp phương tiện",
        accommodation: "Nhà cung cấp lưu trú",
        meal: "Nhà cung cấp ăn uống",
        activity: "Nhà cung cấp hoạt động",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        productTypeTrans: {
          flightAndHotel: "Vé máy bay + KS Vinpearl",
          highSpeedShipHotel: "Tàu cao tốc + KS Vinpearl",
          vinpearlHotel: "Gói phòng Vinpearl",
          tourAndExperience: "Tour & Trải nghiệm",
          airportPickup: "Đón tiễn sân bay",
          installmentVIN: "Trả góp 0%",
        },
        bookingPeriod: "Hạn cuối đặt dịch vụ Tour",
        bookingPeriodVoucher: "Hạn cuối đặt dịch vụ Voucher",
        ticketObjectType: "Chọn đối tượng",
        ticketType: "Loại vé",
        type: "Kiểu sản phẩm",
        types: {
          voucher: "Voucher",
          tour: "Tour",
          vinwonder: "Vinwonder",
        },
        memberShipTypes: "Hạng thẻ",
        partialyCashBack: {
          lblCashBack: "Hoàn bằng tiền mặt",
          lblPointBack: "Hoàn bằng điểm",
          lblTypeName: "Tên loại hoàn",
          lblConfig: "Cấu hình hoàn điểm",
          lblBackValue: "Giá trị hoàn",
          lblRemaining: "Còn lại",
          lblLoyaltyCode: "Mã tỷ lệ loyalty",
          lblPoints: "Số điểm:",
          lblBackToOwner: "Hoàn cho chủ đơn hàng",
          lblBackToOther: "Hoàn cho người khác",
          lblSentPointToEmail: "Chuyển điếm đến email",
          lblRemain: "Còn lại",
        },
        selectSupplier: "Lựa chọn nhà cung cấp",
        supplierRequired: "Nhà cung cấp",
      },
      objectType: {
        name: "Tên đối tượng",
        description: "Mô tả",
        code: "Mã đối tượng",
        action: "Thao tác",
        types: "Kiểu sản phẩm",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        createdDate: "Ngày tạo",
        isAvailable: "Trạng thái",
        title: "Đối tượng",
        rateCodeType: "Kiểu tạo mã giá",
      },
      ticketSold: {
        serialNumber: "Mã kiểm tra",
        skuCode: "Mã sản phẩm",
        ticketCode: "Mã vé",
        productType: "Kiểu sản phẩm",
        stayStartDate: "Ngày check-in",
        stayEndDate: "Ngày check-out",
        status: "Trạng thái",
        action: "Thao tác",
        tourCode: "Mã chương trình",
        tourName: "Tên sản phẩm",
        objectType: "Đối tượng",
        rateCode: "Mã giá",
        saleDate: "Ngày tạo",
        operaBooking: "BookingITI",
        verifyCode: "Mã xác thực",
        propertyName: "Nhà cung cấp",
      },
      promotions: {
        uploadDocument: "Tệp tin code",
        titleImportExcel: "Đổi trạng thái qua file Excel",
        promotionInfo: "Thông tin Promotion",
        updateAt: "Thời gian đổi trạng thái",
        textSearch: "Từ khoá tìm kiếm",
        campaign: "Chiến dịch",
        campaignCode: "Mã chiến dịch",
        campaignName: "Tên chiến dịch",
        bundle: "Bundle",
        bundleName: "Chiến dịch con",
        bundleCode: "Mã bundle",
        promotionCode: "Mã khuyến mại",
        isActive: "Hoạt động",
        isUsed: "Đã sử dụng",
        maxCount: "Số lượng",
        usedCount: "Số lượng đã dùng",
        channel: "Kênh",
        active: "Hoạt động",
        deactive: "Ngừng hoạt động",
        titleDeActive: "Huỷ mã khuyến mại",
        titleActive: "Kích hoạt khuyến mại",
        note: "Ghi chú",
        action: "Thao tác",
        promotionHistorys: "Lịch sử dùng",
        unlimited: "Không giới hạn",
        orderCode: "Mã đơn hàng",
        usedTime: "Thời gian sử dụng",
        notUse: "Chưa sử dụng",
        viewMore: "Xem lịch sử dùng",
        exportFileExcel: "Xuất file",
        title: "Promotions",
        titleModalHistory: "Lịch sử dùng mã Promotion",
        listOrderUsed: "Danh sách đơn hàng sử dụng",
        btnCheckCode: "Kiểm tra code",
        messCheckCode: "Nhập mã promotion code để kiểm tra tình trạng sử dụng",
        status: "Trạng thái",
        currentStatus: "Trạng thái hiện tại",
        schedules: "Thời gian áp dụng",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        titleModalSchedules: "Thời gian áp dụng",
        view: "Xem",
        hotel: "Khách sạn",
        supplier: "Nhà cung cấp",
        scheduleTypeHeader: "Loại thời gian",
        scheduleType: {
          booking_date: "Ngày sử dụng",
          use_date: "Ngày lưu trú",
        },
        bulkActive: "Kích hoạt đồng loạt mã khuyến mãi",
        bulkDeactivated: "Huỷ đồng loạt mã khuyến mãi",
        reason: "Lý do",
        invalidCode: "Code không tồn tại",
        inputTypePlaceholder: "Click vào đây để upload file",
      },
      campaign: {
        sku: "SKU",
        fnb: "FnB",
        hotel: "Hotel",
        flashSale: "Flash Sale",
        diem: "Điểm",
        staynfun: "Staynfun",
        name: "Tên chiến dịch",
        desc: "Nội dung",
        description: "Nội dung",
        formatCode: "Định dạng code",
        code: "Code",
        productType: "Loại sản phẩm",
        isCampaignStaynFun: "Kiểu property",
        totalCount: "Số lượng code",
        usedCount: "Đã sử dụng",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        action: "Thao tác",
        title: "Chiến dịch",
        campaignCode: "Mã chiến dịch",
        headingForm: {
          info: "Thông tin chiến dịch",
          prodType: "Sản phẩm áp dụng",
          type: "Đối tượng áp dụng",
          genCode: "Định dạng code",
        },
        schedules: "Thời gian áp dụng",
        countries: "Quốc gia áp dụng",
        channel: "Áp dụng cho kênh bán hàng",
        platforms: "Áp dụng cho platform",
        tag: "Tag hiển thị",
        discountPointType: "Loại áp dụng",
        discountPointValue: "Giá trị",
        activePoint: "Hoạt động",
        deactivePoint: "Ngừng hoạt động",
        supplier: "Nhà cung cấp",
        supplierAllHotel: "Lựa chọn toàn bộ nhà cung cấp",
        channelNull: "Kênh bán trống sẽ mặc định là chọn tất cả",
        skuIds: "Sản phẩm áp dụng",
        productValues: "Sản phẩm áp dụng",
        selectSkuIds: "Lựa chọn sản phẩm áp dụng",
        hotels: "Khách sạn áp dụng",
        minItemCount: "Số lượng SKU item tối thiểu",
        minFnbItemCount: "Số lượng item tối thiểu",
        minItemCountNull: "Để trống số lượng tối thiểu {{min}} item",
        maxItemCount: "Số lượng SKU item tối đa",
        maxFnbItemCount: "Số lượng item tối đa",
        maxItemCountNull: "Để trống số lượng tối đa vô hạn",
        totalOrderAmount: "Tổng tiền đơn hàng tối thiểu",
        totalOrderAmountNull: "Tổng tiền tối thiểu {{min}} {{currency}}",
        codePrefix: "Prefix code",
        codeCharCount: "Số lượng ký tự",
        promotionType: "Kiểu mã code",
        promotionTypes: {
          unique: "Unique",
          general: "General",
          hints: {
            unique: "Unique code chỉ áp dụng cho thành viên hệ thống",
          },
        },
        maxUseCount: "Số lần sử dụng",
        maxCountPerUser: "Số lượng tối đa người dùng sử dụng",
        userFrequencyLimitCount: "Giới hạn tần suất sử dụng của người dùng",
        userFrequencyLimitPeriodTitle: "Chu kỳ",
        userFrequencyLimitPeriodRequired: "Vui lòng chọn chu kỳ khi nhập giới hạn tần suất sử dụng",
        userFrequencyLimitPeriod: {
          none: "None",
          day: "Ngày",
          week: "Tuần",
          month: "Tháng",
          campaign: "Campaign",
        },
        maxRoomNightPerUser: "Giới hạn số đêm phòng áp dụng của người dùng",
        positiveIntegerInvalid: "%s phải là số nguyên lớn hơn 0",
        discountType: "Loại giảm giá",
        discountTypes: {
          amount: "Số tiền",
          percent: "Phần trăm",
        },
        discountMode: {
          2: "Áp dụng trên toàn đơn hàng",
          1: "Chia đều từng sản phẩm",
        },
        discountValue: "Giá trị giảm",
        maxDiscountValue: "Số tiền tối đa",
        timezoneOffset: "Ngày tạo",
        skuAll:
          "Tất cả (Bao gồm tất cả các SKU tại thời điểm hiện tại và SKU phát sinh trong tương lai )",
        skuSpecific: "Specific (Bao gồm các SKU được lựa chọn)",
        optionSku: {
          skuAll: "Tất cả",
          skuSpecific: "Chỉ định",
          description: {
            skuAll:
              "Bao gồm tất cả các SKU tại thời điểm hiện tại và SKU phát sinh trong tương lai",
            skuSpecific: "Chỉ định cụ thể các SKU được lựa chọn",
          },
        },
        valueDiscount: "Giá trị khuyến mại",
        formatCodeExample: "Code ví dụ",
        bonusType: "Kiểu thưởng",
        bonusValue: "Phần thưởng",
        bonusTypes: {
          tracking: "Tracking",
          decreace: "Giảm tiền",
          product: "Sản phẩm",
          description: {
            tracking: "Dùng tracking hiệu quả bán hàng sale",
            decreace: "Giảm tiền cho khách hàng đủ điều kiện",
            product: "Tặng sản phẩm cho khách hàng đủ điều kiện",
          },
        },
        searchInfoConfig: "Cấu hình tìm kiếm",
        searchInfoConfigs: {
          roomCount: "Số lượng phòng",
          nightCount: "Số lượng đêm",
          max: "Số lượng tối đa",
          min: "Số lượng tối thiểu",
        },
        selectAllHotel: "Lựa chọn toàn bộ khách sạn",
        selectHotel: "Chọn khách sạn áp dụng",
        selectedRateCodes: "Lựa chọn",
        selectedRateCodesSuffix: "mã giá",
        selectedProductSuffix: "sản phẩm",
        supplierName: "Nhà cung cấp",
        codeCharCountPlaceHolder: "Số lượng ký tự 4 -10",
        rangeDate: "Thời gian",
        useObjectHeader: "Đối tượng áp dụng",
        objectType: {
          all: "Tất cả",
          member: "Thành viên đã đăng ký",
          guestVisiting: "Guest",
          specific: "Đối tượng đặc biệt",
          description: {
            all: "Bao gồm thành viên và không phải thành viên",
            member: "Chỉ bao gồm thành viên đã đăng ký",
            guestVisiting: "Áp dụng cho người dùng chưa đăng nhập",
            specific:
              "Bao gồm thành viên và không phải thành viên có email đơn hàng tại danh sách",
            another:
              "Bao gồm thành viên và không phải thành viên có email đơn hàng tại danh sách",
          },
          another: "Đối tượng đặc biệt",
        },
        codeType: {
          standard: "Tiêu chuẩn",
          customize: "Tuỳ chỉnh",
        },
        selectEmail: "Lựa chọn khách hàng",
        selectedEmail: "Lựa chọn {0} khách hàng",
        importFailed: "Vui lòng kiểm trả dữ liệu lỗi",
        importFailedRow: "Dòng",
        importFailedError: "Lỗi:",
        totalRowInFile: "Số dòng dữ liệu trong tập tin:",
        totalRowValid: "Số dòng dữ liệu hợp lệ:",
        totalRowInvalid: "Số dòng dữ liệu lỗi:",
        freeNightConfig: "Cấu hình đêm nghỉ miễn phí",
        freeNightStay: "Số đêm nghỉ miễn phí",
        loyaltyCode: "Liên kết hệ thống loyalty",
        emailNotValid: "Định dạng email không đúng hoặc trùng",
        emailInvalid: "Email không đúng định dạng: {{values}}.",
        emailDuplicated: "Email bị trùng: {{values}}.",
        emailSuffixInvalid: "Đuôi email không đúng định dạng: {{values}}.",
        emailSuffixDuplicated: "Đuôi email bị trùng: {{values}}.",
        maxCodeCount: "Số lượng mã khuyến mãi",
        filterStatus: "Lọc theo trạng thái",
        active: "Đang hoạt động",
        deactive: "Ngừng hoạt động",
        all: "Tất cả",
        optionYes: "Có",
        optionNo: "Không",
        loyaltyBenefitCode: "Benefit code",
        loyaltyCampaignCode: "Campaign code",
        loyaltyCodeRequire:
          "Không điền mã liên kết hệ thống sẽ không kiểm tra sang loyalty",
        PROMOTION_NOT_ENOUGH_QUANTITY:
          "Đã có lỗi xảy ra trong quá trình xử lý, vui lòng liên hệ quản trị viên",
        specialEvent: {
          title: "Chương trình đặc thù",
          configBenefitCard: "Cấu hình quyền lợi thẻ",
          configBenefitVoucher: "Cấu hình quyền lợi voucher",
          numberUse: "Số lần sử dụng",
          loyaltyCode: "Liên kết hệ thống loyalty",
          codeBenefit: "Mã quyền lợi",
          codeCampaign: "Mã chiến dịch",
        },
        markup: "Markup",
        titleConfigPromotionMarkup: "Cấu hình promotion markup",
        promotionMarkup: {
          markupCampaigns: "Chương trình markup",
          airlineCodes: "Áp dụng cho hãng vé",
          isMultipleRoomNight: "Cách giảm giá",
          minRoomNight: "Tối thiểu",
          maxRoomNight: "Tối đa",
        },
        paymentCampaignTitle: "Kịch bản giảm trừ kiểu thẻ quốc tế",
        paymentCampaign: {
          refCode: "Điền mã promotion từ Onepay",
          refCodeValidate: "Mã promotion từ Onepay",
          bankValidate: "Ngân hàng",
          selectBank: "Lựa chọn ngân hàng",
          bankDiscountType: "Kiểu giảm giá",
          bankDiscount: "Giá trị giảm",
          discountValue: "Giá trị giảm",
          bankMaxDiscountValue: "Giá trị giảm tối đa",
          bankContributionPercent: "Tỷ lệ ngân hàng chi trả",
          contributionType: "Tỷ lệ tài trợ còn lại",
          minOrderValue: "Tổng tiền đơn hàng tối thiểu",
          totalBudget: "Tổng ngân sách chiến dịch",
          totalBudgetHint: "Để trống = không giới hạn",
          budgetUsed: "Ngân sách đã dùng",
          unlimited: "Không giới hạn",
          applyForPaymentMethods: "Áp dụng cho HTTT",
          paymentMethodsHint: "Có thể chọn nhiều. Promotion chỉ hiển thị khi user chọn HTTT tương ứng",
          allowMultiPromotion: "Cho phép áp dụng chồng ưu đãi",
          title: "Title hiển thị",
          description: "Mô tả ngắn",
          tooltip: "Tooltip",
        },
        campaignPromotionInfoSection: {
          headerTitle: "Thông tin chiến dịch khuyến mại",
          title: "Thông tin chiến dịch: {{name}}",
          SwitchVPT: "VPT",
          SwitchLoyalty: "Loyalty",
          displayName: "Tên hiển thị",
          description: "Mô tả ngắn",
          detail: "Thông tin chi tiết",
          avatar: "Ảnh đại diện",
          coverPicture: "Ảnh bìa",
          lableWording: "Tên label",
          ctaName: "Tên hiển thị CTA",
          displayTarget: "Đối tượng hiển thị",
          specifyTarget: "Đối tượng chỉ định",
          selectTargetPlaceholder: "Vui lòng chọn đối tượng hiển thị",
          emailTargetConfig: "Cấu hình danh sách email đối tượng ({{email}})",
          btnSave: "Lưu lại",
          btnUpdate: "Update thông tin",
          vptPlaceholder: {
            displayName: "50 ký tự",
            description: "200 ký tự",
            lableWording: "20 ký tự",
            fnbLableWording: "10 ký tự",
            ctaName: "20 ký tự",
          },
          loyaltyDescription:
            "Thông tin chiến dịch được lấy trực tiếp từ loyalty",
        },
      },
      autoFill: {
        campaignName: "Chiến dịch",
        promotionCode: "Mã",
        startDate: "Ngày hoạt động",
        dayOfWeek: "Thời gian hoạt động",
        memberShipTypes: "Đối tượng",
        productTypes: "Module",
        order: "Trọng số",
        isActive: "Trạng thái",
        action: "Thao tác",
        title: "Autofill code",
        campaign: "Loại chiến dịch",
        promotionCodeId: "Chọn mã autofill",
        schedules: "Thời gian autofill",
        memberShipTypeCheckBox: "Lựa chọn đối tượng người dùng",
        productTypesCheckBox: "Lựa chọn khu vực autofill",
        platformsCheckBox: "Lựa chọn platform autofill",
        campaignId: "Loại chiến dịch",
        autoFillApplyConfig: "Thời gian hoạt động",
      },
      payAtHotel: {
        configMemberShiptype: "Cấu hình đối tượng",
        save: "Lưu lại",
        update: "Chỉnh sửa",
        cancel: "Hủy bỏ",
        emptyRatePlan: "Vui lòng chọn rate plan",
      },
      tourTicket: {
        surchargeCategories: "Nhóm phụ thu",
        quantity: "Số lượng",
        code: "Mã vé",
        title: "loại vé",
        ticketCode: "Mã loại vé",
        ticketName: "Tên vé",
        mustBeAMultipleOfTheMultiple: "Phải chia hết cho bội số",
        codePlaceholder: "Mã vé gồm 6 ký tự chữ và số",
        propertyName: "Tên cơ sở",
        propertyToUse: "Địa điểm sử dụng",
        productCode: "Mã sản phẩm",
        name: "Tên loại vé",
        productName: "Tên",
        description: "Mô tả",
        shortDescription: "Mô tả ngắn",
        available: "Trạng thái",
        isAvailable: "Hoạt động",
        isUnAvailable: "Không hoạt động",
        translations: "Phiên dịch",
        soldQuantity: "Số lượng đã bán",
        objectType: "Đối tượng",
        objectTypeList: "Danh sách đối tượng",
        rateCode: "Mã giá",
        salePrice: "Giá",
        rateCodePrice: "Giá bán",
        salePercent: "Phần trăm khuyến mãi (%)",
        salePriceName: "Giá tiền",
        multiple: "Bội số",
        originalPrice: "Giá khuyến mãi",
        tourticketList: "Danh sách vé",
        action: "Thao Tác",
        samePrice: "Đồng giá",
        specific: "Specific",
        showDefault: "Hiện thị mặc định",
        tourName: "Tên chương trình",
        orderItemType: "Loại",
        usingDate: "Ngày check-in",
        returnDate: "Ngày check-out",
        maxQuantity: "Nhiều nhất",
        minQuantity: "Ít nhất",
        isEnableListing: "Hiển thị",
        listProvisions: "Trong danh sách quy định",
        amenity: "Tiện ích",
        extraInfo: "Mô tả chi tiết (Khung chi tiết vé)",
        extraInfoTooltip: "Hiển thị trên khung chi tiết vé, theo từng danh mục",
        shortDescriptionTooltip:
          "Hiển thị trên card sản phẩm trên trang Listing",
        shortDescriptionTransform: "Mô tả ngắn (card sản phẩm)",
      },
      banner: {
        title: "Banner",
        name: "Tên Hình",
        fileUrl: "Hình ảnh",
        imageView: "Hình ảnh",
        url: "Đường dẫn hình",
        order: "Thứ tự",
        image: "Tải hình banner",
        showImage: "Hình ảnh",
        imageName: "Tên hình",
        isEnabled: "Trạng thái",
        status: "Trạng thái",
        show: "Hiện",
        hide: "Ẩn",
        active: "Hiển thị",
        deActive: "Không hiển thị",
        action: "Thao tác",
        fileNotTrue: "File không phải hình",
        type: "Trang hiển thị",
        imageId: "ID vị trí",
        imageIds: {
          main_hotel_banner: "Banner chính Khách Sạn",
          main_voucher_banner: "Banner chính Voucher",
          main_combo_banner: "Banner chính Combo",
          main_home_banner: "Banner chính trang chủ",
          main_experience_banner: "Banner chính Trải Nghiệm",
          hotel_banner_ads: "Banner quảng cáo khách sạn",
          combo_banner_ads: "Banner quảng cáo combo",
          home_banner_ads: "Banner quảng cáo trang chủ",
          hotel_banner_ads_mobile: "Banner quảng cáo khách sạn trên điện thoại",
          combo_banner_ads_mobile: "Banner quảng cáo combo trên điện thoại",
          home_banner_ads_mobile: "Banner quảng cáo trang chủ trên điện thoại",
          footer_hotel_banner: "Banner chân trang khách sạn",
          footer_combo_banner: "Banner chân trang combo",
          footer_home_banner: "Banner chân trang chủ",
          footer_hotel_banner_mobile:
            "Banner chân trang khách sạn trên điện thoại",
          footer_combo_banner_mobile: "Banner chân trang combo trên điện thoại",
          footer_home_banner_mobile: "Banner chân trang chủ trên điện thoại",
          home_sticky_bottom_ads: "Banner quảng cáo cố định bên dưới trang chủ",
          hotel_sticky_bottom_ads:
            "Banner quảng cáo cố định bên dưới Khách Sạn",
          combo_sticky_bottom_ads: "Banner quảng cáo cố định bên dưới Combo",
          voucher_sticky_bottom_ads:
            "Banner quảng cáo cố định bên dưới Voucher",
          experience_sticky_bottom_ads:
            "Banner quảng cáo cố định bên dưới Trải Nghiệm",
          home_sticky_bottom_ads_mobile:
            "Banner quảng cáo cố định bên dưới trang chủ trên điện thoại",
          hotel_sticky_bottom_ads_mobile:
            "Banner quảng cáo cố định bên dưới Khách Sạn trên điện thoại",
          combo_sticky_bottom_ads_mobile:
            "Banner quảng cáo cố định bên dưới Combo trên điện thoại",
          voucher_sticky_bottom_ads_mobile:
            "Banner quảng cáo cố định bên dưới Voucher trên điện thoại",
          experience_sticky_bottom_ads_mobile:
            "Banner quảng cáo cố định bên dưới Trải Nghiệm trên điện thoại",
          vinwonder_banner_bottom: "Banner tải app chân trang desktop",
          vinwonder_banner_bottom_mobile: "Banner tải app chân trang mobile",
        },
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      order: {
        languageCode: "Ngôn ngữ mua",
        bookingId: "Mã xác nhận (trên Golf Soft)",
        departureDate: "Ngày bay",
        departureTime: "Thời gian cất cánh",
        flightInfo: "Chuyến bay",
        flightInfoTitle: "Cấu hình chuyến bay",
        airportDeparture: "Sân bay đi",
        airportArrival: "Sân bay đến",
        airportDomestic: "Hãng hàng không",
        flight: "Chuyến bay",
        refundConfirmed: "Tổng số đã hoàn",
        refundWaiting: "Tổng số đợi hoàn",
        redeemProperty: "Cơ sở sử dụng",
        confirmNumber: "Confirm Number",
        sale_amount: "Giá bán",
        original_amount: "Giá gốc",
        addTicket: "Thêm vé",
        titleModalSKU: "Thêm vé xuất bán",
        ftCode: "FT Code",
        effectiveStartDate: "Ngày bắt đầu hiệu lực",
        effectiveEndDate: "Ngày kết thúc hiệu lực",
        roomConfirmationNumber: "Mã xác nhận",
        maxDiscount: "Giảm tối đa",
        couponCode: "Mã khuyến mãi",
        apply: "Áp dụng",
        counponCodePlaceHolder: "Nhập mã giảm giá",
        totalSeats: "Tổng voucher còn lại",
        searchVoucher: "Search Voucher",
        totalDiscountPrice: "Số tiền giảm",
        totalSalePrice: "Tổng giá bán",
        totalPrice: "Tổng tiền",
        totalChangeRateCode: "Chênh lệch do đổi mã giá",
        departureOrderStatus: "Trạng thái đơn hàng chiều đi",
        returnOrderStatus: "Trạng thái đơn hàng chiều về",
        departureSellAccount: "Tài khoản bán hàng chiều đi",
        returnSellAccount: "Tài khoản bán hàng chiều về",
        installmentFee: "Phí trả góp",
        installmentLimit: "Thời hạn trả góp",
        creditPoint: "Credit Point",
        propertyName: "Cơ sở lưu trú",
        ticketName: "Tên vé",
        rateCode: "Rate code",
        seatNo: "Số ghế",
        title: "Đơn hàng",
        saleReportBySKU: "Báo cáo đơn hàng theo SKU",
        saleChannel: "Kênh bán",
        channel: "Nguồn",
        titleDetailGroupVoucher: "Thông tin voucher",
        orderCode: "Mã đơn hàng",
        fullname: "Họ tên",
        phoneNumber: "Số điện thoại",
        email: "Thư điện tử",
        customerLoginInfo: "Tài khoản đăng nhập",
        phone: "Số điện thoại",
        sex: "Giới tính",
        dateOfBirth: "Ngày sinh",
        firstName: "Đệm và tên",
        lastName: "Họ",
        phoneNumberShort: "SĐT",
        identityType: "Loại giấy tờ tùy thân",
        identityDetail: "Giấy tờ tùy thân",
        national: "--Quốc tịch--",
        placeOfBirth: "Nơi sinh",
        require: "*",
        submarineMaxQuantity: "Tổng vé tàu ngầm không được vượt quá: ",
        session: "Giờ khởi hành",
        zonePickup: "Cảng đón",
        zoneRelease: "Cảng trả",
        createdDate: "Ngày đặt hàng",
        subTotal: "Thành tiền",
        subTotalBeforePromotion: "Thành tiền trước khuyến mãi",
        totalOriginalAmount: "Tổng tiền trước km",
        exchangeCash: "Điểm",
        pointUnit: "điểm",
        totalPayment: "Thành tiền",
        totalChangeRateCodeAdmin: "Đổi mã giá",
        totalSurchargeAdmin: "Phụ thu",
        totalAmountAdmin: "Tổng Tiền",
        paymentPromotion: "Khuyến mãi thanh toán",
        status: "Trạng thái đơn hàng",
        quickTaskStatus: "QuickTask",
        paymentStatus: "Trạng thái thanh toán",
        accountantStatus: "Trạng thái đơn hàng kế toán",
        transactionId: "Mã giao dịch",
        paymentMethod: "Phương thức thanh toán",
        paid: "Đã thanh toán",
        unpaid: "Chưa thanh toán",
        detail: "Chi tiết",
        tourTitle: "Tên dịch vụ",
        departureDate: "Ngày khởi hành",
        priceType: "Loại vé",
        quantity: "Số lượng",
        originalPrice: "Giá",
        price: "Giá",
        prices: "Giá bán",
        salePrice: "Giá khuyến mãi",
        orderInfo: "Thông tin giao dịch",
        groupOrderInfo: "Thông tin đơn hàng",
        groupCustomerInfo: "Thông tin khách hàng",
        groupPaymentInfo: "Thông tin thanh toán",
        groupFinancialInfo: "Thông tin doanh thu",
        orderItemInfo: "Thông tin dịch vụ",
        action: "Thao tác",
        checkCode: "Mã kiểm tra",
        saleReportByOrder: "Báo cáo doanh số theo đơn hàng",
        checkedBy: "Sử dụng bởi",
        checkedDate: "Ngày sử dụng",
        couponValue: "Giá trị voucher",
        firstname: "Tên",
        lastname: "Họ",
        groupCode: "Mã chương trình",
        name: "Tên chương trình",
        operaBookingCode: "Mã booking",
        orderItemType: "Loại đơn hàng",
        property: "Địa điểm sử dụng",
        serialNumber: "Mã voucher",
        surchargeDetail: "Chi tiết phụ thu",
        orderSurcharge: "Phụ thu đơn hàng",
        orderCreateSurcharge: "Tạo phiếu",
        userEmail: "Email",
        voucherStatus: "Trạng thái voucher",
        skuCode: "Mã SKU",
        skuName: "Tên SKU",
        urlSlug: "Link SKU",
        ticketCode: "Mã vé",
        rateCode: "Mã giá",
        markupHotel: "Lãi markup hotel",
        markupHomestay: "Lãi markup homestay",
        errorCode: {
          NOT_FOUND: "Không tìm thấy",
          NOT_ENOUGH_VOUCHER: "Không có đủ số lượng voucher",
          GROUP_NOT_FOUND: "Không tìm thấy chương trình",
        },
        statusDetailGroup: {
          enum: {
            4: "Đã bán",
            7: "Đã dùng",
          },
        },
        orderStatus: {
          0: "",
          1: "Không thành công",
          2: "Thành công",
          3: "Không thành công",
          4: "Chờ thanh toán",
          5: "Đã hủy 1 phần",
          6: "Đã hủy",
          7: "Đã hoàn 1 phần",
          8: "Đã hoàn",
          9: "Chờ xử lý",
        },
        orderQuickTaskStatus: {
          1: "Chưa tạo",
          2: "Đã tạo",
        },
        paymentStatusEnum: {
          0: "",
          1: "Chưa thanh toán",
          2: "Đã thanh toán",
          4: "Chờ thanh toán",
          5: "Đã hủy",
        },
        voucher: {
          groupName: "Tên chương trình",
          discountValue: "Giá trị voucher",
          quantity: "Số lượng",
          originalPrice: "Giá",
          totalPrice: "Tổng tiền",
          status: "Trạng thái",
          operaBookingCode: "Mã Booking",
          checkInDate: "Ngày check-in",
          checkOutDate: "Ngày check-out",
          propertyOfStay: "Cơ sở lưu trú",
          property: "Cơ sở sử dụng",
          checkedDate: "Ngày sử dụng",
          checkCode: "Mã kiểm tra",
          serialNumber: "Mã Voucher",
          salePrice: "Giá bán",
          rateCode: "Mã giá",
          action: "Thao tác",
          types: {
            percent: "%",
            gift: "Miễn phí sử dụng",
            money: "Giảm",
          },
        },
        itemTypes: "Loại đơn",
        orderTypes: {
          voucher: "Voucher",
          tour: "Tour",
          flight: "Chuyến bay",
          hotel: "Khách sạn",
          vinWonder: "Vé VinWonders",
          bundle: "Bundle",
          vinWonderNew: "Vé VinWonders New",
          packageRate: "Package Rate",
          linkCrossSell: "Link CrossSell",
          homestay: "Homestay",
          vinpearlGolf: "Vinpearl Golf",
          fnb: "FNB",
        },
        flightInfos: "Thông tin chuyến bay",
        voucherInfo: "Thông tin Voucher",
        ticketType: "Loại vé",
        serviceName: "Tên dịch vụ",
        tourInfo: "Thông tin Tour",
        vinwondersInfo: "Thông tin VinWonders",
        tourItemTicket: "vé tour",
        tourName: "Tên Tour",
        adult: "Người lớn",
        children: "Trẻ em",
        child: "Trẻ em",
        senior: "Người cao tuổi",
        infant: "Trẻ sơ sinh",
        coupon: "Giảm giá",
        paymentType: "Hình thức thanh toán",
        paymentMethod: "Kênh thanh toán",
        paymentTypes: {
          vnpay: "VNPAY",
          onepay: "ONEPAY",
          zalo: "ONEPAY",
          shopeepay: "ONEPAY",
          onepay_installment: "Trả góp",
          paylater: "Thanh toán sau",
          cash: "Tiền mặt",
          transfer: "Chuyển Khoản",
          qrcode: "QRCode",
          pay_at_hotel: "Tại cơ sở",
          other: "Khác",
          CreditPoint: "Credit Point",
          popr: "POPR",
          // Other: 'OTHER',
          Other: "Khác",
          momo: "MoMo",
          twoc2p: "2C2P",
          Napas: "NAPAS",
          napas: "NAPAS",
          NAPAS: "NAPAS",
          "Agent Voucher": "Agent Voucher",
        },
        soStatus: "Push Sale Order",
        oiStatus: "Push Order Item",
        soioStatuss: {
          success: "Thành công",
          pushed: "Không thành công",
          unhandle: "Chưa xử lý",
        },
        saleChannels: {
          online: "Online",
          corporation: "Công ty",
          customerservice: "Chăm sóc khách hàng",
          property: "Cơ sở",
          internal: "Nội bộ",
          travelagent: "Đại lý",
          b2b: "B2B",
        },
        channels: {
          1: "Online website",
          2: "Online app",
          3: "Online chatbot",
          4: "Offline website",
          10: "BookingVinwonder",
          11: "AppVinwonder",
          12: "Booking Vinpearl Golf",
        },
        surchargeType: {
          ticket: "Phụ thu vé",
          room: "Phụ thu phòng",
          ticketrefundcancel: "Hoàn hủy vé",
          roomrefundcancel: "Hoàn hủy phòng",
          other: "Phụ thu khác",
          Room: "phụ thu phòng",
          DepartureFlight: "phụ thu vé chiều đi",
          ReturnFlight: "phụ thu vé chiều về",
        },
        orderSmsHistories: {
          index: "Id",
          content: "Nội dung",
          receivers: "Số điện thoại",
          status: "Trạng thái",
          createdDate: "Thời gian tạo",
          action: "Gửi lại",
          statusTypes: {
            Failed: "Không thành công",
            Success: "Thành công",
          },
        },
        orderFixcharge: {
          index: "Id",
          fixchargeCode: "Fixcharge code",
          itiNumber: "Iti number",
          reservationCode: "Res code",
          amount: "Số tiền",
          fixchargeStatus: "Trạng thái",
          action: "",
          completed: "Thành công",
          failed: "Thất bại",
          pending: "Đang đẩy",
          code: "Fixcharge code",
          number: "Iti number",
          resCode: "Res code",
          money: "Số tiền",
          status: "Trạng thái",
        },
        currentStatus: "Trạng thái hiện tại",
        confirmResendMail: "Xác nhận gửi lại email?",
        confirmExportVoucher: "Xác nhận xuất file voucher?",
        confirmSendMailTemplate: "Xác nhận gửi email CSKH?",
        confirmLockOrderItem: "Bạn có chắc chắn muốn khóa đơn hàng này?",
        confirmUnLockOrderItem: "Bạn có chắc chắn muốn mở khóa đơn hàng này?",
        confirmPushFixedCharge: "Bạn có chắc chắn muốn đẩy FixCharge?",
        hotelBookingDetailInfo: "Thông tin chi tiết phòng khách sạn",
        hotelInfo: "Thông tin khách sạn",
        hotelBookingInfo: "Thông tin đặt phòng",
        hotelRoomLength: "Số phòng",
        hotelLengthOfStay: "Số đêm",
        homestayBookingDetailInfo: "Thông tin chi tiết phòng homestay",
        homestayInfo: "Thông tin homestay",
        homestayBookingInfo: "Thông tin đặt phòng",
        homestayRoomLength: "Số phòng",
        homestayLengthOfStay: "Số đêm",
        arrivalDate: "Ngày nhận phòng",
        checkoutDate: "Ngày trả phòng",
        operaConfirmationNumber: "Mã đặt phòng",
        orderStatusHotel: "Trạng thái",
        orderStatusHomestay: "Trạng thái",
        roomType: "Loại phòng",
        maxOccupancy: "Số người tối đa",
        maxAdult: "Số người lớn tối đa",
        maxChild: "Số trẻ em tối đa",
        maxInfant: "Số trẻ sơ sinh tối đa",
        amount: "Giá",
        totalAmount: "Tổng tiền",
        totalSurcharge: "Tổng tiền phụ thu",
        profile: "Thông tin khách hàng",
        profileName: "Tên",
        profileEmail: "Email",
        profilePhoneNumber: "Số điện thoại",
        exportSaleOrder: "Xuất bán",
        saleOrderFullName: "Tên người mua",
        saleOrderFirstName: "Tên",
        saleOrderLastName: "Họ",
        note: "Ghi chú",
        saleOrderSuccess: "Xuất bán thành công",
        exportVoucherSuccess: "Xuất file thành công",
        invoiceInfo: "Thông tin xuất hóa đơn",
        smsHistories: "Tin nhắn đã gửi",
        fixchargeCreated: "fixcharge đã tạo",
        fullName: "Họ tên",
        companyName: "Công ty",
        address: "Địa chỉ",
        taxCode: "Mã số thuế",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        payLater: "Thanh toán sau",
        customer: "Khách hàng",
        surcharge: "Phụ thu",
        exportAccessTrade: "Xuất đối soát Access Trade",
        exportAT: "Xuất đối soát Affiliate",
        exportDate: "Ngày xuất",
        affiliateSource: "Nguồn",
        vinWonderInfo: "Thông tin vé VinWonders",
        fnbInfo: "Thông tin đơn hàng FNB",
        fnb: {
          restaurant: "Nhà hàng",
          pickupMode: "Chế độ nhận hàng",
          status: "Trạng thái đơn hàng",
          pickupTime: "Thời gian nhận hàng dự kiến",
          bookingCode: "Mã booking",
          orderTime: "Thời gian đặt đơn",
          dish: "Món ăn",
          price: "Giá",
          discount: "Giảm giá",
          total: "Tổng tiền",
        },
        surchargeInfo: "Thông tin phụ thu",
        vinWonderCustomer: "Hành khách VinWonders",
        checkInDate: "Ngày check-in",
        checkOutDate: "Ngày check-out",
        operaBooking: "Mã Booking",
        tourStatus: "Trạng thái",
        ticketStatus: "Trạng thái VW",
        tourSerialNumber: "Mã kiểm tra",
        changeStatus: "Thay đổi trạng thái ",
        orderProfiles: {
          title: "Thông tin người sử dụng",
          lastName: "Tên đệm và tên",
          firstName: "Họ",
          phoneNumber: "Số điện thoại",
          email: "Email",
          nationality: "Vùng quốc gia",
          member: "Người sử dụng {{number}}",
        },
        tourStatusOptions: {
          1: "Đã bán",
          2: "Đã dùng",
          3: "Đã khoá",
        },
        tourStatusColors: {
          1: "grey",
          2: "green",
        },
        orderItemStatus: {
          1: "Phát hành",
          2: "Đã bán",
          3: "Đã dùng",
          4: "Đã hoàn",
          5: "Đã hủy",
          7: "Đã hoàn một phần",
          13: "Không thành công",
        },
        orderItemStatusColor: {
          1: "green",
          2: "green",
          3: "grey",
          4: "orange",
          5: "red",
          7: "orange",
          13: "red",
        },
        orderItemVWStatus: {
          0: "Tất cả",
          1: "Chờ sử dụng",
          2: "Đang sử dụng",
          3: "Hết lượt sử dụng",
          4: "Hết hạn",
          5: "Bị khóa",
          6: "Thẻ nạp chờ",
          7: "Hủy thẻ",
        },
        orderItemVWStatusColor: {
          0: "green",
          1: "green",
          2: "green",
          3: "red",
          4: "red",
          5: "red",
          6: "red",
          7: "red",
        },
        orderError: "Mã lỗi",
        retryCiapsBooking: "Thử lại",
        retryCiapsBookingSuccess:
          "Retry thành công. Mail confirmation đã được gửi đến khách hàng.",
        retryCiapsBookingErrors: {
          ORDER_NOT_FOUND: "Không tìm thấy đơn hàng",
          UNPAID_ORDER: "Đơn hàng chưa thanh toán",
          ORDER_FAILED: "Đơn hàng không ở trạng thái lỗi",
          ITEM_TYPE_NOT_EXIST: "Đơn hàng không có vé VinWonders Tour",
          RETRY_CIAPS_BOOKING_USING_DATE_EXPIRED: "Vé đã quá ngày sử dụng",
          RETRY_CIAPS_BOOKING_OUT_OF_STOCK: "Vé đã hết suất",
          CIAPS_BOOKING_COMPLETED: "Booking trên CiAPS đã hoàn tất",
          SYS: "Retry booking thất bại",
        },
        recommit: "Xuất lại vé",
        recommitHotelBundle: "Xuất bán",
        confirmRecommitHotelBundle: "Xác nhận xuất bán cho đơn bundle và hotel",
        transactionHotelBundle: "Mã giao dịch",
        transactionHotelBundleMessageError: "Mã giao dịch không được để trống",
        confirmRecommitTour: "Xác nhận xuất lại vé",
        confirmUpdateOrderStatus: "Bạn chắc chắn muốn cập nhật trạng thái?",
        memberShipCode: "Hạng thẻ",
        differenceDueToPriceCodeChange: "Chênh lệch do đổi mã giá",
        addSurchargeTitle: "Tạo phiếu phụ thu",
        selectASurchargeToCancel: "Lựa chọn phụ thu hủy",
        surchargeCost: "Số tiền phụ thu",
        selectSurchargeType: "Lựa chọn kiểu",
        surchargeDesc: "Đảm bảo đã thu được tiền của khách và có sẵn FT code",
        customersList: "Danh sách khách hàng",
        nationalityID: "Quốc tịch",
        memberShipName: "Chủ thẻ",
        vgId: "Mã khách hàng",
        memberShipCardNumber: "Mã thẻ thành viên",
        crossSellOlder: "Đơn hàng LinkCrossSell",
        crossSellLink: "Link CrossSell",
        packageRates: {
          product: "Sản phẩm",
          ratePlan: "RateHotel",
          packageRateName: "Kiểu PackageRate",
          bookable: "Mã bookable",
          quantity: "Số lượng",
          original_amount: "Giá gốc",
          interest_amount: "Lãi",
          sale_amount: "Giá bán",
          total_amount: "Thành tiền",
        },
        affSource: "Nguồn Aff",
        affStatus: "Trạng thái",
        affStatusItem: {
          1: "LEAD",
          2: "APPROVED",
          4: "FAILED",
        },
        affSource_affSId: "Aff Source/aff_sID",
        loyaltyCampaignCode: "Kiểu tiếp cận",
        loyaltyCommitStatus: "Trạng thái quy đổi",
        loyaltyLinkType: "Loại quy đổi",
        loyaltyLinkValue: "Quy đổi",
        itemLoyaltyCommitStatusColor: {
          1: "red",
          2: "green",
        },
        itemLoyaltyCommitStatus: {
          1: "Không thành công",
          2: "Thành công",
        },
        giftPointCommitStatus: "Trạng thái tặng điểm",
        giftPointValue: "Điểm tặng",
        itemGiftPointCommitStatusColor: {
          1: "red",
          2: "green",
        },
        itemGiftPointCommitStatus: {
          1: "Không thành công",
          2: "Thành công",
        },
        pointHistory: {
          spendLog: "Lịch sử tiêu điểm",
          saveLog: "Lịch sử tích điểm",
          vinClubBranchId: "PropertyCode",
          amount: "Point",
          sessionId: "SessionId",
          status: "Trạng thái",
          statusTypes: {
            success: "Thành công",
            failed: "Thất bại",
          },
          refundStatus: "Hoàn tác",
          operator: "Người thao tác",
          operation: "Thao tác",
          orderRefundStatusType: {
            confirmed: "Đã hoàn",
            refundFailed: "Hoàn tiêu thất bại",
          },
          refundModal: {
            title: "Hoàn tiêu điểm đơn hàng",
            message: "Bạn có chắc chắn muốn hoàn tiêu điểm cho đơn ",
            pointAmount: "Số điểm sẽ được hoàn: ",
            point: " điểm",
            warning: "Lưu ý: Thao tác này không thể hoàn tác.",
          },
          refundSuccess: "Hoàn tiêu thành công",
          refundFail: "Hoàn tiêu thất bại",
          refundFailContent:
            "Đã xảy ra lỗi trong quá tình hoàn điểm. Vui lòng thử lại sau.",
        },
        outletInfo: "Địa điểm",
        sessionInfo: "Khung giờ",
      },
      orderSku: {
        orderCode: "Mã đơn hàng",
        transactionId: "Mã giao dịch",
        paymentType: "Hình thức thanh toán",
        paymentStatus: "Trạng thái thanh toán",
        orderStatus: "Trạng thái",
        accountantStatus: "Trạng thái đơn hàng kế toán",
        saleChannel: "Kênh bán",
        channel: "Nguồn",
        orderItemType: "Loại đơn",
        createdDate: "Ngày đặt hàng",
        fullname: "Họ tên",
        email: "Thư điện tử",
        phoneNumber: "Số điện thoại",
        couponCode: "Mã giảm giá",
        couponValue: "Giảm giá",
        subTotal: "Thành tiền",
        surcharge: "Tổng tiền phụ thu",
        surchargeDetail: "Chi tiết phụ thu",
        totalAmount: "Tổng tiền",
        totalChangeRateCode: "Chênh lệch do đổi mã giá",
        note: "Ghi chú",
        skuCode: "Mã SKU",
        skuName: "Tên SKU",
        ticketCode: "Mã vé",
        ticketName: "Tên vé",
        ticketType: "Loại vé",
        checkCode: "Mã kiểm tra",
        serialNumber: "Mã Voucher",
        voucherStatus: "Trạng thái Voucher",
        salePrice: "Giá bán",
        operaBookingCode: "Opera booking",
        checkInDate: "Ngày check-in",
        checkOutDate: "Ngày check-out",
        property: "Địa điểm",
        checkedDate: "Ngày sử dụng",
        checkedBy: "Sử dụng bởi",
        adult: "Người lớn",
        infant: "Trẻ sơ sinh",
        child: "Trẻ em",
        senior: "Người cao tuổi",
        endDate: "Ngày kết thúc hiệu lực mã voucher",
        bookingPeriod: "Hạn cuối cùng phải đặt",
        memberShipCode: "Hạng thẻ",
        affiliateSource: "Nguồn Aff",
      },
      orderDetailReportSku: {
        orderCode: "Mã đơn hàng",
        orderId: "Mã giao dịch",
        paymentType: "Hình thức thanh toán",
        paymentStatus: "Trạng thái thanh toán",
        orderStatus: "Trạng thái đơn hàng",
        accountantStatus: "Trạng thái đơn hàng kế toán",
        saleChannel: "Kênh bán",
        channel: "Nguồn",
        orderItemType: "Loại đơn",
        createdDate: "Ngày tạo",
        fullname: "Họ tên khách đại diện",
        email: "Thư điện tử",
        phoneNumber: "Số điện thoại",
        fullnameCustomer: "Họ tên khách mua",
        emailCustomer: "Thư điện tử khách mua",
        phoneNumberCustomer: "Số điện thoại khách mua",
        memberShipName: "Hạng hội viên",
        couponCode: "Mã giảm giá",
        couponValue: "Số tiền giảm",
        subTotal: "Giá trị đơn hàng gốc",
        surcharge: "Tổng tiền phụ thu",
        surchargeDetail: "Chi tiết phụ thu",
        totalAmount: "Tổng tiền",
        totalChangeRateCode: "Chênh lệch do đổi mã giá",
        note: "Ghi chú",
        skuCode: "Mã SKU",
        skuName: "Tên SKU",
        urlSlug: "UrlSlug",
        ticketCode: "Mã loại vé",
        ticketName: "Tên loại vé",
        ticketType: "Loại vé",
        ticketPrice: "Giá bán vé",
        totalRounding: "Lãi vé",
        checkCode: "Mã kiểm tra",
        serialNumber: "Mã Voucher",
        voucherStatus: "Trạng thái Voucher",
        salePrice: "Giá bán",
        operaBookingCode: "Mã booking",
        checkInDate: "Ngày nhận phòng",
        checkOutDate: "Ngày trả phòng",
        checkedDate: "Ngày sử dụng",
        checkedBy: "Sử dụng bởi",
        adult: "Người lớn",
        infant: "Trẻ sơ sinh",
        child: "Trẻ em",
        senior: "Người cao tuổi",
        endDate: "Hạn lưu trú",
        bookingPeriod: "Hạn cuối đặt dịch vụ",
        groupName: "Nhóm chương trình",
        memberShipCode: "Hạng thẻ",
        rateCode: "Mã giá",
        seatNo: "Số ghế",
        rateName: "Tên mã giá",
        supplierCode: "Mã NCC",
        supplierName: "Tên NCC",
        outletName: "Cơ sở",
        outletInfo: "Cơ sở",
        sessionInfo: "Khung giờ",
        supplierType: "Nhóm sản phẩm gốc",
        supplierProductCode: "Mã SP gốc",
        supplierProductName: "Tên sản phẩm gốc",
        supplierProductPrice: "Giá sản phẩm gốc",
        departureLocation: "Nơi khởi hành",
        property: "Địa điểm áp dụng",
        agentId: "Agent",
        installmentFee: "Kiểu trả góp",
        installmentLimit: "Thời hạn trả góp",
        affiliateSource: "Nguồn Aff",
      },
      orderDetailReportHotel: {
        orderCode: "MÃ ĐƠN HÀNG",
        createdDate: "Ngày đặt hàng",
        checkInDate: "Ngày Check-in",
        checkOutDate: "Ngày Check-out",
        hotelName: "Tên Khách sạn",
        ratePlanName: "Rate Plan Name",
        ratePlanCode: "Rate Plan Code",
        promotionName: "Tên promo",
        roomType: "Hạng phòng",
        lengthOfStay: "Đêm phòng (RN)",
        adultQuantity: "SL NL",
        childQuantity: "SL TE",
        nationality: "Quốc tịch",
        priceRoom: "Giá vốn phòng",
        markUpPriceRoom: "Mark up phòng",
        salePrice: "Giá dịch vụ",
        couponValue: "Số tiền khuyến mại",
        surcharge: "Tổng tiền phụ thu",
        surchargeDetail: "Chi tiết phụ thu",
        totalAmount: "Tổng tiền",
        couponCode: "Mã giảm giá",
        memberShipCode: "Hạng hội viên",
        transactionId: "Mã giao dịch",
        paymentType: "Hình thức thanh toán",
        bookingId: "Booking ID",
        saleChannel: "Kênh bán",
        channel: "Nguồn",
        fullnameCustomer: "Họ và tên khách đại diện",
        phoneNumberCustomer: "Số điện thoại",
        emailCustomer: "Email khách mua",
        fullname: "Họ tên khách mua",
        phoneNumber: "SĐT khách mua",
        email: "Thư điện tử",
        agentId: "Agent",
        note: "NOTE",
      },

      product: {
        title: "Sản phẩm",
        name: "Tên",
        description: "Mô tả",
        action: "Thao tác",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      infoRedeem: {
        hotelName: "Tên khách sạn",
        itineraryNumber: "ITI Booking ID",
        voucherCode: "Mã bảo mật",
        listConfirm: "Confirm no. list",
        titleProfile: "Thông tin khách",
        titleTransportation: "Thông tin vận chuyển",
        lastName: "Họ",
        firstName: "Tên",
        email: "Email",
        phoneNumber: "Số điện thoại",
        dateOfBirth: "Ngày sinh",
        note: "Ghi chú",
        ticketName: "Tên vé",
        status: "Trạng thái",
        surchargeInfo: "Thông tin phụ thu",
        NOTIFY_WARNING_LOCK:
          "Voucher đang bị khoá , chỉ được kiểm tra không thể sử dụng",
        transportation: {
          update: "Chọn Transportation task đã tạo",
          create: "Tạo mới",
          ignore: "Không tạo Transportation task",
          adult: "Người lớn",
          children: "Trẻ em",
          name: "Tên",
          object: "Đối tượng",
          transportDateTime: "Thời gian",
          transportType: "Kiểu vận chuyển",
          listTransportype: {
            arrival: "Đón",
            departure: "Tiễn",
            "round-trip": "khứ hồi",
            internal_transfer: "Chuyển nội bộ",
          },
          route: "Route",
          vehicleType: "Vehicle Type",
          vehicle: "Vehicle",
          departureLocation: "Điểm đi",
          arrivalLocation: "Điểm đến",
          flightNumber: "Flight number",
          airport: "Sân bay",
          serialTicket: "Serial vé máy bay",
        },
      },
      checkVoucher: {
        title: "Kiểm tra voucher",
        checkedDate: "Ngày sử dụng",
        orderCode: "Mã đơn hàng",
        goToOrder: "Xem đơn hàng",
        propertyOfStay: "Cơ sở lưu trú",
        infoVoucher: "Thông tin voucher",
        infoGroup: "Thông tin chương trình",
        infoUsed: "Thông tin sử dụng",
        email: "Email",
        enddate: "Ngày kết thúc",
        startdate: "Ngày bắt đầu",
        fullname: "Họ tên khách hàng",
        groupname: "Tên chương trình",
        hmscode: "Mã xác nhận",
        phone: "Số điện thoại",
        price: "Giá bán",
        properties: "Khu vực sử dụng",
        products: "Sản phẩm",
        status: "Trạng thái",
        use: "Sử dụng",
        times: "lần",
        used: "Đã sử dụng",
        valid: "Hiệu lực",
        invalid: "Không hợp lệ",
        lockvoucher: "Khoá voucher",
        unlockvoucher: "Mở khoá voucher",
        islocked: "Đã khoá",
        reason: "Lý do",
        bill: "Số hoá đơn",
        exportorder: "Hệ thống xuất hoá đơn",
        note: "Ghi chú",
        minOrderValue: "Đơn hàng tối thiểu",
        maxOrderValue: "Đơn hàng tối đa",
        maxDiscountValue: "Giá giảm tối đa",
        originalPrice: "Giá gốc",
        salePrice: "Giá giảm",
        saleStartDate: "Ngày mở bán",
        saleEndDate: "Ngày ngừng bán",
        voucherType: "Giảm",
        conditionOfUse: "Điều khoản sử dụng",
        onlycheck: "Mã chỉ dùng để kiểm tra, không thể sử dụng",
        bookingDate: "Ngày đặt hàng",
        checkCode:
          "Nhập mã kiểm tra để tra cứu tình trạng sử dụng. Nhập mã voucher để ghi nhận sử dụng voucher",
        property: "Địa điểm sử dụng",
        checkInDate: "Ngày check-in",
        checkOutDate: "Ngày check-out",
        operaBookingCode: "Mã Booking",
      },
      voucher: {
        showInfo: {
          info: "1. Thông tin voucher",
        },
        checkCode: "Mã kiểm tra",
        optionfilter: "Tuỳ chọn hiển thị",
        clearfilter: "Xoá hiển thị",
        title: "Voucher",
        serial: "Mã số",
        group: "Chương trình",
        groupName: "Chương trình",
        salePrice: "Giá giảm",
        status: "Trạng thái",
        hmsVerificationCode: "Mã xác thực",
        createdDate: "Ngày nhập",
        invalid: "Phát hành",
        sold: "Đã bán",
        used: "Đã sử dụng",
        action: "Thao tác",
        actionId: "Thao tác",
        voucherNumber: "Số lượng voucher",
        remainQuantity: "Số lượng còn lại",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        typeReduced: "Loại",
        discountValue: "Giảm",
        maxDiscountValue: "Giá giảm tối đa",
        limitNumberOfTimes: "Số lần sử dụng",
        property: "Cơ sở áp dụng",
        note: "Ghi chú",
        minOrderValue: "Đơn hàng tối thiểu",
        maxOrderValue: "Đơn hàng tối đa",
        gift: "Tặng",
        money: "Tiền",
        percent: "%",
        lock: "Khoá voucher",
        createDate: "Ngày tạo",
        checkInDate: "Ngày check-in",
        checkOutDate: "Ngày check-out",
        operaBookingCode: "Mã Booking",
        propertyOfStay: "Cơ sở lưu trú",
        checkedDate: "Ngày sử dụng",
        statusVoucher: {
          public: "Phát hành",
          sold: "Đã bán",
          used: "Đã dùng",
          refuned: "Đã hoàn",
          cancelled: "Đã hủy",
          fail: "Không thành công",
          expired: "Đã hết hạn",
          locked: "Đã khoá",
        },
        colorStatus: {
          1: "orange",
          2: "green",
          3: "red",
          4: "green",
          5: "#87d068",
          6: "danger",
          7: "red",
          8: "danger",
          999: "grey",
          998: "darkgrey",
        },
        log: {
          Checked: "Kiểm tra voucher",
          Sold: "Đã bán",
          Used: "Sử dụng",
          Locked: "Khoá",
          Unlocked: "Mở khoá",
          Refunded: "Đã hoàn",
          Cancelled: "Đã huỷ",
          colorStatus: {
            1: "orange",
            2: "red",
            3: "green",
            4: "#b3b3b3",
            5: "#87d068",
            6: "orange",
            7: "red",
          },
        },
        date: "Ngày",
        actionDate: "Ngày",
        user: "Thành viên",
        actionBy: "Thành viên",
        importVoucher: "Nhập voucher",
        chooseFile: "Chọn tập tin",
        dataError: "- Dữ liệu không hợp lệ, dòng: ",
        // checkCode: "- Mã kiểm tra",
        voucherCode: "Mã voucher",
        alreadyExist: "Đã tồn tại, dòng:",
        dataDuplicate: "Bị trùng, dòng:",
        importFaild: "Nhập voucher thất bại, vui lòng kiểm tra lại dữ liệu.",
        importSuccess: "Nhập voucher thành công.",
        totalCount: "Tổng số voucher:",
        totalRowInFile: "Số dòng dữ liệu trong tập tin:",
        totalRowValid: "Số dòng dữ liệu hợp lệ:",
        totalRowInvalid: "Số dòng dữ liệu lỗi:",
        importData: "Nhập dữ liệu",
        importExcel: "Nhập file Excel",
        exportExcel: "Tải tập tin mẫu",
        exportFileExcel: "Xuất file Excel",
        currencyCode: "Tiền tệ",
      },
      property: {
        title: "Cơ sở",
        name: "Tên",
        address: "Địa chỉ",
        phone: "Số điện thoại",
        email: "Email",
        action: "Thao tác",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        type: "Áp dụng cho",
      },
      role: {
        title: "Vai trò",
        name: "Tên vai trò",
        createdDate: "Ngày tạo",
        action: "Thao tác",
        generalManagement: "Quản lý chung",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      hotel: {
        addressHyperLink: "Hyper link địa chỉ",
        tripAdvisorLocationId: "Mã Trip Advisor",
        napasReconEmail: "Email nhận file đối soát",
        hardblock: "Hardblock",
        thumbnailTag: "Tag hình ảnh",
        urlSlug: "Slug",
        amenity: "Tiện ích",
        title: "Khách sạn",
        name: "Tên",
        code: "Code",
        types: "Loại",
        address: "Địa chỉ",
        star: "Hạng",
        review: "Đánh giá",
        hotline: "Hotline",
        active: "Hoạt động",
        deActive: "Ngừng hoạt động",
        isActive: "Trạng thái",
        action: "Thao tác",
        villa: "Biệt thự",
        resort: "Resort",
        condotel: "Căn hộ du lịch",
        apartment: "Chung cư",
        notspecified: "Khác",
        basicInfo: "Thông tin cơ bản",
        addressInfo: "Thông tin địa chỉ",
        images: "Hình ảnh",
        uploadFile: "Tải ảnh lên",
        uploading: "Đang tải lên",
        selectTypes: "Chọn các loại khách sạn",
        description: "Mô tả",
        country: "Quốc gia",
        province: "Tỉnh thành",
        location: "Địa điểm",
        locationOnMap: "Vị trí trên bản đồ",
        email: "Email",
        phone: "Số điện thoại",
        shortDescription: "Mô tả ngắn",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        hotelroom: "Phòng khách sạn",
        villa2bedroom: "Villa 2 Phòng ngủ",
        villa3bedroom: "Villa 3 Phòng ngủ",
        villa4bedroom: "Villa 4 Phòng ngủ",
        condotel1bedroom: "Condotel 1 Phòng ngủ",
        condotel2bedroom: "Condotel 2 Phòng ngủ",
        installmentFee: "Phí trả góp",
        installmentLimit: "Thời hạn trả góp",
        installmentFee_enum: {
          UN_KNOW: "Vui lòng chọn",
          CUS: "Khách trả phí",
          VIN: "Vinpearl trả phí",
        },
        creditPoint: "Credit Point",
        installmentLimit_enum: {
          UN_KNOW: "Vui lòng chọn",
          SIX_MONTH: "6 tháng",
          TWELVE_MONTH: "12 tháng",
          SIX_TWELVE_MONTH: "6 tháng 12 tháng",
        },
        hotelTags: {
          name: "Tags",
          isActiveListing: "Trạng thái hiển thị",
        },
        rates: {
          selectRateCode: "Thêm rate code",
          rateCodeDuplicate: "Rate code đã tồn tại",
          rateCodeMaximum: "Chỉ có thể thêm tối đa 20 rate code",
        },
        rateCompare: {
          selectRateCompare: "Thêm Rate Compare",
        },
        administrator: "Quản trị",
        hotel: "Khách sạn",
        btb: "BTB",
      },
      homestay: {
        addressHyperLink: "Hyper link địa chỉ",
        tripAdvisorLocationId: "Mã Trip Advisor",
        thumbnailTag: "Tag hình ảnh",
        urlSlug: "Slug",
        amenity: "Tiện ích",
        title: "Homestay",
        name: "Tên",
        code: "Code",
        types: "Loại",
        address: "Địa chỉ",
        star: "Hạng",
        review: "Đánh giá",
        hotline: "Hotline",
        active: "Hoạt động",
        deActive: "Ngừng hoạt động",
        isActive: "Trạng thái",
        action: "Thao tác",
        villa: "Biệt thự",
        resort: "Resort",
        condotel: "Căn hộ du lịch",
        apartment: "Chung cư",
        notspecified: "Khác",
        basicInfo: "Thông tin cơ bản",
        addressInfo: "Thông tin địa chỉ",
        images: "Hình ảnh",
        uploadFile: "Tải ảnh lên",
        uploading: "Đang tải lên",
        selectTypes: "Chọn các loại khách sạn",
        description: "Mô tả",
        country: "Quốc gia",
        province: "Tỉnh thành",
        location: "Địa điểm",
        locationOnMap: "Vị trí trên bản đồ",
        email: "Email",
        phone: "Số điện thoại",
        shortDescription: "Mô tả ngắn",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        homestayroom: "Phòng homestay",
        villa2bedroom: "Villa 2 Phòng ngủ",
        villa3bedroom: "Villa 3 Phòng ngủ",
        villa4bedroom: "Villa 4 Phòng ngủ",
        condotel1bedroom: "Condotel 1 Phòng ngủ",
        condotel2bedroom: "Condotel 2 Phòng ngủ",
        installmentFee: "Phí trả góp",
        installmentLimit: "Thời hạn trả góp",
        installmentFee_enum: {
          UN_KNOW: "Vui lòng chọn",
          CUS: "Khách trả phí",
          VIN: "Vinpearl trả phí",
        },
        creditPoint: "Credit Point",
        installmentLimit_enum: {
          UN_KNOW: "Vui lòng chọn",
          SIX_MONTH: "6 tháng",
          TWELVE_MONTH: "12 tháng",
          SIX_TWELVE_MONTH: "6 tháng 12 tháng",
        },
        homestayTags: {
          name: "Tags",
          isActiveListing: "Trạng thái hiển thị",
        },
        rates: {
          selectRateCode: "Thêm rate code",
          rateCodeDuplicate: "Rate code đã tồn tại",
          rateCodeMaximum: "Chỉ có thể thêm tối đa 20 rate code",
        },
        rateCompare: {
          selectRateCompare: "Thêm Rate Compare",
        },
        hotelroom: "Phòng khách sạn",
      },
      golf: {
        title: "Sân Golf",
        orderNo: "Thứ tự hiển thị",
        name: "Tên sân Golf",
        code: "Code",
        active: "Trạng thái",
        translations: "Phiên dịch",
        action: "Thao tác",
        basicInfo: "Thông tin cơ bản",
        images: "Hình ảnh",
        email: "Email",
        hotline: "Hotline",
        website: "Link trên trang Branding",
        shortDescription: "Mô tả ngắn ",
        description: "Mô tả chi tiết",
        addressInfo: "Thông tin địa chỉ",
        linkGoogleMap: "Link Google Map",
        // active: "Hoạt động",
        deActive: "Ngừng hoạt động",
        uploadFile: "Tải hình ảnh",
        uploading: "Đang tải lên",
        messageSyncAll:
          "Đồng bộ dữ liệu với Golf Soft sẽ ghi đè lên dữ liệu hiện tại. Xác nhận đồng bộ ?",
        updateOrder: "Cập nhật thứ tự",
        supportPayLater: "Hỗ trợ trả sau",
      },
      roomType: {
        title: "Loại phòng",
        name: "Tên",
        code: "Mã loại phòng",
        amenity: "Tiện ích",
        maxOccupancy: "Công suất phòng",
        isActive: "Hoạt động",
        action: "Thao tác",
        active: "Hoạt động",
        deactive: "Ngừng hoạt động",
        basic_info: "Thông tin cơ bản",
        media: "Hình ảnh",
        shortDescription: "Miêu tả ngắn",
        description: "Chi tiết kiểu phòng",
        extend_info: "Thông tin thêm",
        refId: "REF ID",
        features: "Feature",
        area: "Diện tích phòng",
        maxAdult: "Người lớn tối đa",
        maxChildren: "Trẻ em tối đa",
        square_unit: "Diện tích",
        square_unit_type: "Đơn vị",
        numberOfRoom: "Số lượng phòng ngủ",
        bedType: "Loại giường",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        hardblock: "Hardblock",
      },
      homestayRoomType: {
        title: "Loại phòng homestay",
        name: "Tên",
        code: "Mã loại phòng",
        amenity: "Tiện ích",
        maxOccupancy: "Công suất phòng",
        isActive: "Hoạt động",
        action: "Thao tác",
        active: "Hoạt động",
        deactive: "Ngừng hoạt động",
        basic_info: "Thông tin cơ bản",
        media: "Hình ảnh",
        shortDescription: "Miêu tả ngắn",
        description: "Chi tiết kiểu phòng",
        extend_info: "Thông tin thêm",
        refId: "REF ID",
        features: "Feature",
        area: "Diện tích phòng",
        maxAdult: "Người lớn tối đa",
        maxChildren: "Trẻ em tối đa",
        square_unit: "Diện tích",
        square_unit_type: "Đơn vị",
        numberOfRoom: "Số lượng phòng",
        bedType: "Loại giường",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      rate: {
        isIndependent: "Rate độc lập",
        onIsIndependent: "Yes",
        offIsIndependent: "No",
        isExtend: "isExtend",
        onIsExtend: "ON",
        offIsExtend: "OFF",
        title: "Rate",
        code: "Code",
        name: "Tên",
        description: "Mô tả",
        shortDescription: "Mô tả ngắn",
        descriptionPromotions: "Mô tả (Dịch vụ đính kèm)",
        descriptionTerms: "Mô tả (Điều khoản)",
        dayOfWeek: "Thời gian hoạt động",
        startTime: "Từ giờ",
        endTime: "Tới giờ",
        promotions: "Chiến dịch",
        order: "Trọng số",
        typeRate: "DC",
        translations: "Phiên dịch",
        action: "Thao tác",
        refId: "REF ID",
        address: "Địa chỉ",
        isActive: "Hoạt động",
        active: "Hoạt động",
        usageStatus: "Đồng bộ RRM",
        deactive: "Ngừng hoạt động",
        cancelPolicy: "Chính sách hoàn hủy",
        status: "Trạng thái RRM",
        confirmSync: "Bạn có chắc chắn muốn đồng bộ ?",
        titleSyncAll: "Đồng bộ tất cả dữ liệu ?",
        clearCache: "Clear Cache?",
        messageSyncAll:
          "Khi thực hiện thao tác này sẽ đồng bộ dữ liệu rate của tất cả khách sạn",
        filters: {
          hotel: "Hotel",
          bundle: "Bundle",
          active: "Hoạt động",
          deActive: "Ngừng hoạt động",
          deActiveShort: "Ngừng HĐ",
          activeUsage: "ON",
          deActiveUsage: "OFF",
          onIsIndependent: "Yes",
          offIsIndependent: "No",
        },
        cancelPolicyObject: {
          tableValue: "Bảng giá trị",
          rangeDate: "Khoảng thời gian áp dụng",
          weekdays: "Ngày trong tuần",
          daysBeforeArrival: "Số ngày trước checkin",
          amount: "Giá trị",
          type: "Đơn vị",
          action: "Sử dụng",
          valueOption: {
            flat: "Số tiền",
            percent: "%",
          },
          getNewValue: "Lấy thêm giá trị",
          sync: "Refresh",
          error: "Giá trị phải > 0",
        },
        descriptionRate: {
          icon: "Icon",
          shortDescription: "Text",
          action: "Hành động",
          add: "Add",
        },
        newRate: {
          title: "Danh sách rate",
        },
        syncRateLanguage: {
          confirmSyncLanguagePrefix: "Không tồn tại ngôn ngữ",
          confirmSyncLanguageSuffix: "Lựa chọn ngôn ngữ thay đổi cho ",
          noReplace: "Không thay thế",
        },
        rateInfo: "Thông tin Rate",
        priceConfig: {
          title: "Cấu hình giá",
          startDate: "Ngày bắt đầu",
          endDate: "Ngày kết thúc",
          roomtype: "Roomtype",
          point: "Giá trị (điểm)",
          isActive: "Trạng thái",
          action: "Thao tác",
          valueTitle: "Giá trị/đêm",
          availableTime: "Khoảng thời gian khả dụng",
          roomtyppe: "Loại phòng",
        },
      },
      homestayRate: {
        isIndependent: "Rate độc lập",
        onIsIndependent: "Yes",
        offIsIndependent: "No",
        isExtend: "isExtend",
        onIsExtend: "ON",
        offIsExtend: "OFF",
        title: "Rate",
        code: "Code",
        name: "Tên",
        description: "Mô tả",
        shortDescription: "Mô tả ngắn",
        promotions: "Chiến dịch",
        order: "Trọng số",
        typeHomestayRate: "DC",
        translations: "Phiên dịch",
        action: "Thao tác",
        refId: "REF ID",
        address: "Địa chỉ",
        isActive: "Hoạt động",
        active: "Hoạt động",
        usageStatus: "Đồng bộ RRM",
        deactive: "Ngừng hoạt động",
        cancelPolicy: "Chính sách hoàn hủy",
        refStatus: "Trạng thái RRM",
        confirmSync: "Bạn có chắc chắn muốn đồng bộ ?",
        titleSyncAll: "Đồng bộ tất cả dữ liệu ?",
        clearCache: "Clear Cache?",
        messageSyncAll:
          "Khi thực hiện thao tác này sẽ đồng bộ dữ liệu rate của tất cả khách sạn",
        status: "Trạng thái RRM",
        filters: {
          hotel: "Hotel",
          bundle: "Bundle",
          active: "Hoạt động",
          deActive: "Ngừng hoạt động",
          deActiveShort: "Ngừng HĐ",
          activeUsage: "ON",
          deActiveUsage: "OFF",
          onIsIndependent: "Yes",
          offIsIndependent: "No",
        },
        cancelPolicyObject: {
          tableValue: "Bảng giá trị",
          rangeDate: "Khoảng thời gian áp dụng",
          daysBeforeArrival: "Số ngày trước checkin",
          amount: "Giá trị",
          type: "Đơn vị",
          action: "Sử dụng",
          valueOption: {
            flat: "Số tiền",
            percent: "%",
          },
          getNewValue: "Lấy thêm giá trị",
          sync: "Refresh",
          error: "Giá trị phải > 0",
        },
        descriptionHomestayRate: {
          icon: "Icon",
          shortDescription: "Text",
          action: "Hành động",
          add: "Add",
        },
        newHomestayRate: {
          title: "Danh sách rate",
        },
        syncHomestayRateLanguage: {
          confirmSyncLanguagePrefix: "Không tồn tại ngôn ngữ",
          confirmSyncLanguageSuffix: "Lựa chọn ngôn ngữ thay đổi cho ",
          noReplace: "Không thay thế",
        },
      },
      rateCompare: {
        title: "Rate Compare",
        rateCodeCompare: "Rate gốc",
        rateCodePriority: "Rate ưu tiên hiển thị",
        note: "Ghi chú",
        action: "Thao tác",
      },
      bookablePackageRate: {
        title: "Bookable Package Rate",
        code: "Code",
        name: "Tên",
        newName: "Tên dịch vụ",
        description: "Mô tả",
        seq: "Trọng số",
        typeRate: "DC",
        translations: "Phiên dịch",
        action: "Thao tác",
        refId: "REF ID",
        address: "Địa chỉ",
        isActive: "Hoạt động",
        active: "Hoạt động",
        isActiveVPT: "Trạng thái VPT",
        usageStatus: "Đồng bộ RRM",
        deactive: "Ngừng hoạt động",
        isStatus: "Trạng thái RRM",
        confirmSync: "Bạn có chắc chắn muốn đồng bộ ?",
        transactionCode: "TCode",
        thumbImage: "Hình",
        imageLink: "Hình",
        amenityId: "Icon",
        uploadFile: "Tải hình ảnh",
        uploading: "Đang tải lên",
        calculationRule: "Calculation rule",
        postingRhythm: "Posting rhythm",
      },
      packageRate: {
        title: "Đóng gói sản phẩm",
        code: "Mã gói",
        name: "Tên gói",
        objectApplyValue: "Đối tượng áp dụng",
        channel: "Nền tảng áp dụng",
        isActive: "Trạng thái",
        bookingDatesConfig: "Ngày bán",
        stayingDatesConfig: "Ngày sử dụng",
        description: "Mô tả",
        generalInformation: "Thông tin chung",
        detailDescription: "Mô tả chi tiết",
        productList: "Danh sách sản phẩm",
        configProductSalesTime: "Cấu hình thời gian bán sản phẩm",
        configTimeUsingProduct: "Cấu hình thời gian sử dụng sản phẩm",
        addStage: "Thêm giai đoạn",
        startDate: "Ngày bắt đầu",
        stageDate: "Giai đoạn",
        endDate: "Ngày kết thúc",
        displayAdvanced: "Hiển thị nâng cao",
        onlyApplyForTime: "Chỉ áp dụng cho các khung giờ",
        onlyApplyForDaysOfWeek: "Chỉ áp dụng cho các thứ",
        advancedSearchTerms: "Tùy chỉnh điều kiện tìm kiếm nâng cao",
        searchByNight: "Tìm kiếm theo đêm",
        searchByRoom: "Tìm kiếm theo phòng",
        min: "Min",
        max: "Max",
        advancedApplicableConditions: "Điều kiện áp dụng nâng cao",
        displaySale: "Cách hiển thị bán hàng",
        hotel: "Khách sạn",
        applicablePlatform: "Nền tảng áp dụng",
        applicableObject: "Đối tượng áp dụng",
        productPackageDetail: "Mô tả chi tiết gói sản phẩm",
        titleDesc: "Title hiển thị",
        packageRateProductType: "Loại dịch vụ",
        cost: "Cost",
        markupType: "Kiểu markup",
        markupValue: "Giá trị markup",
        action: "Thao tác",
        costUndefine: "Chưa xác định",
        add: "Thêm",
        selectHotel: "Chọn khách sạn",
        selectHotelPlaceholder: "Vui lòng chọn khách sạn",
        selectRate: "Chọn rate",
        selectRatePlaceholder: "Vui lòng chọn rate",
        selectPMSSevices: "Chọn dịch vụ từ PMS",
        selectRatePlan: "Lựa chọn ratecode cấu hình",
        selectRateUpsell: "Lựa chọn Rate Upsell",
        rateCode: "Ratecode",
        rateName: "Rate name",
        selectBookables: "Chọn bookable",
        selectBookablePlaceholder: "Vui lòng chọn dịch vụ",
        selectVPTSevices: "Chọn dịch vụ từ VPT",
        selectRateCode: "Lựa chọn mã giá",
        selectRateCodePlaceholder: "Vui lòng chọn mã giá",
        confirmChangeHotel: "Xác nhận xóa sản phẩm/dịch vụ đã chọn",
        confirmChangeHotelContent1:
          "Thay đổi khách sạn sẽ làm thay đổi toàn bộ dịch vụ, sản phẩm đi cùng.",
        confirmChangeHotelContent2: "Bạn có chắc chắn chọn lại khách sạn khác?",
        confirmTitle: "Xác nhận thông tin",
        confirmChangeToInactive: "Bạn có chắc chắn muốn ngừng bán Gói sản phẩm",
        confirmChangeToActive:
          "Bạn có chắc chắn muốn tiếp tục bán Gói sản phẩm",
        confirmDelete: "Bạn có chắc chắn muốn xóa sản phẩm",
        confirmClone: "Bạn có chắc chắn muốn sao chép nội dung gói sản phẩm",
        titleContent: "Tiêu đề",
        content: "Nội dung",
        reasons: "Lý do",
        validateUsingDate: "Ngày sử dụng không được nhỏ hơn ngày mở bán",
        codeService: "Mã dịch vụ",
        nameService: "Tên dịch vụ",
        selectRoomType: "Lựa chọn roomtype",
        order: "Trọng số",
        calculationRule: "Calculation rule",
        postingRhythm: "Posting rhythm",
        information: "Thông tin hiển thị",
        filters: {
          active: "Hoạt động",
          inactive: "Ngừng hoạt động",
        },
      },
      location: {
        title: "Địa điểm",
        name: "Tên",
        code: "Mã địa điểm",
        order: "STT",
        isActive: "Hoạt động",
        isDomestic: "Nội địa",
        domesticActive: "Nội địa",
        domesticDeactive: "Quốc tế",
        action: "Thao tác",
        active: "Hoạt động",
        deactive: "Ngừng hoạt động",
        image: "Ảnh đại diện",
        uploadFile: "Tải hình ảnh",
        uploading: "Đang tải lên",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      price: {
        title: "Giá tùy chỉnh",
        name: "Tên",
        type: "Loại",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        value: "Giá trị",
        hotel: "Khách sạn",
        isActive: "Trạng thái",
        active: "Kích hoạt",
        deactive: "Ngưng kích hoạt",
        action: "Thao tác",
        applyDates: "Ngày áp dụng",
        amount: "Số tiền",
        percent: "Phần trăm",
        percentage: "Phần trăm",
      },
      popularPlace: {
        name: "Tên địa điểm",
        title: "Địa điểm nổi bật",
        isActive: "Hoạt động",
        action: "Thao tác",
        active: "Hoạt động",
        deactive: "Ngừng hoạt động",
        averagePrice: "Giá trung bình",
        numberOfVacancies: "Số lượng trống",
        order: "STT",
        uploadFile: "Tải ảnh lên",
        uploading: "Đang tải lên",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      category: {
        title: "Danh mục",
        createdDate: "Ngày tạo",
        action: "Thao tác",
        name: "Tên danh mục",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      siteinfo: {
        title: "Thông tin site",
        name: "Tên Gọi",
        key: "Key",
        value: "Giá trị",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        createdDate: "Ngày tạo",
        action: "Thao tác",
      },
      agent: {
        title: "Đại Lý",
        // id: "Mã đại lý",
        name: "Tên Đại Lý",
        email: "Email",
        phoneNumber: "Số Điện Thoại",
        taxNumber: "Số Thuế",
        address: "Địa Chỉ",
        contactFullname: "Họ tên liên lạc",
        contactEmail: "Email liên lạc",
        contactPhoneNumber: "SĐT liên lạc",
        createdDate: "Ngày tạo",
        action: "Thao tác",
      },
      page: {
        title_page: "Trang",
        title: "Tiêu đề",
        createdDate: "Ngày tạo",
        action: "Thao tác",
        urlSlug: "Địa chỉ website",
        description: "Mô tả",
        content: "Nội dung",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      post: {
        title_page: "Bài viết",
        title: "Tiêu đề",
        order: "Thứ tự",
        createdDate: "Ngày tạo",
        action: "Thao tác",
        urlSlug: "Địa chỉ website",
        description: "Mô tả",
        content: "Nội dung",
        isAvailable: "Trạng thái",
        available: "Hoạt động",
        unAvailable: "Không hoạt động",
        thumbImageView: "Ảnh đại diện",
        headerImageView: "Ảnh bài viết",
        categories: "Danh mục",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        source: "Nguồn",
      },
      flight: {
        title: "Chuyến bay",
        titleListSegment: "Danh sách điểm dừng",
        segmentEnd: "điểm dừng %n",
        overStopTime: "trong %n",
        total: "Tổng",
        totalPrice: "Tổng cộng",
        departureDate: "Ngày khởi hành",
        flightNumber: "Số hiệu chuyến bay",
        startPoint: "Ga đi",
        endPoint: "Ga đến",
        flightDuration: "Thời gian bay",
        quantity: "Số lượng",
        ticketPrice: "Giá vé",
        taxesAndFees: "Thuế & Phí",
        vptServiceFee: "Phí dịch vụ VPT",
        baggage: "Hành lý",
        priceIncludedTaxesAndFees: "Giá đã bao gồm thuế và phí",
        adult: "Người lớn",
        children: "Trẻ em",
        infant: "Trẻ sơ sinh",
        directFlight: "Bay thẳng",
        flightOverStops: "Bay qua %n điểm dừng",
        passengerInfos: "Thông tin hành khách",
        birthday: "Ngày sinh",
        email: "Email",
        gender: "Giới tính",
        lastTKDate: "Thời hạn đặt chỗ",
        message: "Nội dung",
        status: "Trạng thái",
        departureTicketNumber: "Số vé chiều đi",
        returnTicketNumber: "Số vé chiều về",
        flightStatus: {
          HELD: "Đã giữ chỗ",
          HELD_FAIL: "Giữ chỗ lỗi",
          ISSUED: "Đã xuất vé",
          ISSUE_FAIL: "Xuất vé lỗi",
        },
        genderTypesAdult: {
          1: "Ông",
          0: "Bà",
        },
        genderTypes: {
          1: "Nam",
          0: "Nữ",
        },
        phone: "Số điện thoại",
        passngerTypes: {
          ADT: "Người lớn",
          CHD: "Trẻ em",
          INF: "Trẻ sơ sinh",
        },
        baggageDeparture: "Hành lý chiều đi",
        baggageReturn: "Hành lý chiều về",
        baggageWeightUnit: "kg",
        flightOrderCode: "Mã đặt chỗ",
        markupPrice: "Lãi markup",
      },
      home: {
        title: "Trang chủ",
      },
      priceMakeup: {
        title: "Cấu hình giá",
        name: "Tên",
        type: "Loại",
        types: {
          1: "Số tiền",
          2: "Phần trăm",
        },
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        value: "Giá trị",
        applyDates: "Ngày áp dụng",
        amount: "Số tiền",
        percent: "Phần trăm",
        percentage: "Phần trăm",
      },
      report: {
        title: "Báo cáo",
        saleReport: "Báo cáo doanh thu",
        redemptionReports: "Tình hình sử dụng voucher",
        totalRevenue: "Doanh thu",
        totalOrder: "Tổng đơn hàng",
        voucherOrders: "Tổng đơn voucher",
        tourOrders: "Tổng đơn tour",
        flightOrders: "Tổng đơn chuyến bay",
        hotelOrders: "Tổng đơn khách sạn",
        createdDate: "Ngày",
        revenue: "Doanh thu",
        orderCount: "Tổng đơn hàng",
        currentDate: "Hôm nay",
        currentWeek: "Tuần này",
        currentMonth: "Tháng này",
        exportExcel: "Xuất file excel",
        groupCode: "Mã chương trình",
        groupName: "Chương trình",
        quantity: "Số lượng",
        properties: "Cơ sở",
        propertyName: "Tên cơ sở",
        saleStartDate: "Ngày mở bán",
        saleEndDate: "Ngày ngưng bán",
        originalPrice: "Giá",
        salePrice: "Giá giảm",
        openingStock: "Tồn đầu kỳ",
        increase: "Tăng trong kỳ",
        decrease: "Giảm trong kỳ",
        usedCount: "Đã dùng",
        closingStock: "Tồn cuối kỳ",
        vinWonderOrders: "Tổng đơn VinWonders",
        cashflow: "Báo cáo dòng tiền",
        orderDetailReportsBySku: "Báo cáo chi tiết sản phẩm cho SKU",
        bundleReport: "Báo cáo chi tiết sản phẩm cho Bundle",
        exportExcludeUserInfo: "Xuất file excel (Không thông tin khách hàng)",
        receiptsPayslipCreate: "Tạo phiếu thu/chi",
        exportExcelExcludeUser: "Xuất file excel (Không thông tin khách hàng)",
        collaboratorReport: "Báo cáo CTV",
        btbUseRoomReport: "Báo cáo sử dụng phòng BTB",
        orderDetailReportsByHotel: "Báo cáo chi tiết cho đơn hàng Hotel",
        btbOrderReport: "Báo cáo sử dụng phòng BTB",
      },
      rating: {
        title: "Đánh giá",
        productName: "Tên SP",
        productType: "Loại SP",
        fullName: "Tên",
        ratingValue: "Đánh giá",
        titleRating: "Tiêu đề",
        comment: "Nội dung đánh giá",
        createdDate: "Ngày tạo",
        action: "Thao tác",
        replies: "Trả lời",
        isApproved: "Đã cho phép",
        beApproved: "Đã được cho phép",
        noReply: "Không có trả lời",
        hideThisComment: "Ẩn bình luận này",
        showThisComment: "Hiển thị bình luận này",
      },
      groupCategory: {
        title: "Loại chương trình",
        name: "Tên",
        parentName: "Tên chương trình cha",
        createdDate: "Ngày tạo",
        action: "Thao tác",
        order: "Thứ tự",
        errorCode: {
          PARENT_CATEGORY_LIMITED_LEVEL:
            "Loại chương trình đã có một loại chương trình cha, giới hạn 2 cấp!",
        },
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
      },
      combo: {
        title: "Combo",
      },
      supplier: {
        title: "Nhà cung cấp",
        supplierInfoTitle: "Thông tin nhà cung cấp",
        supplierInfoDetailTitle: "Mô tả chi tiết nhà cung cấp",
        contract: {
          status: {
            signed: "Đã ký",
            unsigned: "Chưa ký",
            processing: "Đang xử lý",
          },
        },
        product: {
          type: {
            vehicle: "Phương tiện",
            accommodation: "Lưu trú",
            meal: "Ăn uống",
            activity: "Hoạt động",
          },
          typeTitle: "Nhóm sản phẩm",
          title: "Sản phẩm nhà cung cấp",
          name: "Tên sản phẩm",
          supplierTypes: "Nhóm sản phẩm",
          description: "Mô tả",
          productCode: "Mã sản phẩm",
          cost: "Giá cost",
          sellCost: "Giá bán",
          transactionCode: "Tcode",
          status: "Trạng thái",
          isActive: "Sử dụng",
          block: "Khóa",
          action: "Thao tác",
          keyList: "Thuộc tính",
          typeSupplier: "Kiểu sản phẩm",
          supplierName: "Nhà cung cấp",
          root: "Sản phẩm gốc",
          sale: "Sản phẩm bán",
          refId: "REF ID",
          productType: "Kiểu sản phẩm",
          hotel: "Danh sách khách sạn được áp dụng",
          selectAllHotel: "Chọn tất cả",
        },
        infoDetail: {
          title: "Title hiển thị",
          advisor: "Mã Trip Advisor",
          shortDescription: "Mô tả ngắn",
          mainStatus: "MainStatus",
          content: "Nội dung chi tiết",
          thumbImage: "Ảnh đại diện",
          specialImage: "Ảnh nổi bật",
          slideShowImages: "Ảnh trình chiếu",
          video: "Video",
        },
        contractStatus: "Trạng thái HĐ",
        supplierName: "Tên",
        code: "Mã",
        address: "Địa chỉ",
        email: "Email",
        logo: "Logo",
        logoImage: "Hình ảnh logo",
        noteContent: "Nội dung ghi chú",
        phoneNumber: "Số ĐT",
        taxNumber: "Mã số thuế",
        supplierSystem: "Tích hợp hệ thống nhà cung cấp",
        titleLimitDateSearchTicket: "Giới hạn ngày bán vé trên thanh tìm kiếm",
        multipleDate: "Có (chọn ngày lẻ)",
        rangeDate: "Có (chọn khoảng ngày)",
        noneDate: "Không",
        siteCode: "siteCode",
        signedDate: "Ngày ký HĐ",
        contractEndDate: "Ngày hết hạn HĐ",
        question: "Câu hỏi",
        answer: "Câu trả lời",
        linkGGMap: "Link nhúng gg map",
        linkMapGG: "Link nhúng gg map",
        action: "Thao tác",
        supplierProduct: "Sản phẩm cung cấp",
        supplierProducts: "Sản phẩm cung cấp",
        selectSupplierProducts: "Chọn sản phẩm cung cấp",
        supplierProductName: "Tên sản phẩm",
        supplierProductType: "Loại sản phẩm",
        supplierUsagePlan: "Lịch sử dụng",
        uploading: "Đang tải lên",
        uploadFile: "Tải hình ảnh",
        uploadVideo: "Tải video",
        contactFullname: "Tên liên hệ",
        contactEmail: "Email liên hệ",
        contactPhoneNumber: "Số điện thoại Liên hệ",
        contractNumber: "Số hợp đồng",
        supplierCode: "Mã nhà cung cấp",
        invalidCode: "Độ dài mã là 5 ký tự chữ và số",
        translations: "Phiên dịch",
        napasReconEmail: "Email nhận file đối soát",
        expiryMinutes: "Thời gian hết hạn thanh toán Napas (phút)",
        website: "WebSite",
        titleContent: "Tiêu đề",
        content: "Nội dung",
        productWarehouseGoodReceipts: {
          goodReceiptCode: "Lô hàng",
          quantity: "Số lượng nhập (a)",
          planedQuantity: "Đã lên kế hoạch",
          soldQuantity: "Đã bán",
          expiredQuantity: "Đã hết hạn (c)",
          availableQuantity: "Khả dụng = a - (b+c)",
          usedQuantity: "Đã sử dụng (b)",
          usedTime: "Thời gian sử dụng",
          sold: "Đã bán",
          used: "Đã sử dụng",
          plan: "Lịch sử dụng",
        },
      },
      ticket: {
        title: "Ticket chăm sóc khách hàng",
        ticket: "Ticket",
        ticketName: "Tên ticket",
        actionType: "Loại thành động",
        actionTypes: {
          unknow: "Không rõ",
          assign: "Giao",
          changeStatus: "Đổi trạng thái",
        },
        priority: "Ưu tiên",
        priorities: {
          unknow: "Không rõ",
          lowest: "Thấp nhất",
          low: "Thấp",
          medium: "Trung bình",
          high: "Cao",
          highest: "Cao nhất",
        },
        status: "Trạng thái",
        statusTypes: {
          unknow: "Không rõ",
          active: "Kích hoạt",
          processing: "Đang tiến hành",
          hold: "Giữ",
          close: "Đóng",
        },
        orderCode: "Mã đơn hàng",
        contactInfo: "Thông tin liên lạc",
        contactName: "Thành viên",
        contactEmail: "Email",
        contactPhone: "Điện thoại",
        assigner: "Người giao",
        assignee: "Người được giao",
        product: "Sản phẩm",
        createdDate: "Ngày tạo",
        openedTime: "Thời gian mở",
        closedTime: "Thời gian đóng",
        contactFirstName: "Họ",
        contactLastName: "Tên",
        notes: "Ghi chú",
        action: "Thao tác",
        errorCode: {
          ORDER_NOT_FOUND: "Không tìm thấy đơn hàng",
          WORKFLOW_CONFIGURATION_NOT_FOUND: "Không tìm thấy cấu hình",
        },
        myTickets: "Phiếu của tôi",
        user: "Thành viên",
        orderItemType: "Loại đơn hàng",
        workSession: "Phiên làm việc",
        assignedDays: "Ngày được giao",
        isDisabled: "Tắt",
        isEnabled: "Bật",
        ticketAssignConfigs: "Cấu hình giao ticket",
        sunday: "Chủ Nhật",
        monday: "Thứ Hai",
        tuesday: "Thứ Ba",
        wednesday: "Thứ Tư",
        thursday: "Thứ Năm",
        friday: "Thứ Sáu",
        saturday: "Thứ Bảy",
        allDay: "Tất cả ngày",
      },
      ratecode: {
        ratecodeInfo: "Thông tin mã giá",
        listSchedule: "Danh sách lịch trình",
        surchargeCategory: "Nhóm phụ thu",
        title: "Mã giá",
        campaign: "Nhóm chương trình",
        name: "Tên mã giá",
        code: "Code",
        cost: "Tổng tiền",
        rounding: "Làm tròn",
        sellCost: "Thành tiền",
        sellCostTitle: "Giá bán làm tròn",
        adult: "Người lớn",
        child: "Trẻ em",
        room: "Phòng",
        lengOfStay: "Lịch trình",
        description: "Nội dung",
        isActive: "Trạng thái",
        action: "Thao tác",
        active: "Sử dụng",
        deactive: "Khóa",
        codeTitle: "Code mã giá",
        numberNight: "Số đêm",
        typeGroupSupplier: "Áp dụng cho nhóm sản phẩm",
        typeGroupSupplierBasic: "Sản phẩm Không tích hợp",
        typeGroupSupplierVinwonder: "Sản phẩm có tích hợp",
        minimumUnitConfiguration: "Cấu hình đơn vị tối thiểu",
        rateCodeProducts: "Cấu phần",
        rateCodeProduct: "Mã con",
        productTypes: "Nhóm sản phẩm",
        lock: "Khóa mã giá",
        unLock: "Mở khóa mã giá",
        invalidCode: "Độ dài code mã giá tối thiểu 3 và tối đa 5 kí tự",
        invalidCodeUpdate: "Độ dài code mã giá tối thiểu 3 và tối đa 9 kí tự",
        stockAvailable: "Khả dụng",
        translateSetting: "Cài đặt đa ngôn ngữ",
        slotServices: "Dịch vụ có suất đính kèm",
        syncSlotServices: "Sync slot services",
        syncSlotServicesSuccess: "Đồng bộ dịch vụ có suất đính kèm thành công",
        notes:
          "Notes: Mã giá bán theo từng ngày sẽ phụ thuộc vào số lượng khả dụng đã được setup theo kế hoạch bán tại sản phẩm nhà cung cấp. Nếu bạn muốn thay đổi số lượng bán ở mã giá, vui lòng thay đổi số lượng tại phiếu nhập kho sản phẩm NCC",
        product: {
          name: "Sản phẩm",
          inventoryDeliveryType: "Phương thức xuất kho",
          inventoryDeliveryTypes: {
            EachDaySchedule: "Mỗi ngày trong lịch trình",
            FirstAndLastSchedule: "Ngày đầu và ngày cuối lịch trình",
            EachNightSchedule: "Mỗi đêm trong lịch trình",
            FirstDaySchedule: "Ngày đầu lịch trình",
          },
          cost: "Giá thành",
          coefficient: "Hệ số",
          interest: "Lãi",
          sellCost: "Thành tiền",
          action: "Thao tác",
          supplier: "Nhà cung cấp",
          typeProduct: "Nhóm sản phẩm",
          product: "Sản phẩm",
          value: "Hệ số",
          add: "Add",
        },
        stockAvailables: {
          supplierProductId: "",
          createAvailable: "Số lượng cấu thành",
          stockAvailable: "Số lượng khả dụng",
        },
        errorSellCost: "Tiền làm tròn chưa hợp lệ",
        rateCodeWarehouseGoodReceipts: {
          usagePlan: "Kế hoạch sử dụng mã giá",
        },
      },
      supplierCategory: {
        title: "Nhóm sản phẩm",
        name: "Tên",
        code: "Mã",
        categoryKeys: "Thuộc tính",
        action: "Thao tác",
        nameCate: "Tên nhóm sản phẩm",
        codeCate: "Mã nhóm sản phẩm",
        descriptionCate: "Mô tả nhóm sản phẩm",
        invalidCode: "Độ dài code mã giá tối thiểu 3 và tối đa 5 kí tự",
        add: "Add",
        keyList: {
          code: "Code",
          name: "Name",
          type: "Type",
          action: "Thao tác",
          content: "Nội dung",
        },
        isKeyListDuplicate: "Mã Keylist đã được thêm",
      },
      exchangeRate: {
        title: "Tỷ giá",
        currencies: {
          VND: "Việt Nam Đồng",
          USD: "Đô La Mỹ",
          KRW: "Won Hàn Quốc",
          WON: "Won Hàn Quốc",
        },
        exchangeRateTo: "Sang",
        currencySymbols: {
          VND: "đ",
          USD: "$",
          KRW: "₩",
          WON: "₩",
        },
      },
      emailTemplate: {
        title: "Mẫu email CSKH",
        titleEmail: "Tiêu đề email",
        status: "Trạng thái",
        isActived: "Hoạt động",
        isUnactived: "Ngừng hoạt động",
        content: "Nội dung",
        action: "Tháo tác",
        contentViewHtml: "Hiển thị mã HTML",
        note: "Ghi chú",
      },
      airport: {
        title: "Sân bay",
        id: "Mã sân bay",
        IATA: "Mã sân bay IATA",
        ICAO: "Mã sân bay ICAO",
        name: "Tên sân bay",
        cityId: "Mã thành phố",
        cityName: "Tên Thành phố",
        countryId: "Mã vùng",
        countryName: "Tên nước",
        isDomestic: "Loại",
        createdDate: "Ngày tạo",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        order: "Trọng số",
        provinceName: "Tên tỉnh thành",
        action: "Thao tác",
        isDisplay: "Vị trí hiển thị tìm kiếm",
        airportCode: "Mã sân bay",
        airportName: "Tên sân bay",
        cityCode: "Thành phố",
        hide: "Không hiển thị",
        show: "Hiển thị",
        departureAirport: "Điểm đi",
        returnAirport: "Điểm đến",
        selectToAirport: "Chọn chặng bay đến",
        toAirportList: "Danh sách chặng bay đến",
      },
      fareRule: {
        title: "Điều kiện vé",
        airlineCode: "Mã hàng không",
        className: "Hạng vé",
        cancellationRefund: "Hủy hoàn Tiền",
        timeChange: "Thay đổi thời gian",
        itineraryChange: "Thay đổi hành trình",
        passengerInfoChange: "Thay đổi thông tin hành khách",
        remarks: "Lưu ý",
        translations: "Phiên dịch",
        action: "Thao tác",
      },
      baggage: {
        title: "Hành lý",
        airlineCode: "Mã hàng không",
        class: "Hạng vé",
        handBaggage: "Hành lý xách tay",
        baggageAllowance: "Hành lý ký gửi miễn cước",
        isDomestic: "Loại",
        action: "Thao tác",
        domestic: "Trong nước",
        international: "Quốc Tế",
      },
      vinWonder: {
        title: "VinWonder",
        statusText: "Trạng thái",
        limitNumberOfSalesPerUser: "Giới hạn số lượng mua",
        ticketType: "Loại vé",
        serialNumber: "Series vé",
        salePrice: "Giá bán",
        order: "Trọng số",
        available: "Trạng thái",
        name: "Tên",
        siteCode: "Địa điểm",
        type: "Kiểu sản phẩm",
        isAvailable: "Hiệu lực",
        isUnAvailable: "Không hiệu lực",
        isSpecial: "Nổi bật",
        isHot: "bán chạy",
        highLight: "Điểm nổi bật",
        siteCodeString: "Site Code String",
        conditionOfUse: "Điều khoản sử dụng",
        description: "Mô tả",
        saleStartDate: "Ngày mở bán",
        saleEndDate: "Ngày Ngừng bán",
        images: "Hình ảnh (Tối đa 5 tấm)",
        action: "Thao tác",
        status: "Trạng thái",
        limitNumberOfTimes: "Số lần sử dụng",
        shortDescription: "Mô tả ngắn",
        thumbImage: "Ảnh đại diện",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        createdDate: "Ngày tạo",
        urlSlug: "Đường dẫn website",
        operationManuals: "Hướng dẫn vận hành",
        acceptcheck: "* Tôi xác nhận đã kiểm tra thông tin",
        acceptInfo: "Vui lòng xác nhận thông tin",
        vinWonderCode: "Mã VinWonder",
        showInfo: {
          info: "1. Thông tin chung",
          available: "2. Hiệu lực",
          condition: "3. Điều kiện",
          introduce: "4. Giới thiệu",
        },
        vinWonderName: "Tên",
        vinWonderTicketName: "Vé",
        usingDate: "Ngày sử dụng",
        adult: "Người lớn",
        children: "Trẻ em",
        child: "Trẻ em",
        senior: "Người cao tuổi",
        price: "Tổng tiền",
        blackOutStartDate: "Ngày bắt đầu đóng",
        blackOutEndDate: "Ngày kết thúc đóng",
        blackOutReason: "Lý do đóng",
        dateOfBirth: "Ngày sinh",
        placeOfBirth: "Nơi sinh",
        email: "Email",
        fullName: "Tên đầy đủ",
        identityTypeName: "Loại định danh",
        identityDetail: "Mã định danh",
        nationalityName: "Quốc tịch",
        phone: "SĐT",
        sex: "Giới tính",
        zoneReleaseName: "Điểm trả",
        zonePickupName: "Điểm đón",
      },
      vinWonderTickets: {
        title: "VinWonder Ticket",
        name: "Tên",
        isAvailable: "Hiệu lực",
        isUnAvailable: "Không hiệu lực",
        descriptions: "Mô tả",
        shortDescriptions: "Mô tả ngắn",
        ticketCode: "Mã vé",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        createdDate: "Ngày tạo",
        action: "Thao tác",
        available: "Trạng thái",
      },
      vinWonderTicketItem: {
        title: "Hạng vé",
        ticketType: "Loại vé",
        rateCode: "Rate code",
        refId: "REF ID",
        originalPrice: "Giá",
        salePrice: "Giá bán",
        action: "Thao Tác",
      },
      vinWonderPrice: {
        title: "Giá tùy chỉnh",
        name: "Tên",
        type: "Loại",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        value: "Giá trị",
        active: "Kích hoạt",
        deactive: "Ngưng kích hoạt",
        action: "Thao tác",
        applyDates: "Ngày áp dụng",
        amount: "Số tiền",
        percent: "Phần trăm",
        percentage: "Phần trăm",
        money: "Tiền",
      },
      checkVinWonder: {
        title: "Kiểm tra VinWonder",
        info: "Thông tin chung",
        infoVW: "Thông tin VinWonder",
        infoTicket: "Thông tin khách hàng",
        checkCode: "Nhập Series vé để tra cứu tình trạng sử dụng",
        siteCode: "Địa điểm",
        vinWonderName: "Tên",
        vinWonderTicketName: "Tên vé",
        ticketType: "Loại vé",
        serialNumber: "Mã VinWonder",
        usingDate: "Ngày sử dụng",
        statusCode: "Trạng Thái",
        fullname: "Họ tên",
        email: "Email",
        phoneNumber: "Số điện thoại",
        enumStatus: {
          0: "Chờ kích hoạt",
          1: "Đang hoạt động",
          2: "Bị khóa",
          3: "Đã sử dụng",
          4: "Thẻ đang được nạp chờ",
        },
      },
      tagSearch: {
        groupTag: "Nhóm tag tìm kiếm",
        tags: "Tags",
        titleAddTag: "Thêm tags",
        tagName: "Chọn tags để thêm",
        tagGroupTypes: {
          undefined: "Nhóm không xác định",
          1: "Nhóm tag tìm kiếm",
          2: "Nhóm tag thông tin",
          3: "Nhóm tag Vinwonder",
          4: "Nhóm tag Ratefilter",
        },
      },
      surcharge: {
        status: {
          active: "Hiệu lực",
          deactive: "Không hiệu lực",
          delete: "Đã hủy",
        },
        isDeleted: "Trạng thái",
        ftCode: "FT Code",
        title: "Phụ thu",
        id: "Mã phụ thu",
        orderId: "Mã đơn hàng",
        name: "Nội dung phụ thu",
        surchargeType: "Loại phụ thu",
        paymentType: "Hình thức thanh toán",
        paymentDate: "Ngày thanh toán",
        operaBookingCode: "Mã Booking",
        transactionId: "Mã giao dịch",
        amount: "Số tiền (VNĐ)",
        fieldAmount: "Số tiền",
        note: "Ghi chú",
        action: "Thao tác",
        rateCodes: "Danh sách mã giá",
        modalSurchage: {
          title: "Hủy phụ thu",
          message:
            "Khi hủy phụ thu, hệ thống sẽ tạo phiếu phải chi tự động dựa trên chính xác mã giá đã tạo phụ thu",
        },
        pmsTransactionCode: "Transaction code",
        surchargeId: "Id phụ thu",
        isTCodeValid: "Code khả dụng",
        valid: "Khả dụng",
        invalid: "Không khả dụng",
      },
      bundleOrderSurcharge: {
        status: {
          active: "Hiệu lực",
          deactive: "Không hiệu lực",
          delete: "Đã hủy",
        },
        isDeleted: "Trạng thái",
        ftCode: "FT Code",
        title: "Phụ thu",
        id: "Mã phụ thu",
        orderId: "Mã đơn hàng",
        name: "Nội dung phụ thu",
        surchargeType: "Kiểu phụ thu",
        author: "Admin thực hiện",
        createdDate: "Ngày tạo",
        paymentType: "Hình thức thanh toán",
        paymentDate: "Ngày thanh toán",
        operaBookingCode: "Mã Booking",
        transactionId: "Mã giao dịch",
        amount: "Tổng số tiền",
        totalSurchargeAmount: "Tổng tiền phụ thu",
        fieldAmount: "Số tiền",
        note: "Ghi chú",
        action: "Thao tác",
        rateCodes: "Danh sách mã giá",
        modalSurchage: {
          title: "Hủy phụ thu",
          message: "Đảm bảo đã thu được tiền của khách và có sẵn FT code",
          totalSurchargeCost: "Tổng tiền hủy phụ thu",
        },
        pmsTransactionCode: "Transaction code",
        surchargeId: "Id phụ thu",
        isTCodeValid: "Code khả dụng",
        valid: "Khả dụng",
        invalid: "Không khả dụng",
        createdBy: "Admin thực hiện",
        rowIndex: "ID",
      },
      changeRateCode: {
        title: "Chọn mã giá thay thế",
        contentChange: "Tiến hành đổi sản phẩm",
        from: "Từ",
        to: "Sang",
        search: "Tìm kiếm mã giá",
        searchCampaign: "Chương trình",
        note: "Lưu ý",
        noteContent:
          "Việc thay đổi sản phẩm gốc hệ thống sẽ hủy sản phẩm cũ, chuyển toàn bộ thanh toán từ sản phẩm cũ sang sản phẩm mới. Hệ thống sẽ cân đối và yêu cầu nhập liệu phần tiền còn thiếu",
        noteContentChangeRateCode:
          "Thay đổi từ một mã giá sang nhiều hơn một mã giá hệ thống yêu cầu tạo nhanh mã giá thay thế",
        cashFlow: "Dòng tiền phát sinh",
        name: "Sản phẩm",
        code: "Mã giá",
        cashFlow: "Dòng tiền",
        sellCost: "Order",
        cancelCashFlow: "Hủy chuyển",
        changeCashFlow: "Đổi sp cost",
        inputFt: "Input FT thực thu",
        errorFT: "Cần nhập mã FT",
        roundRadio: "",
        newIssueCostAmount: "Số tiền cost phát sinh mới: {{cost}}",
        additionalPayment: "Thanh toán thêm",
        nonAdditionalPayment: "Không thanh toán thêm",
        quicklyCreateANewPriceCode: "Tạo nhanh mã giá mới",
        newCodePrice: "Code mã giá mới",
        nameNewCode: "Tên mã giá mới",
        totalPrice: "Tổng tiền: {{totalPrice}}",
        salePriceRounding: "Giá bán làm tròn",
        priceRounding: "Làm tròn: {{priceRounding}}",
      },
      experience: {
        title: "Trải nghiệm",
        indexSKUs: "Chỉ mục tất cả sản phẩm",
        unauthorized: "Tài khoản không có quyền thực hiện thao tác!",
      },
      productFeed: {
        title: "Product Feed",
        unauthorized: "Tài khoản không có quyền thực hiện thao tác!",
      },
      tagGroupDetails: {
        title: "Thông tin nhóm thẻ",
        name: "Tên thẻ",
        review: "Xem trước",
        order: "Trọng số",
        translations: "Phiên dịch",
        action: "Thao tác",
        color: "Màu chữ",
        bgColor: "Màu nền",
        linkedSkus: "SKUs đã link",
        linkSkus: "Link SKUs",
        tagGroup: "Nhóm thẻ",
        tagGroupId: "Thuộc nhóm thẻ",
        skuAvailable: "SKUs có sẵn",
        skuSelected: "SKUs đã chọn",
        rateTagAvailable: "Rates có sẵn",
        rateTagSelected: "Rates đã chọn",
        status: "Trạng thái",
        active: "Kích hoạt",
        deactive: "Ngưng kích hoạt",
        tagGroupTypes: {
          undefined: "Nhóm không xác định",
          1: "Nhóm thẻ Filter",
          2: "Nhóm thẻ Tag",
          3: "Nhóm thẻ Vinwonder",
          4: "Nhóm thẻ RateFilter",
        },
        rateTag: "Rate tags",
      },
      bundle: {
        loyaltyCampaignCode: "Mã chiến dịch Loyalty",
        loyaltyBenefitCode: "Benefit code",
        loyaltyCampaignCode: "Mã liên kết Loyalty",
        tabBundleTitle: "Nhóm khuyến mãi",
        tabPromotionTitle: "Code khuyến mãi",
        campaignCode: "Mã chiến dịch",
        campaignName: "Tên chiến dịch",
        code: "Mã nhóm khuyến mãi",
        name: "Tên nhóm khuyến mãi",
        count: "Số lượng code",
        usedCount: "Đã sử dụng",
        rangeDate: "Thời gian sử dụng",
        isActive: "Trạng thái",
        expiredDate: "Ngày hết hạn",
        createdDate: "Ngày tạo",
        createdUserName: "Người tạo",
        action: "Thao tác",
        cardExpired: "Theo hạn thẻ",
        voucherExpired: "Theo hạn voucher",
        timeToApplyType: "Thời gian áp dụng",
        all: "Tất cả các ngày trong thời gian quy định",
        some: "Áp dụng khoản thời gian nhất định",
        campaign: "Loại chiến dịch",
        inputName: "Tên nhóm muốn tạo",
        usedDate: "Ngày bắt đầu dùng code",
        stayDate: "Ngày bắt đầu lưu trú",
        campaignDate: "Thời gian chiến dịch",
        title: "nhóm khuyến mãi",
        activated: "Đang hoạt động",
        deactivated: "Ngừng hoạt động",
        maxCountInput: "Số lượng tối đa có thể nhập:",
        productType: "Loại sản phẩm:",
        rangeStayDate: "Thời gian lưu trú",
        promotionCode: "Mã khuyến mãi",
        maxCountCode: "Số lượng mã khuyến mãi tối đa:",
        selectPromotionCode: "Thêm mã khuyến mãi",
        selectedPromotionCode: "Thêm {0} mã khuyến mãi",
        promotionCodeNotValid:
          "Mã khuyến mãi không hợp lệ (4 - 20 ký tự) hoặc quá số lượng cho phép",
        importFailed: "Vui lòng kiểm trả dữ liệu lỗi",
        importFailedRow: "Dòng",
        importFailedError: "Lỗi:",
        totalRowInFile: "Số dòng dữ liệu trong tập tin:",
        totalRowValid: "Số dòng dữ liệu hợp lệ:",
        totalRowInvalid: "Số dòng dữ liệu lỗi:",
        promotionCodeDuplicate: "Mã khuyến mãi đã tồn tại",
                loyaltyCodeDateRestriction: "Giới hạn ngày sử dụng mã theo Loyalty",
                promotionCodeDateRestriction: "Giới hạn ngày sử dụng mã Promotion",
                dateRestriction: "Giới hạn ngày sử dụng",
                dateRestrictionType: {
                    byOddDays: "Theo ngày lẻ",
                    byDateRange: "Theo khoảng ngày",
                    byDayOfWeek: "Theo ngày trong tuần",
                },
                noDateRestriction: "Không giới hạn ngày sử dụng",
                choose: "Chọn ",
                applyDates: "ngày áp dụng",
                applyDateRanges: "khoảng thời gian áp dụng",
                applyDaysOfWeek: "ngày trong tuần áp dụng",
                addStage: "Thêm giai đoạn",
                deleteAll: "Xoá tất cả"
      },
      cashFlow: {
        searchOrderCode: "Tìm theo mã đơn hàng",
        orderCode: "Mã đơn hàng",
        productCode: "Mã sản phẩm",
        ticketCode: "Mã vé",
        rateCode: "Mã giá",
        ticketSerial: "Vé đối tượng",
        checkCode: "Mã kiểm tra",
        transactionCode: "TransactionCode",
        transactionName: "TransactionName",
        action: "Action",
        postDate: "PostDate",
        name: "Name",
        orderDebit: "Order (Debit)",
        paymentCredit: "Payment (Credit)",
        account: "Tài khoản",
        property: "Nhà cung cấp",
        ftCode: "FTcode",
        onePayCode: "OnePayCode",
        pRefId: "pRefID",
        note: "Note",
        orderType: "OrderType",
        userInfo: "UserInfomation",
        status: "Status",
        refId: "Mã tham chiếu",
        redeemProperty: "Cơ sở sử dụng",
        identity: "Identity",
        totalAmount: "Tổng tiền",
        amount: "Số tiền",
        titleViewPopup: "Xem dòng tiền theo mã đơn hàng",
        title: "phiếu thu/chi",
      },
      recommendation: {
        tagTab: "User - Tag",
        prodTab: "User - Product",
        user: "User",
        0: "Top 1",
        1: "Top 2",
        2: "Top 3",
        3: "Top 4",
        4: "Top 5",
        5: "Top 6",
      },
      collaboratorReport: {
        title: "Báo cáo cộng tác viên",
        crosscheckpms: "Cross check PMS",
        topupPoint: "Topup điểm",
        export: "Export báo cáo",
        name: "Tên CTV",
        email: "Email",
        phoneNumber: "SĐT",
        orderCode: "Đơn hàng",
        status: "Trạng thái đơn hàng",
        createdDate: "Ngày bán",
        departureDate: "Ngày CO",
        orderAmount: "Giá trị đơn hàng",
        orderCumulativeCode: "Mã tích điểm",
        orderCumulativeAmount: "Giá trị tích lũy",
        checkOutPms: "CrossCheck PMS",
        isAccumulated: "TT tích điểm",
        orderStatus: {
          Failed: "Không thành công",
          Success: "Thành công",
          PartiallyCancelled: "Đã hủy 1 phần",
          Cancelled: "Đã hủy",
          PartiallyRefunded: "Đã hoàn 1 phần",
          Refunded: "Đã hoàn",
          Waiting: "Chờ xử lý",
        },
      },
      configSourceFlight: {
        ticketVieJet: "Vé Vietjet",
        vieJet: "Nguồn trực tiếp từ Vietjet",
        dataCom: "Nguồn lấy qua đối tác DataCom",
      },
      btbOrderReport: {
        title: "Báo cáo đơn hàng BTB",
        hotelName: "Khách sạn",
        fullname: "Họ tên người đặt",
        email: "Email người đặt",
        phoneNumber: "SĐT người đặt",
        transactionDate: "Ngày đặt",
        arrivalDate: "Ngày CI",
        titleArrivalDate: "Ngày đến",
        departureDate: "Ngày CO",
        stayNight: "Số đêm",
        villaOwnerCode: "Mã căn sử dụng",
        itineraryNumber: "Mã hành trình",
        roomConfirmationNumber: "Mã xác nhận",
        roomTypeName: "Loại phòng",
        ratePlanCode: "Rate",
        fullnameCustomer: "Khách chính",
        total: "Điểm thanh toán",
        export: "Xuất file Excel",
      },
      btbUseRoomReport: {
        title: "Báo cáo sử dụng phòng BTB",
        export: "Export báo cáo",
        Date: "Ngày",
      },
      vinwondertaggroup: {
        nameVI: "Tên tab hiển thị (tiếng Việt)",
        code: "Code (giá trị parameter trên URL)",
        nameEN: "Tên tab hiển thị (tiếng Anh)",
        nameKO: "Tên tab hiển thị (tiếng Hàn)",
        nameZh: "Tên tab hiển thị (tiếng Trung)",
        nameRu: "Tên tab hiển thị (tiếng Nga)",
        nameHI: "Tên tab hiển thị (tiếng Ấn)",
        applyForSuppliers: "Áp dụng trên các NCC",
        filterFollowSupplier: "Filter theo NCC",
        name: "Tên",
        codeIndex: "Code",
        supplierNamesConfiged: "Nhà cung cấp đã link",
        totalSkuConfiged: "SKUs đã link",
        isActive: "Trạng thái",
        action: "Thao tác",
        translations: "Phiên dịch",
        orderCode: "Thứ tự hiển thị",
        nameFollowSupplier: "Tên hiển thị",
        isDefault: "Mặc định",
        siteType: "Hiển thị cho trang",
      },
      fnb: {
        outlet: {
          propertyName: "Cơ sở",
          outletName: "Nhà hàng",
          code: "Code",
          active: "Trạng thái",
          inactive: "Ngừng hoạt động",
          translations: "Phiên dịch",
          action: "Thao tác",
        },
        menu: {
          code: "Menu code",
          name: "Menu name",
          outlet: "Outlet",
          translations: "Phiên dịch",
          status: "Trạng thái",
          active: "Hoạt động",
          inactive: "Không hoạt động",
          image: "Hình ảnh"

        },
        menuItem: {
          code: "Mã item",
          name: "Tên item",
          tags: "Tags",
          closeItem: "Đóng bán",
          closeItemInternal: "Đóng bán nội bộ",
          salePrice: "Giá bán",
          description: "Mô tả",
          active: "Có",
          inactive: "Không",
          unauthorized: "Tài khoản không có quyền thực hiện thao tác!",
        },
        condiment: {
          name: "Tên",
          code: "Mã",
          status: "Trạng thái",
          active: "Hoạt động",
          inactive: "Không hoạt động",
          image: "Hình ảnh",
          translations: "Phiên dịch",
          action: "Thao tác",
          min: "Min",
          max: "Max",
          minSelection: "Min selection",
          maxSelection: "Max selection",
        },
        menuGroup: {
          groupCode: "Mã nhóm",
          groupName: "Tên nhóm",
          translations: "Phiên dịch",
          status: "Trạng thái",
          active: "Hoạt động",
          inactive: "Không hoạt động",
        },
        option: {
          name: "Name",
          code: "Code",
          translations: "Phiên dịch",
        },
        product: {
          name: "Tên",
          code: "Mã",
          shortName: "Tên ngắn",
          totalPrice: "Giá",
          translations: "Phiên dịch",
          status: "Trạng thái",
          action: "Thao tác",
        },
        outlet: {
          propertyName: "Cơ sở",
          name: "Tên nhà hàng",
          code: "Mã",
          active: "Hoạt động",
          inactive: "Không hoạt động",
          translations: "Phiên dịch",
          action: "Thao tác",
          status: "Trạng thái",
        },
      },
    },
    orderGolf: {
      info: "Thông tin Tee Time & người chơi",
      teeTime: "Tee Time",
      infoItem: "Thông tin người chơi",
      date: "Ngày chơi",
      time: "Giờ phát bóng",
      golf: "Sân Golf",
      courtType: "Loại sân",
      holes: "Số lỗ",
      teeBox: "Điểm phát bóng",
      numberPlayer: "Số người chơi",
      customerType: "Loại khách",
      customerName: "Tên khách",
      customerCode: "MCode",
      voucherCode: "Mã Voucher",
      voucherAmount: "Phụ thu Voucher",
      amount: "Thành tiền",
      no: "STT",
      paymentInfo: "Chi tiết thanh toán",
      cashBeforePromotion: "Thành tiền trước khuyến mại",
      useVoucher: "Sử dụng Voucher (dành cho Đại lý)",
      countVC: "Số Voucher đã sử dụng",
      surcharge: "Phụ thu",
      deposit: "Trừ tài khoản Deposit (dành cho Đại lý)",
      total: "Tổng tiền",
      category: "Hạng mục",
      serviceType: "Loại dịch vụ",
    },
  },
  en: {
    titLng: "Tiếng Anh",
    lang: "en",
    notfound: "Không tìm thấy trang",
    welcome: "Chào mừng bạn đến với VinFast",
    title: "VinFast",
    currency: "USD",
    currencySymbol: "$",
    login: "Đăng nhập",
    logout: "Đăng Xuất",
    validation: {
      code: "Vui lòng nhập đúng định dạng code",
      email: "Vui lòng nhập đúng email",
      password:
        "Mật khẩu gồm ký tự thường, ký tự viết hoa, ký tự số, ký tự đặt biệt và trên 6 ký tự",
      image: "File phải là hình",
      video: "File phải là video",
      required: "Dữ liệu không được rỗng",
      requiredImage: "Vui lòng chọn hình",
      string: "Dữ liệu phải là ký tự",
      number: "Dữ liệu phải là số",
      priceRequired: "Vui lòng nhập giá",
      invalidDate: "Ngày tháng không hợp lệ",
      salePriceLessThenPrice: "Giá giảm phải thấp hơn giá gốc",
      maxImage: "Tối đa 5 tấm hình",
      passwordRequired: "Mật khẩu không được rỗng",
      currentPasswordRequired: "Mật khẩu cũ không được rỗng",
      newPasswordRequired: "Mật khẩu mới không được rỗng",
      confirmPasswordRequired: "Mật khẩu xác nhận không được rỗng",
      usernameRequired: "Tài khoản không được rỗng",
      usernameOrPasswordNotMatch: "Tài khoản hoặc mật khẩu không đúng",
      userLocked: "Sai thông tin đăng nhập hoặc tài khoản bị khoá",
      connectFail: "Kết nối bị lỗi, máy chủ không phản hồi!",
      voucherInvalid: "Mã số voucher không hợp lệ",
      userNameExists: "Tài khoản đã tồn tại!",
      uploadFail: "Tải tập tin không thành công",
      percent: "Không được quá 100%",
      minOrderValue: "Dữ liệu phải nhỏ hơn đơn hàng tối đa",
      maxPhone: "Không được quá 12 ký tự",
      minPhone: "Dữ liệu phải từ 8 ký tự trở lên",
      minpassword: "Dữ liệu phải từ 6 ký tự trở lên",
      quantity: "Số lượng ít nhất là 1",
      LessThenZero: "Dữ liệu phải lớn hơn 0",
      MinValue: "Dữ liệu phải lớn hơn",
      isPhone: "Vui lòng nhập đúng số điện thoại",
      isSpecialString: "Vui lòng không nhập ký tự đặc biệt",
      isUrl: "Vui lòng nhập đúng đường dẫn",
      recaptcha: "Vui lòng xác nhận trước khi đăng nhập",
      comparePassword: "Mật khẩu xác nhận không trùng khớp",
      checkForm: "Vui lòng kiểm tra lại dữ liệu",
      validateNotePromotion: "Ghi chú không được để trống",
      queryWithTime30Days: "Mỗi lần tìm kiếm tối đa 30 ngày",
      statusCode: {
        code: {
          200: "Tải dữ liệu thành công",
          201: "Tạo thành công",
          204: "Sửa dữ liệu thành công",
          400: "Truy xuất không hiệu lực nhé",
          401: "Bạn chưa đăng nhập!",
          403: "Bạn chưa được cấp quyền vào trang này!.",
          404: "Không tìm thấy trang",
          408: "Lỗi kết nối đến máy chủ, vui lòng thử lại sau.",
          500: "Đã có lỗi xảy ra. Vui lòng liên hệ với admin hệ thống để được hỗ trợ. Xin cám ơn",
          1: "Bắt buộc phải nhập dữ liệu",
          2: "Dữ liệu phải là số",
          3: "Dữ liệu quá giới hạn",
          1403: "Tài khoản hoặc mật khẩu không hợp lệ",

          RATE_DESCRIPTION_PROMOTIONAL_REQUIRED: "Description (Promotional) must not empty",
          RATE_DESCRIPTION_TERMS_CONDITIONS_REQUIRED: "Description (Terms Conditions) must not empty",
          TICKET_TOUR_PRICE_REQUIRED: "%s hoặc %f phải lớn hơn 0",
          ACTIVATED_BUNDLE: "Are you sure want to activated %s",
          DEACTIVATED_BUNDLE: "Are you sure want to deactivated %s",
          PROMOTION_CODE_EXISTED: "Mã khuyến mãi đã tồn tại",
          EXCEEDED_NUMBER_OF_CODE: "Mã khuyến mãi vượt quá số lượng cho phép",
          VIN_WONDER_SITECODE_NOT_FOUND: "Cannot find vin wonder sitecode ",
          RECOMMIT_TOURS_SEATS_IS_OUT_OF_STOCK:
            "Số lượng tour hiện tại không khả dụng",
          RECOMMIT_APPLY_FOR_ALL_ORDER_ITEMS_FAILED_ONLY:
            "Trạng thái các đơn hàng không khả dụng",
          RECOMMIT_APPLY_ORDER_TOUR_ONLY:
            "Chỉ khả dụng đối với đơn hàng tour đã thanh toán và trạng thái đơn hàng không thành công",
          APPLY_PROMOTION_FAILED: "Mã khuyến mãi không hợp lệ",
          ACTION: "Bạn có chắc chắn thực hiện hành động này",
          FILE_INVALID: "Tệp tin không đúng định dạng!",
          INVALID_TYPE_LOYALTY:
            "Mã promotion đang map với loyalty dùng unique code ",
          WH_NOT_RECEIPT: "Vui lòng nhập kho trước!",
          LOYALTY_HAVE_TO_UNLIMITED:
            "Mã promotion map với loyalty sử dụng code có giới hạn",
          ORDER_ITEM_INVALID: "Không xác định",
          //bundle
          LOYALTY_HAVE_ONE_CODE_ONLY:
            "Promotion map với loyalty có nhiều hơn một code general",
          REDIRECT_LINK_RECURSIVE:
            "Đường dẫn liên kết đã tồn tại trên hệ thống",
          REDIRECT_TO_LINK_ERROR: "Đường dẫn liên kết không hợp lệ",
          PHS_RESET_COUNT_TIME_INVALID:
            "Phs reset count time need from 0 to 10",
          CANT_ACTIVE_RATE_UNUSAGE: "Cannot active rate plan is unusage",
          RATE_NAME_REQUIRED: "Rate name must not empty",
          RATE_DESCRIPTION_REQUIRED: "Rate description must not empty",
          SURCHARGE_TRANSACTION_CODE_NOT_VALID:
            "Lỗi transaction code trong phụ thu không hợp lệ",
          SURCHARGE_PMS_CODE_NOT_VALID:
            "Lỗi transaction code trong phụ thu không hợp lệ",
          SURCHARGE_PMS_CODE_REQUIRED: "Phụ thu này yêu cầu transaction code",
          SYS_SURCHARGE_EXCEED_CHECKOUT_DATE:
            "Phụ thu chỉ thực hiện được đến hết ngày checkout",
          COMBINE_RATE_CODE_DIFFERENCE_INTEREST_TYPE:
            "Interest type of rate code are difference, cannot create new rate code",
          COMBINE_RATE_CODE_INVALID_PARAMS_INPUT:
            "Params input cannot be null or empty",
          COMBINE_RATE_CODE_NOT_FOUND_IN_LIST_IDS:
            "Not found any rate code in list id",
          COMBINE_RATE_CODE_CANNOT_GENERATE_NEW_CODE:
            "Cannot generate new code",
          COMBINE_RATE_CODE_SELL_COST_LESS_THAN_COST:
            "Sell cost cannot less than cost",
          RATECODE_NOT_VALID: "Ratecode not valid",
          RATE_CODE_NOT_FOUND: "Ratecode not found",
          LTR_CATEGORY_VALIDATION_ERROR:
            "Rate code can't not has 2 products with LTR category",
          MKR_PROMOTION_IS_NULL:
            "Promotion campaign type is markup, promotion markup info cannot be null",
          MKR_PROMOTION_ROOMNIGHT_NUMBER_INVALID:
            "Min room night cannot larger than max room night",
          MKR_PROMOTION_MARKUP_CONFIG_ID_IS_EMPTY:
            "Data markup config cannot contains markup config id is null or empty",
          MKR_PROMOTION_MARKUP_CONFIG_HOTEL_RATE_IS_EMPTY:
            "Data markup config cannot contains hotel id or rate plan id is null or empty",
          MKR_PROMOTION_MARKUP_DISCOUNT_MODE_MUST_BE_ALL:
            "Promotion for markup must have discount mode is all",
          MKR_PROMOTION_MARKUP_DISCOUNT_TYPE_INVALID:
            "Promotion for markup must have discount type is cash or percentage",
          MKR_PROMOTION_MARKUP_CAMPAIGN_NOT_FOUND:
            "Cannot found any markup campaign",
          MKR_PROMOTION_MARKUP_CAMPAIGN_INACTIVED:
            "Markup campaign inactived: ",
          MKR_PROMOTION_MARKUP_NOT_MATCH_DISCOUNT_TYPE:
            "Promotion campaign and markup campaign has difference discount type",
          MKR_PROMOTION_VALUE_GREATER_THAN_MARKUP_MIN_VALUE:
            "Promotion discount value greater than minimum markup value",
          MKR_PROMOTION_MARKUP_VALUE_MUST_GREATER_THAN_ZERO:
            "Markup campaign existing markup value zero",
          MKR_PROMOTION_MARKUP_HOTEL_NOT_FOUND:
            "Cannot find any promotion markup for hotel",
          MKR_PROMOTION_MARKUP_BUNDLE_NOT_FOUND:
            "Cannot find any promotion markup for bundle",
          MKR_PROMOTION_MARKUP_FLIGHT_NOT_FOUND:
            "Cannot find any promotion markup for flight",
          MKR_PROMOTION_CODE_NOT_FOUND: "Promotion code not found",
          MKR_PROMOTION_CODE_NOT_MATCH_ANY_MARKUP_CAMPAIGN:
            "Promotion code not match with any markup campaign",
          MKR_PROMOTION_HOTEL_REQUEST_CONDITIONS_INVALID:
            "Promotion markup hotel request conditions to check invalid",
          MKR_PROMOTION_CHECK_CODE_MISSING_HOTEL_IDS:
            "Promotion markup hotel request missing hotel ids",
          MKR_PROMOTION_APPLY_CODE_MISSING_RATEPLAN_IDS:
            "Promotion markup hotel request missing rateplan ids",
          MKR_PROMOTION_NOT_APPLY_FOR_LIST_HOTEL_REQUEST:
            "Promotion code not apply for any hotel in request list",
          MKR_PROMOTION_NOT_APPLY_FOR_LIST_RATE_REQUEST:
            "Promotion code not apply for any rate in request list",
          COMBINE_RATE_CODE_DIFFERENCE_INTEREST_TYPE:
            "Interest type of rate code are difference, cannot create new rate code",
          COMBINE_RATE_CODE_INVALID_PARAMS_INPUT:
            "Params input cannot be null or empty",
          COMBINE_RATE_CODE_NOT_FOUND_IN_LIST_IDS:
            "Not found any rate code in list id",
          COMBINE_RATE_CODE_CANNOT_GENERATE_NEW_CODE:
            "Cannot generate new code",
          COMBINE_RATE_CODE_SELL_COST_LESS_THAN_COST:
            "Sell cost cannot less than cost",
          RATECODE_NOT_VALID: "Ratecode not valid",
          RATE_CODE_NOT_FOUND: "Ratecode not found",
          RATE_CODE_PRODUCT_DUPLICATE: `Rate Code can't duplicate Vinwonder Product`,
          LTR_CATEGORY_VALIDATION_ERROR:
            "Rate code can't not has 2 products with LTR category",
          RECOMMIT_HOTEL_BUNDLE_INVALID:
            "Recommit just apply for order hotel, bundle with status failed and valid PHS",
          FLIGHT_BOOKING_INFO_NOT_FOUND:
            "Lỗi không tìm thấy Thông tin chuyến bay",
          INVALID_COMMIT_FIXED_CHARGE_CONDITION:
            "Đơn hàng sai điều kiện đẩy fixcharge",
          FIXEDCHARGE_COMMIT_FAIL: "Commit fixcharge thất bại",
          UNEXPECTED_ERROR: "Có lỗi xảy ra",
          GET_BOOKING_FAILED: "Lấy thông tin booking thất bại",
          TOUR_ITEM_NOT_FOUND: "Tour item not found",
          BOOKABLE_PACKAGE_RATE_NOT_FOUND:
            "Không tìm thấy Bookable Package Rate",
          FLIGHT_TRACKING_EXIST: "Đã có dữ liệu tracking",
          ORDER_ITEM_INVALID: "Không xác định",
          CATEGORY_VALIDATION_ERROR_LTR:
            "SPNCC không thể tồn tại 2 nhóm sản phầm lưu trú",
          UPSELL_REQUIRED: "Vui lòng chọn loại upsell trước",
          PACKAGE_RATE_MUST_UPSELL:
            "Vui lòng chọn loại upsell ở tab thông tin chung",
          UPSELLS_CONTAIN_RATEPLAN: "Upsell không bao gồm rate ở trên",
          FLIGHT_TRACKING_INVALID_REQUEST: "Dữ liệu tracking không hợp lệ",
          UPSELL_REQUIRED: "Vui lòng chọn loại upsell trước",
          PACKAGE_RATE_MUST_UPSELL:
            "Vui lòng chọn loại upsell ở tab thông tin chung",
          UPSELLS_CONTAIN_RATEPLAN: "Upsell không bao gồm rate ở trên",
          TAG_GROUP_NOT_FOUND: "Cannot find tag group",
          TAG_GROUP_CODE_EXISTED: "Tag group code is existed",
          TAG_GROUP_TRANSLATION_REQUIRED: "Tag group translation is required",
          TAG_GROUP_LANGUAGE_DEFAULT_REQUIRED:
            "Tag group default language is required",
          TAG_GROUP_TRANSLATION_DUPLICATED:
            "Tag group translation is duplicated",
          TAG_GROUP_SUPPLIER_DUPLICATED: "Tag group supplier is duplicated",
        },
      },
    },
    paginate: {
      showLine: "Số dòng 1 trang",
      first: "Trang đầu",
      last: "Trang cuối",
      previous: "Trang trước",
      next: "Trang kế",
    },
    translate: {
      languages: {
        vi: "Tiếng Việt",
        en: "Tiếng Anh",
        ko: "Tiếng Hàn",
        zh: "Tiếng Trung",
        ru: "Tiếng Nga",
        hi: "Tiếng Ấn",
      },
      language: "Ngôn ngữ",
      translatedLanguages: "Ngôn ngữ đã được dịch",
    },
    navigation: {
      flightTracking: "Chuyến bay",
      transportation: "Vận chuyển",
      redirectlink: "Cấu hình Redirect URL",
      createRedirectLink: "Tạo mới Redirect URL",
      updateRedirectLink: "Cập nhật Redirect URL",
      checkPromotion: "Kiểm tra Promotion code",
      rates: "Rates",
      bookablePackageRates: "Bookable Package Rate",
      updateRates: "Cập nhật Rate",
      createRates: "Tạo mới Rate",
      airports: "Airport",
      updateAirport: "Update airport",
      createAirport: "Create airport",
      fareRules: "Fare Rule",
      createfareRule: "Create Fare Rule",
      updatefareRule: "Update Fare Rule",
      baggages: " Baggages",
      createBaggage: "Create Baggage",
      updateBaggage: "Update Baggage",
      agents: "Agents",
      home: "Trang chủ",
      users: "Quản lý thành viên",
      createUsers: "Tạo thành viên",
      updateUsers: "Cập nhật thành viên",
      tickets: "Quản lý yêu cầu",
      createTickets: "Tạo yêu cầu",
      updateTickets: "Cập nhật yêu cầu",
      createProperties: "Tạo mới cơ sở",
      updateProperties: "Cập nhật cơ sở",
      surcharge: "Surcharge",
      promotions: "Promotions",
      promotionsManagerment: "Promotions Managerment",
      createGroupPromotions: "Create Promotion Group",
      updateGroupPromotions: "Update Promotion Group",
      autoFill: "Autofill code",
      rateCodes: "Mã giá",
      pointchangehistory: "Lịch sử biến đổi điểm hệ thống",
      warehousemanagement: "Quản lý Inventory",
      createWarehousemanagement: "Tạo mới phiếu nhập kho",
      updateWarehousemanagement: "Cập nhật phiếu nhập kho",
      app: "App",
      appui: "Cấu hình UI",
      appUIUpdate: "Cập nhật nội dung",
      appUICreate: "Tạo mới nội dung",
      clearCache: "Clear cache",
      fnbProduct: "FNB Product",
      outlets: "Outlets",
      FnB: "FNB",
      menuItems: "Menu Items",
    },
    placeHolderForm: {
      input: "Vui lòng nhập",
      select: "Vui lòng chọn",
      dropImage: "Kéo và thả hình ảnh ở đây",
      dropVideo: "Kéo và thả video ở đây",
      startDate: "Ngày bắt đầu",
      endDate: "Ngày kết thúc",
    },
    action: {
      info: "Thông tin",
      export: "Xuất file",
      import: "Nhập file",
      create: "Tạo mới",
      confirm: "Xác nhận",
      update: "Cập nhật",
      clone: "Sao chép",
      show: "Xem",
      cancel: "Hủy",
      remove: "Xoá",
      action: "Thao tác",
      exit: "Thoát",
      lock: "Khoá",
      unlock: "Mở khoá",
      refreshData: "Làm mới dữ liệu",
      autoResize: "Auto resize",
      back: "Quay về",
      backIndex: "Quay về trang chủ",
      statusHide: "Không hiển thị",
      statusShow: "Hiển thị",
      sort: "Sắp xếp danh sách",
      changeStatus: "Đổi trạng thái",
      sync: "Đồng bộ dữ liệu",
      bundleViewCode: "View code",
      bundleDeactivated: "Deactivated code",
      bundleActivated: "Activated code",
      updateActiveByExcel: "Active/Deactive group",
      changeRate: "Đổi mã giá",
      pushFixedCharge: "Đẩy FixCharge",
    },
    notification: {
      title: "Thông báo",
      cloneSuccess: "Sao chép dữ liệu thành công",
      notInternet: "Kết nối bị lỗi, máy chủ không phản hồi!",
      createSuccess: "Thêm dữ liệu thành công",
      updateSuccess: "Cập nhật dữ liệu thành công",
      removeSuccess: "Xoá dữ liệu thành công",
      checkSuccess: "Kiểm tra thành công",
      uploadSuccess: "Tải dữ liệu thành công",
      resendMailSuccess: "Gởi email thành công",
      sureRemove: "Bạn chắc chắn muốn xóa ?",
      sureDeActive: "Bạn muốn vô hiệu tài khoản ?",
      sureUse: "Bạn chắc chắn muốn sử dụng ?",
      sureLogout: "Bạn chắc chắn muốn thoát?",
      unsaveUpdate: "Bạn có thay đổi chưa lưu",
      confirmExit: "Bạn có chắc chắn muốn thoát?",
      pushFixedChargeSuccess: "Đẩy FixCharge thành công",
      cantSelectTwoRateCode: "Không thể chọn 2 mã giá",
      clearCacheSuccess: "Xóa cache thành công",
      confirmSyncData: "Bạn có chắc chắn muốn đồng bộ dữ liệu menu cho outlet này?",
      confirmSyncDataCondiment: "Bạn có chắc chắn muốn đồng bộ dữ liệu condiment cho property này?",
      confirmSyncDataOption: "Bạn có chắc chắn muốn đồng bộ dữ liệu option cho property này?",
      confirmSyncProductFnb: "Bạn có chắc chắn muốn đồng bộ dữ liệu?",
      syncSuccess: "Đồng bộ dữ liệu thành công",
    },
    permission: {
      view: "Xem",
      viewList: "Xem danh sách",
      create: "Thêm",
      update: "Sửa",
      delete: "Xóa",
      approve: "Cho phép",
      resendEmail: "Gửi lại email",
      exportVoucher: "Xuất file voucher",
      saleOrder: "Xuất bán",
      useVoucher: "Sử dụng",
      updatePrice: "Sửa giá",
      export: "Xuất file excel",
      check: "Kiểm tra",
      viewDetail: "Xem chi tiết",
      updateItemStatus: "Cập nhật trạng thái item",
      lockItem: "Khóa item",
      deactive: "Huỷ mã khuyến mại",
      sync: "Đồng bộ dữ liệu",
      updateStatus: "Cập nhật trạng thái",
      bundleView: "Xem nhóm khuyến mãi",
      bundleCreate: "Tạo nhóm khuyến mãi",
      bundleUpdate: "Cập nhật nhóm khuyến mãi",
      recommit: "Xuất lại vé",
      updateActiveByExcel: "Cập nhật trạng thái theo Excel",
      exportExcludeUserInfo: "Xuất file excel (Không thông tin khách hàng)",
      receiptsPayslipCreate: "Tạo phiếu thu/chi",
      flightTracking: "Chuyến bay",
      flightTracking: {
        view: "Xem chuyến bay",
        create: "Tạo chuyến bay",
        update: "Cập nhật chuyến bay",
        delete: "Xoá chuyến bay",
      },
      refund: "Hoàn điểm",
    },
    item: {
      receiptsPayslip: {
        title: "Tạo phiếu thu/chi",
      },
      user: {
        title: "Thành viên",
        staff_code: "Mã nhân viên",
        name: "Họ và tên",
        username: "Tên tài khoản",
        phone: "Số điện thoại",
        email: "Email",
        password: "Mật khẩu",
        oldPassword: "Mật khẩu cũ",
        newPassword: "Mật khẩu mới",
        confirmPassword: "Xác nhận mật khẩu",
        stationId: "Khu vực trạm",
        deActivated: "Khoá thành viên",
        role: "Vai trò",
        status: "Trạng thái",
        action: "Thao tác",
        mfaEnabled: "MFA Status",
        forceMfa: "Force MFA",
        forceMfaOn: "On",
        forceMfaOff: "Off",
        accountSecurity: "Account security",
        newLabel: "NEW",
        mfaStatusDescription: "Multi-factor authentication status configured by the user",
        forceMfaDescription: "Require the user to configure or verify MFA on their next sign-in",
      },
      ticket: {
        title: "yêu cầu",
        assigned: "Người thực hiện",
        note: "Ghi chú",
        reason: "Lý do",
        typeId: "Loại yêu cầu",
        createdBy: "Người tạo",
        updatedBy: "Người cập nhật",
        order: "#",
        status: "Trạng thái",
        action: "Thao tác",
        statusLabel: {
          label: {
            0: "Mới tạo",
            1: "Hoàn thành",
            2: "Huỷ yêu cầu",
          },
          class: {
            0: "green",
            1: "blue",
            2: "red",
          },
        },
      },
      baggage: {
        domestic: "Domestic",
        international: "International",
      },
      configPHS: {
        hotel: "Hotel",
        bundle: "Bundle",
        title: "Config placeholder session",
        isActive: "Status",
        sessionLiveTime: "PHS time",
        paymentTime: "Payment time",
        edit: "Edit",
        save: "Save",
        cancel: "Cancel",
        turnOff: "Off",
        turnOn: "On",
        timeUnit: "Minute",
        warningEdit: "No field can be empty",
      },
      tour: {
        title: "Tour",
        bookingDate: "Ngày khởi hành",
        totalPrice: "Tổng giá",
        outStock: "Hết vé",
        adultTicket: "Số lượng người lớn",
        childTicket: "Số lượng trẻ em",
        productTypes: "Loại sản phẩm",
        operationManuals: "Hướng dẫn vận hành",
        propertyName: "Cơ sở lưu trú",
        saleDate: "Ngày bán",
        stayDate: "Ngày lưu trú",
        effectiveDate: "Ngày hiệu lực",
        voucherBookingPeriod: "Ngày cuối xử lý đơn hàng",
        cutOffDate: "Số ngày phải đặt trước",
        createTicket: "Tạo ticket",
        updateTicket: "Cập nhật",
        ticketName: "Tên",
        uploadFile: "Tải hình ảnh",
        uploading: "Đang tải lên",
        tourTitle: "Tiêu đề",
        tourCode: "Mã tour",
        tourName: "Tên tour",
        images: "Hình ảnh",
        thumbImage: "Ảnh đại diện",
        departure: "Điểm khởi hành",
        destination: "Điểm đến",
        groupSize: "Size đoàn",
        order: "Trọng số",
        countryId: "Địa điểm",
        stateOrProvinceId: "Mã vùng",
        duration: "Thời gian",
        description: "Mô tả",
        service: "Dịch vụ",
        cancelCondition: "Điều kiện huỷ",
        cancellationPolicy: "Điều kiện hoàn hủy",
        departureDateItem: "Ngày khởi hành",
        productType: "Loại tour",
        from: "Ngày đi",
        to: "Ngày về",
        seat: "Số chỗ ngồi",
        originalPrice: "Giá",
        salePrice: "Giá khuyến mãi",
        priceTypeHeader: "Loại giá",
        highlight: "Điểm nổi bật",
        itinerary: "Lịch trình",
        serviceIncluded: "Dịch vụ bao gồm",
        serviceExcluded: "Dịch vụ không bao gồm",
        note: "Lưu ý",
        noted: "Ghi chú",
        checklist: "Checklist khởi hành",
        hotel: "Khách sạn",
        airline: "Nhà cung cấp",
        days: "Số ngày",
        day: "Ngày",
        nights: "Số đêm",
        night: "Đêm",
        isSpecial: "Tour nổi bật",
        adultOriginalPrice: "Giá vé mặc định",
        adultSalePrice: "Giá vé người lớn khuyến mãi",
        childOriginalPrice: "Giá vé trẻ em",
        childSalePrice: "Giá vé trẻ em khuyến mãi",
        action: "Thao tác",
        lengthOfTour: "Độ dài kỳ nghỉ",
        enumLengthOfTour: "days ngày nights đêm",
        active: "Kích hoạt",
        deactive: "Ngưng kích hoạt",
        priceType: {
          ADULT: "Người lớn",
          OLDSTER: "Người cao tuổi trên 65",
          CHILD: "Trẻ em từ 4 - 11 tuổi",
          NEWBORN: "Trẻ em dưới 4 tuổi",
          ANIMAL: "Động vật",
        },
        limitNumberOfSale: "Giới hạn số lượng mua",
        step: "Chu kỳ (ngày)",
        errorCode: {
          2: "Ngày khởi hành không được nhỏ hơn ngày khởi hành của hành trình đã tồn tại",
          TS_DEPARTURE_DATE_EXIST: "Ngày khởi hành đã tồn tại",
          UNDEFINED_ERROR: "Lỗi không xác định. Vui lòng thử lại!",
          TS_TOUR_NOT_FOUND: "Không tìm thấy tour",
          // TS_INVALID_MAXDATE: 'Ngày khởi hành được chọn không được lớn hơn ngày khởi hành sau cùng của tour',
          TS_INVALID_MAXDATE: "Ngày khởi hành đã tồn tại",
          TS_TOUR_TYPE_IN_USED:
            "Lỗi: Không thể xóa, đối tượng sử dụng đang được sử dụng bởi tour khác",
        },
        generalInfo: "Thông tin chung",
        tripItinerary: "Lịch trình",
        tripItineraryContent: "Nội dung lịch trình",
        tourInfo: "Thông tin sản phẩm",
        productInfo: "Sản phẩm",
        sellPlan: "Kế hoạch bán",
        tourTickets: "Vé và biến đổi giá",
        defaultPrice: "Giá mặc định",
        departureDate: "Ngày khởi hành",
        departureDates: "Các ngày khởi hành",
        destinationDate: "Ngày kết thúc",
        tourOperationType: "Loại sản phẩm",
        channel: "Kênh bán",
        showTicketInfo: {
          title: "Lựa chọn thông tin trong hiển thị vé QR",
          note: "Lưu ý: mặc định hiển thị Mã Booking, Ngày sử dụng & Loại vé",
        },
        inbound: "Nội địa",
        outbound: "Quốc tế",
        tourTypes: "Đối tượng sử dụng",
        tagSKUVW: "Tag SKU VWBK",
        tag: "Tag",
        selectTourTypes: "Chọn dòng các đối tượng sử dụng",
        selectTagSKUVW: "Chọn dòng các tag SKU VWBK",
        tourTypeName: "Tên đối tượng sử dụng",
        tagSKUVWName: "Tên tag SKU VWBK",
        isHotTour: "Sản phẩm hot",
        attribute: "Thuộc tính",
        isWebsitePublished: "Hiển thị trên website",
        isWebsiteNotPublished: "Chưa lên website",
        isCrossSell: "Hiển thị bán CrossSell",
        publishDateTime: "Ngày đưa lên website",
        urlSlug: "Đường dẫn website",
        specialImage: "Ảnh nổi bật",
        slideShowImages: "Ảnh/video trình chiếu",
        checklistContent: "Nội dung checklist",
        checkListEmptyTitle: "Chưa có tiêu đề",
        isEnabled: "Hiệu lực",
        isEnabledTitle: "Trạng thái",
        isDisabled: "Tắt",
        currency: "Đơn vị tiền tệ",
        shortDescription: "Mô tả ngắn",
        months: "Tháng",
        vehicle: "Nhà cung cấp phương tiện",
        accommodation: "Nhà cung cấp lưu trú",
        meal: "Nhà cung cấp ăn uống",
        activity: "Nhà cung cấp hoạt động",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        productTypeTrans: {
          flightAndHotel: "Vé máy bay + KS Vinpearl",
          highSpeedShipHotel: "Tàu cao tốc + KS Vinpearl",
          vinpearlHotel: "Gói phòng Vinpearl",
          tourAndExperience: "Tour & Trải nghiệm",
          airportPickup: "Đón tiễn sân bay",
          installmentVIN: "Trả góp 0%",
        },
        ticketObjectType: "Chọn đối tượng",
        ticketType: "Loại vé",
        memberShipTypes: "Hạng thẻ",
        partialyCashBack: {
          lblCashBack: "Hoàn bằng tiền mặt",
          lblPointBack: "Hoàn bằng điểm",
          lblTypeName: "Tên loại hoàn",
          lblConfig: "Cấu hình hoàn điểm",
          lblBackValue: "Giá trị hoàn",
          lblRemaining: "Còn lại",
          lblLoyaltyCode: "Mã tỷ lệ loyalty",
          lblPoints: "Số điểm:",
          lblBackToOwner: "Hoàn cho chủ đơn hàng",
          lblBackToOther: "Hoàn cho người khác",
          lblSentPointToEmail: "Chuyển điếm đến email",
        },
      },
      campaign: {
        sku: "SKU",
        fnb: "FnB",
        hotel: "Hotel",
        flashSale: "Flash Sale",
        diem: "Điểm",
        name: "Tên chiến dịch",
        desc: "Nội dung",
        description: "Nội dung",
        formatCode: "Định dạng code",
        code: "Code",
        productType: "Loại sản phẩm",
        totalCount: "Số lượng code",
        usedCount: "Đã sử dụng",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        action: "Thao tác",
        title: "Chiến dịch",
        campaignCode: "Mã chiến dịch",
        headingForm: {
          info: "Thông tin chiến dịch",
          prodType: "Sản phẩm áp dụng",
          type: "Đối tượng áp dụng",
          genCode: "Định dạng code",
        },
        schedules: "Thời gian áp dụng",
        countries: "Quốc gia áp dụng",
        channel: "Áp dụng cho kênh bán hàng",
        platforms: "Áp dụng cho platform",
        channelNull: "Kênh bán trống sẽ mặc định là chọn tất cả",
        skuIds: "Sản phẩm áp dụng",
        hotels: "Khách sạn áp dụng",
        minItemCount: "Số lượng SKU item tối thiểu",
        minFnbItemCount: "Số lượng item tối thiểu",
        minItemCountNull: "Để trống số lượng tối thiểu {{min}} item",
        maxItemCount: "Số lượng SKU item tối đa",
        maxFnbItemCount: "Số lượng item tối đa",
        maxItemCountNull: "Để trống số lượng tối đa vô hạn",
        totalOrderAmount: "Tổng tiền đơn hàng tối thiểu",
        totalOrderAmountNull: "Tổng tiền tối thiểu {{min}} {{currency}}",
        codePrefix: "Prefix code",
        codeCharCount: "Số lượng ký tự",
        promotionType: "Kiểu mã code",
        promotionTypes: {
          unique: "Unique",
          general: "General",
          hints: {
            unique: "Unique code chỉ áp dụng cho thành viên hệ thống",
          },
        },
        maxUseCount: "Số lần sử dụng",
        maxCountPerUser: "Số lượng tối đa người dùng sử dụng",
        userFrequencyLimitCount: "Giới hạn tần suất sử dụng của người dùng",
        userFrequencyLimitPeriodTitle: "Chu kỳ",
        userFrequencyLimitPeriodRequired: "Vui lòng chọn chu kỳ khi nhập giới hạn tần suất sử dụng",
        userFrequencyLimitPeriod: {
          none: "None",
          day: "Ngày",
          week: "Tuần",
          month: "Tháng",
          campaign: "Campaign",
        },
        maxRoomNightPerUser: "Giới hạn số đêm phòng áp dụng của người dùng",
        positiveIntegerInvalid: "%s phải là số nguyên lớn hơn 0",
        discountType: "Loại giảm giá",
        discountTypes: {
          amount: "Số tiền",
          percent: "Phần trăm",
        },
        discountMode: {
          ALL: "Áp dụng trên toàn đơn hàng",
          ITEM: "Chia đều từng sản phẩm",
        },
        discountValue: "Giá trị giảm",
        maxDiscountValue: "Số tiền tối đa",
        timezoneOffset: "Ngày tạo",
        skuAll:
          "Tất cả (Bao gồm tất cả các SKU tại thời điểm hiện tại và SKU phát sinh trong tương lai )",
        skuSpecific: "Specific (Bao gồm các SKU được lựa chọn)",
        optionSku: {
          skuAll: "Tất cả",
          skuSpecific: "Chỉ định",
          description: {
            skuAll:
              "Bao gồm tất cả các SKU tại thời điểm hiện tại và SKU phát sinh trong tương lai",
            skuSpecific: "Chỉ định cụ thể các SKU được lựa chọn",
          },
        },
        valueDiscount: "Giá trị khuyến mại",
        formatCodeExample: "Code ví dụ",
        bonusType: "Kiểu thưởng",
        bonusValue: "Phần thưởng",
        bonusTypes: {
          tracking: "Tracking",
          decreace: "Giảm tiền",
          product: "Sản phẩm",
          description: {
            tracking: "Dùng tracking hiệu quả bán hàng sale",
            decreace: "Giảm tiền cho khách hàng đủ điều kiện",
            product: "Tặng sản phẩm cho khách hàng đủ điều kiện",
          },
        },
        searchInfoConfig: "Cấu hình tìm kiếm",
        searchInfoConfigs: {
          roomCount: "Số lượng phòng",
          nightCount: "Số lượng đêm",
          max: "Số lượng tối đa",
          min: "Số lượng tối thiểu",
        },
        selectHotel: "Chọn khách sạn áp dụng",
        selectedRateCodes: "Lựa chọn",
        selectedRateCodesSuffix: "mã giá",
        supplierName: "Nhà cung cấp",
        codeCharCountPlaceHolder: "Số lượng ký tự 4 -10",
        rangeDate: "Thời gian",
        useObjectHeader: "Đối tượng áp dụng",
        objectType: {
          all: "Tất cả",
          member: "Thành viên đã đăng ký",
          guestVisiting: "Guest",
          specific: "Đối tượng đặc biệt",
          description: {
            all: "Bao gồm thành viên và không phải thành viên",
            member: "Chỉ bao gồm thành viên đã đăng ký",
            guestVisiting: "Áp dụng cho người dùng chưa đăng nhập",
            specific:
              "Bao gồm thành viên và không phải thành viên có email đơn hàng tại danh sách",
          },
          another: "Đối tượng đặc biệt",
        },
        codeType: {
          standard: "Tiêu chuẩn",
          customize: "Tuỳ chỉnh",
        },
        selectEmail: "Lựa chọn khách hàng",
        selectedEmail: "Lựa chọn {0} khách hàng",
        importFailed: "Vui lòng kiểm trả dữ liệu lỗi",
        importFailedRow: "Dòng",
        importFailedError: "Lỗi:",
        totalRowInFile: "Số dòng dữ liệu trong tập tin:",
        totalRowValid: "Số dòng dữ liệu hợp lệ:",
        totalRowInvalid: "Số dòng dữ liệu lỗi:",
        freeNightConfig: "Cấu hình đêm nghỉ miễn phí",
        freeNightStay: "Số đêm nghỉ miễn phí",
        loyaltyCode: "Liên kết hệ thống loyalty",
        emailNotValid: "Định dạng email không đúng hoặc trùng",
        emailInvalid: "Email không đúng định dạng: {{values}}.",
        emailDuplicated: "Email bị trùng: {{values}}.",
        emailSuffixInvalid: "Đuôi email không đúng định dạng: {{values}}.",
        emailSuffixDuplicated: "Đuôi email bị trùng: {{values}}.",
        PROMOTION_NOT_ENOUGH_QUANTITY:
          "Đã có lỗi xảy ra trong quá trình xử lý, vui lòng liên hệ quản trị viên",
        specialEvent: {
          title: "Chương trình đặc thù",
          configBenefitCard: "Cấu hình quyền lợi thẻ",
          configBenefitVoucher: "Cấu hình quyền lợi voucher",
          numberUse: "Số lần sử dụng",
          loyaltyCode: "Liên kết hệ thống loyalty",
        },
        markup: "Markup",
        campaignPromotionInfoSection: {
          headerTitle: "Thông tin chiến dịch khuyến mại",
          title: "Thông tin chiến dịch: {{name}}",
          SwitchVPT: "VPT",
          SwitchLoyalty: "Loyalty",
          displayName: "Tên hiển thị",
          description: "Mô tả ngắn",
          detail: "Thông tin chi tiết",
          avatar: "Ảnh đại diện",
          coverPicture: "Ảnh bìa",
          lableWording: "Tên label",
          ctaName: "Tên hiển thị CTA",
          displayTarget: "Đối tượng hiển thị",
          specifyTarget: "Đối tượng chỉ định",
          selectTargetPlaceholder: "Vui lòng chọn đối tượng hiển thị",
          emailTargetConfig: "Cấu hình danh sách email đối tượng ({{email}})",
          btnSave: "Lưu lại",
          btnUpdate: "Update thông tin",
          vptPlaceholder: {
            displayName: "50 ký tự",
            description: "200 ký tự",
            lableWording: "20 ký tự",
            fnbLableWording: "10 ký tự",
            ctaName: "20 ký tự",
          },
          loyaltyDescription:
            "Thông tin chiến dịch được lấy trực tiếp từ loyalty",
        },
      },
      bundle: {
        loyaltyBenefitCode: "Benefit code",
        loyaltyCampaignCode: "Mã liên kết Loyalty",
        tabBundleTitle: "Bundles",
        tabPromotionTitle: "Promotion Code",
        campaignCode: "Campaign code",
        campaignName: "Campaign name",
        code: "Group code",
        name: "Group name",
        count: "Max count",
        usedCount: "Used Count",
        rangeDate: "Rang date",
        isActive: "Status",
        expiredDate: "Expired date",
        createdDate: "Created Date",
        createdUserName: "Created By",
        action: "Action",
        timeToApplyType: "Time to apply",
        all: "All times",
        some: "Specify times",
        campaign: "Campaign type",
        inputName: "Group name",
        usedDate: "Used date",
        stayDate: "Stay date",
        campaignDate: "Campaign date",
        title: "promotion group",
        activated: "Activated",
        deactivated: "Deactivated",
        maxCountInput: "Max promotion code:",
        productType: "Loại sản phẩm:",
        rangeStayDate: "Thời gian lưu trú",
        promotionCode: "Mã khuyến mãi",
        maxCountCode: "Số lượng mã khuyến mãi tối đa:",
        selectPromotionCode: "Thêm mã khuyến mãi",
        selectedPromotionCode: "Thêm {0} mã khuyến mãi",
        promotionCodeNotValid:
          "Mã khuyến mãi không hợp lệ (4 - 20 ký tự) hoặc quá số lượng cho phép",
        importFailed: "Vui lòng kiểm trả dữ liệu lỗi",
        importFailedRow: "Dòng",
        importFailedError: "Lỗi:",
        totalRowInFile: "Số dòng dữ liệu trong tập tin:",
        totalRowValid: "Số dòng dữ liệu hợp lệ:",
        totalRowInvalid: "Số dòng dữ liệu lỗi:",
        promotionCodeDuplicate: "Mã khuyến mãi đã tồn tại",
      },
      promotions: {
        promotionInfo: "Thông tin Promotion",
        titleImportExcel: "Đổi trạng thái qua file Excel",
        updateAt: "Thời gian đổi trạng thái",
        textSearch: "Từ khoá tìm kiếm",
        campaign: "Chiến dịch",
        campaignCode: "Mã chiến dịch",
        campaignName: "Tên chiến dịch",
        bundle: "Bundle",
        bundleName: "Chiến dịch con",
        bundleCode: "Mã bundle",
        promotionCode: "Mã khuyến mại",
        isActive: "Hoạt động",
        isUsed: "Đã sử dụng",
        maxCount: "Số lượng",
        usedCount: "Số lượng đã dùng",
        channel: "Kênh",
        active: "Hoạt động",
        deactive: "Ngừng hoạt động",
        titleDeActive: "Huỷ mã khuyến mại",
        titleActive: "Kích hoạt khuyến mại",
        note: "Ghi chú",
        action: "Thao tác",
        promotionHistorys: "Lịch sử dùng",
        unlimited: "Không giới hạn",
        orderCode: "Mã đơn hàng",
        usedTime: "Thời gian sử dụng",
        notUse: "Chưa sử dụng",
        viewMore: "Xem lịch sử dùng",
        exportFileExcel: "Xuất file",
        title: "Promotions",
        titleModalHistory: "Lịch sử dùng mã Promotion",
        listOrderUsed: "Danh sách đơn hàng sử dụng",
        btnCheckCode: "Kiểm tra code",
        messCheckCode: "Nhập mã promotion code để kiểm tra tình trạng sử dụng",
        status: "Trạng thái",
        currentStatus: "Trạng thái hiện tại",
        schedules: "Thời gian áp dụng",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        titleModalSchedules: "Thời gian áp dụng",
        view: "Xem",
        hotel: "Hotel",
        supplier: "Nhà cung cấp",
        scheduleTypeHeader: "Loại thời gian",
        scheduleType: {
          booking_date: "Ngày sử dụng",
          use_date: "Ngày lưu trú",
        },
        bulkActive: "Kích hoạt đồng loạt mã khuyến mãi",
        bulkDeactivated: "Huỷ đồng loạt mã khuyến mãi",
      },
      order: {
        bookingId: "Mã xác nhận (trên Golf Soft)",
        departureDate: "Ngày bay",
        departureTime: "Thời gian cất cánh",
        flightInfo: "Chuyến bay",
        flightInfoTitle: "Cấu hình chuyến bay",
        airportDeparture: "Sân bay đi",
        airportArrival: "Sân bay đến",
        airportDomestic: "Hãng hàng không",
        flight: "Chuyến bay",
        refundConfirmed: "Tổng số đã hoàn",
        refundWaiting: "Tổng số đợi hoàn",
        roomConfirmationNumber: "confirm no.",
        maxDiscount: "Giảm tối đa",
        couponCode: "Mã khuyến mãi",
        apply: "Áp dụng",
        counponCodePlaceHolder: "Nhập mã giảm giá",
        totalSeats: "Tổng voucher còn lại",
        totalDiscountPrice: "Số tiền giảm",
        totalSalePrice: "Tổng giá bán",
        totalPrice: "Tổng tiền",
        totalChangeRateCode: "Chênh lệch do đổi mã giá",
        departureOrderStatus: "Trạng thái đơn hàng chiều đi",
        returnOrderStatus: "Trạng thái đơn hàng chiều về",
        departureSellAccount: "Tài khoản bán hàng chiều đi",
        returnSellAccount: "Tài khoản bán hàng chiều về",
        installmentFee: "Phí trả góp",
        installmentLimit: "Thời hạn trả góp",
        creditPoint: "Credit Point",
        propertyName: "Cơ sở lưu trú",
        ticketName: "Tên vé",
        rateCode: "Rate code",
        seatNo: "Seat No",
        title: "Đơn hàng",
        saleReportBySKU: "Báo cáo đơn hàng theo SKU",
        saleChannel: "Kênh bán",
        titleDetailGroupVoucher: "Thông tin voucher",
        orderCode: "Mã đơn hàng",
        fullname: "Họ tên",
        phoneNumber: "Số điện thoại",
        email: "Thư điện tử",
        customerLoginInfo: "Customer login info",
        phone: "Số điện thoại",
        sex: "Giới tính",
        dateOfBirth: "Ngày sinh",
        firstName: "Đệm và tên",
        lastName: "Họ",
        phoneNumberShort: "SĐT",
        identityType: "Loại giấy tờ tùy thân",
        identityDetail: "Giấy tờ tùy thân",
        national: "--Quốc tịch--",
        placeOfBirth: "Nơi sinh",
        require: "*",
        submarineMaxQuantity: "Tổng vé tàu ngầm không được vượt quá: ",
        session: "Giờ khởi hành",
        zonePickup: "Cảng đón",
        zoneRelease: "Cảng trả",
        createdDate: "Ngày đặt hàng",
        subTotal: "Thành tiền",
        totalOriginalAmount: "Tổng tiền trước km",
        exchangeCash: "Điểm",
        pointUnit: "điểm",
        totalPayment: "Thành tiền",
        totalChangeRateCodeAdmin: "Đổi mã giá (chỉ admin)",
        totalSurchargeAdmin: "Phụ thu (chỉ admin)",
        totalAmountAdmin: "Tổng Tiền (Admin)",
        paymentPromotion: "Khuyến mãi thanh toán",
        status: "Trạng thái đơn hàng",
        quickTaskStatus: "QuickTask",
        paymentStatus: "Trạng thái thanh toán",
        transactionId: "Mã giao dịch",
        paymentMethod: "Payment method",
        paid: "Đã thanh toán",
        unpaid: "Chưa thanh toán",
        detail: "Chi tiết",
        tourTitle: "Tên dịch vụ",
        departureDate: "Ngày khởi hành",
        priceType: "Loại vé",
        quantity: "Số lượng",
        originalPrice: "Giá",
        price: "Giá",
        prices: "Giá bán",
        salePrice: "Giá khuyến mãi",
        orderInfo: "Thông tin giao dịch",
        groupOrderInfo: "Thông tin đơn hàng",
        groupCustomerInfo: "Thông tin khách hàng",
        groupPaymentInfo: "Thông tin thanh toán",
        groupFinancialInfo: "Thông tin doanh thu",
        orderItemInfo: "Thông tin dịch vụ",
        action: "Thao tác",
        checkCode: "Mã kiểm tra",
        saleReportByOrder: "Báo cáo doanh số theo đơn hàng",
        checkedBy: "Sử dụng bởi",
        checkedDate: "Ngày sử dụng",
        couponValue: "Giá trị voucher",
        firstname: "Tên",
        lastname: "Họ",
        groupCode: "Mã chương trình",
        name: "Tên chương trình",
        operaBookingCode: "Mã booking",
        orderItemType: "Loại đơn hàng",
        property: "Địa điểm sử dụng",
        serialNumber: "Mã voucher",
        surchargeDetail: "Chi tiết phụ thu",
        orderSurcharge: "Phụ thu đơn hàng",
        orderCreateSurcharge: "Tạo phiếu",
        userEmail: "Email",
        voucherStatus: "Trạng thái voucher",
        skuCode: "Mã SKU",
        skuName: "Tên SKU",
        urlSlug: "Link SKU",
        ticketCode: "Mã vé",
        errorCode: {
          NOT_FOUND: "Không tìm thấy",
          NOT_ENOUGH_VOUCHER: "Không có đủ số lượng voucher",
          GROUP_NOT_FOUND: "Không tìm thấy chương trình",
        },
        statusDetailGroup: {
          enum: {
            4: "Đã bán",
            7: "Đã dùng",
          },
        },
        orderStatus: {
          0: "",
          1: "Không thành công",
          2: "Thành công",
          3: "Failed",
          4: "Waiting for payment",
          5: "Đã hủy 1 phần",
          6: "Đã hủy",
          7: "Đã hoàn 1 phần",
          8: "Đã hoàn",
          9: "Chờ xử lý",
        },
        orderQuickTaskStatus: {
          1: "Chưa tạo",
          2: "Đã tạo",
        },
        paymentStatusEnum: {
          0: "",
          1: "Chưa thanh toán",
          2: "Đã thanh toán",
          4: "Chờ thanh toán",
          5: "Đã hủy",
        },
        voucher: {
          groupName: "Tên chương trình",
          discountValue: "Giá trị voucher",
          quantity: "Số lượng",
          originalPrice: "Giá",
          totalPrice: "Tổng tiền",
          status: "Trạng thái",
          operaBookingCode: "Mã Booking",
          checkInDate: "Ngày check-in",
          checkOutDate: "Ngày check-out",
          propertyOfStay: "Cơ sở lưu trú",
          property: "Cơ sở sử dụng",
          checkedDate: "Ngày sử dụng",
          checkCode: "Mã kiểm tra",
          serialNumber: "Mã Voucher",
          salePrice: "Giá bán",
          action: "Thao tác",
          types: {
            percent: "%",
            gift: "Miễn phí sử dụng",
            money: "Giảm",
          },
        },
        itemTypes: "Loại đơn",
        orderTypes: {
          voucher: "Voucher",
          tour: "Tour",
          flight: "Chuyến bay",
          hotel: "Khách sạn",
          vinWonder: "Vé VinWonders",
          bundle: "Bundle",
          vinWonderNew: "Vé VinWonders New",
          packageRate: "Package Rate",
          vinpearlGolf: "Vinpearl Golf",
          fnb: "FNB",
        },
        flightInfos: "Thông tin chuyến bay",
        voucherInfo: "Thông tin Voucher",
        ticketType: "Loại vé",
        serviceName: "Service name",
        tourInfo: "Thông tin Tour",
        vinwondersInfo: "Thông tin VinWonders",
        tourName: "Tên Tour",
        adult: "Người lớn",
        children: "Trẻ em",
        child: "Trẻ em",
        infant: "Trẻ sơ sinh",
        senior: "Người cao tuổi",
        coupon: "Giảm giá",
        paymentType: "Hình thức thanh toán",
        paymentMethod: "Kênh thanh toán",
        paymentTypes: {
          vnpay: "VNPAY",
          onepay: "ONEPAY",
          zalo: "ONEPAY",
          shopeepay: "ONEPAY",
          onepay_installment: "Trả góp",
          paylater: "Thanh toán sau",
          cash: "Tiền mặt",
          transfer: "Chuyển Khoản",
          qrcode: "QRCode",
          CreditPoint: "Credit Point",
          other: "Khác",
          Other: "OTHER",
          momo: "MoMo",
          twoc2p: "2C2P",
          Napas: "NAPAS",
          NAPAS: "NAPAS",
          napas: "NAPAS",
          "Agent Voucher": "Agent Voucher",
        },
        saleChannels: {
          online: "Online",
          corporation: "Công ty",
          customerservice: "Chăm sóc khách hàng",
          property: "Cơ sở",
          internal: "Nội bộ",
          travelagent: "Đại lý",
          b2b: "B2B",
        },
        channels: {
          1: "Online website",
          2: "Online app",
          3: "Online chatbot",
          4: "Offline website",
          10: "BookingVinwonder",
          11: "AppVinwonder",
          12: "Booking Vinpearl Golf",
        },
        surchargeType: {
          ticket: "Phụ thu vé",
          room: "Phụ thu phòng",
          ticketrefundcancel: "Hoàn hủy vé",
          roomrefundcancel: "Hoàn hủy phòng",
          other: "Phụ thu khác",
          Room: "phụ thu phòng",
          DepartureFlight: "phụ thu vé chiều đi",
          ReturnFlight: "phụ thu vé chiều về",
        },
        orderSmsHistories: {
          index: "",
          content: "Nội dung",
          receivers: "Số điện thoại",
          status: "Trạng thái",
          createdDate: "Thời gian tạo",
          action: "Gửi lại",
          statusTypes: {
            Failed: "Không thành công",
            Success: "Thành công",
          },
        },
        currentStatus: "Trạng thái hiện tại",
        confirmResendMail: "Xác nhận gửi lại email?",
        confirmExportVoucher: "Xác nhận xuất file voucher?",
        confirmSendMailTemplate: "Xác nhận gửi email CSKH?",
        confirmLockOrderItem: "Bạn có chắc chắn muốn khóa đơn hàng này?",
        confirmPushFixedCharge: "Bạn có chắc chắn muốn đẩy FixCharge?",
        confirmUnLockOrderItem: "Bạn có chắc chắn muốn mở khóa đơn hàng này?",
        hotelBookingDetailInfo: "Thông tin chi tiết phòng khách sạn",
        hotelInfo: "Thông tin khách sạn",
        hotelBookingInfo: "Thông tin đặt phòng",
        hotelRoomLength: "Số phòng",
        hotelLengthOfStay: "Số đêm",
        homestayBookingDetailInfo: "Thông tin chi tiết phòng homestay",
        homestayInfo: "Thông tin homestay",
        homestayBookingInfo: "Thông tin đặt phòng",
        homestayRoomLength: "Số phòng",
        homestayLengthOfStay: "Số đêm",
        arrivalDate: "Ngày nhận phòng",
        checkoutDate: "Ngày trả phòng",
        operaConfirmationNumber: "Mã đặt phòng",
        orderStatusHotel: "Trạng thái",
        orderStatusHomestay: "Trạng thái",
        roomType: "Loại phòng",
        maxOccupancy: "Số người tối đa",
        maxAdult: "Số người lớn tối đa",
        maxChild: "Số trẻ em tối đa",
        maxInfant: "Số trẻ sơ sinh tối đa",
        amount: "Giá",
        totalAmount: "Tổng tiền",
        totalSurcharge: "Tổng tiền phụ thu",
        profile: "Thông tin khách hàng",
        profileName: "Tên",
        profileEmail: "Email",
        profilePhoneNumber: "Số điện thoại",
        exportSaleOrder: "Xuất bán",
        saleOrderFullName: "Tên người mua",
        saleOrderFirstName: "Tên",
        saleOrderLastName: "Họ",
        note: "Ghi chú",
        saleOrderSuccess: "Xuất bán thành công",
        exportVoucherSuccess: "Xuất file thành công",
        invoiceInfo: "Thông tin xuất hóa đơn",
        smsHistories: "Tin nhắn đã gửi",
        fullName: "Họ tên",
        companyName: "Công ty",
        address: "Địa chỉ",
        taxCode: "Mã số thuế",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        payLater: "Thanh toán sau",
        customer: "Khách hàng",
        surcharge: "Phụ thu",
        exportAccessTrade: "Xuất đối soát Access Trade",
        exportAT: "Xuất đối soát Affiliate",
        exportDate: "Ngày xuất",
        affiliateSource: "Nguồn",
        vinWonderInfo: "Thông tin vé VinWonders",
        fnbInfo: "Thông tin đơn hàng FNB",
        fnb: {
          restaurant: "Restaurant",
          pickupMode: "Pickup Mode",
          status: "Order Status",
          pickupTime: "Estimated Pickup Time",
          bookingCode: "Booking Code",
          orderTime: "Order Time",
          dish: "Dish",
          price: "Price",
          discount: "Discount",
          total: "Total",
        },
        surchargeInfo: "Thông tin phụ thu",
        checkInDate: "Ngày check-in",
        checkOutDate: "Ngày check-out",
        operaBooking: "Mã Booking",
        tourStatus: "Trạng thái",
        ticketStatus: "Trạng thái VW",
        tourSerialNumber: "Mã kiểm tra",
        changeStatus: "Thay đổi trạng thái ",
        tourStatusOptions: {
          1: "Đã bán",
          2: "Đã dùng",
          3: "Đã khoá",
        },
        tourStatusColors: {
          1: "grey",
          2: "green",
        },
        orderItemStatus: {
          1: "Phát hành",
          2: "Đã bán",
          3: "Đã dùng",
          4: "Đã hoàn",
          5: "Đã hủy",
          13: "Không thành công",
        },
        orderItemStatusColor: {
          1: "green",
          2: "green",
          3: "grey",
          4: "orange",
          5: "red",
          13: "red",
        },
        orderItemVWStatus: {
          0: "Tất cả",
          1: "Chờ sử dụng",
          2: "Đang sử dụng",
          3: "Hết lượt sử dụng",
          4: "Hết hạn",
          5: "Bị khóa",
          6: "Thẻ nạp chờ",
          7: "Hủy thẻ",
        },
        orderItemVWStatusColor: {
          0: "green",
          1: "green",
          2: "green",
          3: "red",
          4: "red",
          5: "red",
          6: "red",
          7: "red",
        },
        orderError: "Mã lỗi",
        retryCiapsBooking: "Thử lại",
        retryCiapsBookingSuccess:
          "Retry thành công. Mail confirmation đã được gửi đến khách hàng.",
        retryCiapsBookingErrors: {
          ORDER_NOT_FOUND: "Không tìm thấy đơn hàng",
          UNPAID_ORDER: "Đơn hàng chưa thanh toán",
          ORDER_FAILED: "Đơn hàng không ở trạng thái lỗi",
          ITEM_TYPE_NOT_EXIST: "Đơn hàng không có vé VinWonders Tour",
          RETRY_CIAPS_BOOKING_USING_DATE_EXPIRED: "Vé đã quá ngày sử dụng",
          RETRY_CIAPS_BOOKING_OUT_OF_STOCK: "Vé đã hết suất",
          CIAPS_BOOKING_COMPLETED: "Booking trên CiAPS đã hoàn tất",
          SYS: "Retry booking thất bại",
        },
        recommit: "Xuất lại vé",
        confirmRecommitTour: "Xác nhận xuất lại vé",
        confirmUpdateOrderStatus: "Bạn chắc chắn muốn cập nhật trạng thái?",
        memberShipCode: "Hạng thẻ",
        differenceDueToPriceCodeChange: "Chênh lệch do đổi mã giá",
        addSurchargeTitle: "Tạo phiếu phụ thu",
        selectASurchargeToCancel: "Lựa chọn phụ thu hủy",
        surchargeCost: "Số tiền phụ thu",
        selectSurchargeType: "Lựa chọn kiểu",
        surchargeDesc: "Đảm bảo đã thu được tiền của khách và có sẵn FT code",
        customersList: "Danh sách khách hàng",
        nationalityID: "Quốc tịch",
        outletInfo: "Địa điểm",
        sessionInfo: "Khung giờ",
      },
      tour: {
        title: "Tour",
        bookingDate: "Ngày khởi hành",
        totalPrice: "Tổng giá",
        outStock: "Hết vé",
        adultTicket: "Số lượng người lớn",
        childTicket: "Số lượng trẻ em",
        productTypes: "Loại sản phẩm",
        operationManuals: "Hướng dẫn vận hành",
        propertyName: "Cơ sở lưu trú",
        saleDate: "Ngày bán",
        stayDate: "Ngày lưu trú",
        cutOffDate: "Số ngày phải đặt trước",
        createTicket: "Tạo ticket",
        updateTicket: "Cập nhật",
        ticketName: "Tên",
        uploadFile: "Tải hình ảnh",
        uploading: "Đang tải lên",
        tourTitle: "Tiêu đề",
        tourCode: "Mã tour",
        tourName: "Tên tour",
        images: "Hình ảnh",
        thumbImage: "Ảnh đại diện",
        departure: "Điểm khởi hành",
        destination: "Điểm đến",
        groupSize: "Size đoàn",
        order: "Trọng số",
        countryId: "Địa điểm",
        stateOrProvinceId: "Mã vùng",
        duration: "Thời gian",
        description: "Mô tả",
        service: "Dịch vụ",
        cancelCondition: "Điều kiện huỷ",
        cancellationPolicy: "Điều kiện hoàn hủy",
        departureDateItem: "Ngày khởi hành",
        productType: "Loại tour",
        from: "Ngày đi",
        to: "Ngày về",
        seat: "Số chỗ ngồi",
        originalPrice: "Giá",
        salePrice: "Giá khuyến mãi",
        priceTypeHeader: "Loại giá",
        highlight: "Điểm nổi bật",
        itinerary: "Lịch trình",
        serviceIncluded: "Dịch vụ bao gồm",
        serviceExcluded: "Dịch vụ không bao gồm",
        note: "Lưu ý",
        noted: "Ghi chú",
        checklist: "Checklist khởi hành",
        hotel: "Khách sạn",
        airline: "Nhà cung cấp",
        days: "Số ngày",
        day: "Ngày",
        nights: "Số đêm",
        night: "Đêm",
        isSpecial: "Tour nổi bật",
        adultOriginalPrice: "Giá vé mặc định",
        adultSalePrice: "Giá vé người lớn khuyến mãi",
        childOriginalPrice: "Giá vé trẻ em",
        childSalePrice: "Giá vé trẻ em khuyến mãi",
        action: "Thao tác",
        lengthOfTour: "Độ dài kỳ nghỉ",
        enumLengthOfTour: "days ngày nights đêm",
        active: "Kích hoạt",
        deactive: "Ngưng kích hoạt",
        priceType: {
          ADULT: "Người lớn",
          OLDSTER: "Người cao tuổi trên 65",
          CHILD: "Trẻ em từ 4 - 11 tuổi",
          NEWBORN: "Trẻ em dưới 4 tuổi",
          ANIMAL: "Động vật",
        },
        limitNumberOfSale: "Giới hạn số lượng mua",
        step: "Chu kỳ (ngày)",
        errorCode: {
          2: "Ngày khởi hành không được nhỏ hơn ngày khởi hành của hành trình đã tồn tại",
          TS_DEPARTURE_DATE_EXIST: "Ngày khởi hành đã tồn tại",
          UNDEFINED_ERROR: "Lỗi không xác định. Vui lòng thử lại!",
          TS_TOUR_NOT_FOUND: "Không tìm thấy tour",
          // TS_INVALID_MAXDATE: 'Ngày khởi hành được chọn không được lớn hơn ngày khởi hành sau cùng của tour',
          TS_INVALID_MAXDATE: "Ngày khởi hành đã tồn tại",
          TS_TOUR_TYPE_IN_USED:
            "Lỗi: Không thể xóa, đối tượng sử dụng đang được sử dụng bởi tour khác",
        },
        generalInfo: "Thông tin chung",
        tripItinerary: "Lịch trình",
        tripItineraryContent: "Nội dung lịch trình",
        tourInfo: "Thông tin tour",
        productInfo: "Sản phẩm",
        sellPlan: "Kế hoạch bán",
        tourTickets: "Vé và biến đổi giá",
        defaultPrice: "Giá mặc định",
        departureDate: "Ngày khởi hành",
        departureDates: "Các ngày khởi hành",
        destinationDate: "Ngày kết thúc",
        tourOperationType: "Loại tour",
        channel: "Kênh bán",
        showTicketInfo: {
          title: "Lựa chọn thông tin trong hiển thị vé QR",
          note: "Lưu ý: mặc định hiển thị Mã Booking, Ngày sử dụng & Loại vé",
        },
        inbound: "Nội địa",
        outbound: "Quốc tế",
        tourTypes: "Đối tượng sử dụng",
        tagSKUVW: "Tag SKU VWBK",
        tag: "Tag",
        selectTourTypes: "Chọn dòng các đối tượng sử dụng",
        selectTagSKUVW: "Chọn dòng các tag SKU VWBK",
        tourTypeName: "Tên đối tượng sử dụng",
        tagSKUVWName: "Tên tag SKU VWBK",
        isHotTour: "Hot tour",
        attribute: "Thuộc tính",
        isWebsitePublished: "Hiển thị trên website",
        isWebsiteNotPublished: "Chưa lên website",
        isCrossSell: "Hiển thị bán CrossSell",
        publishDateTime: "Ngày đưa lên website",
        urlSlug: "Đường dẫn website",
        specialImage: "Ảnh nổi bật",
        slideShowImages: "Ảnh trình chiếu",
        checklistContent: "Nội dung checklist",
        checkListEmptyTitle: "Chưa có tiêu đề",
        isEnabled: "Hiệu lực",
        isEnabledTitle: "Trạng thái",
        isDisabled: "Tắt",
        currency: "Đơn vị tiền tệ",
        shortDescription: "Mô tả ngắn",
        months: "Tháng",
        vehicle: "Nhà cung cấp phương tiện",
        accommodation: "Nhà cung cấp lưu trú",
        meal: "Nhà cung cấp ăn uống",
        activity: "Nhà cung cấp hoạt động",
        languages: "Ngôn ngữ",
        translations: "Phiên dịch",
        productTypeTrans: {
          flightAndHotel: "Vé máy bay + KS Vinpearl",
          highSpeedShipHotel: "Tàu cao tốc + KS Vinpearl",
          vinpearlHotel: "Gói phòng Vinpearl",
          tourAndExperience: "Tour & Trải nghiệm",
          airportPickup: "Đón tiễn sân bay",
          installmentVIN: "Trả góp 0%",
        },
        ticketObjectType: "Chọn đối tượng",
        ticketType: "Loại vé",
      },
      changeRateCode: {
        noteContentChangeRateCode:
          "Thay đổi từ một mã giá sang nhiều hơn một mã giá hệ thống yêu cầu tạo nhanh mã giá thay thế",
        additionalPayment: "Thanh toán thêm",
        nonAdditionalPayment: "Không thanh toán thêm",
        quicklyCreateANewPriceCode: "Tạo nhanh mã giá mới",
        newCodePrice: "Code mã giá mới",
        nameNewCode: "Tên mã giá mới",
        totalPrice: "Tổng tiền: {{totalPrice}}",
        salePriceRounding: "Giá bán làm tròn",
        priceRounding: "Làm tròn: {{priceRounding}}",
      },
      configSourceFlight: {
        ticketVieJet: "Vé Vietjet",
        vieJet: "Nguồn trực tiếp từ Vietjet",
        dataCom: "Nguồn lấy qua đối tác DataCom",
      },
      golf: {
        title: "Sân Golf",
        orderNo: "Thứ tự hiển thị",
        name: "Tên sân Golf",
        code: "Code",
        active: "Trạng thái",
        translations: "Phiên dịch",
        action: "Thao tác",
        basicInfo: "Thông tin cơ bản",
        images: "Hình ảnh",
        email: "Email",
        hotline: "Hotline",
        website: "Link trên trang Branding",
        shortDescription: "Mô tả ngắn ",
        description: "Mô tả chi tiết",
        addressInfo: "Thông tin địa chỉ",
        linkGoogleMap: "Link Google Map",
        // active: "Hoạt động",
        deActive: "Ngừng hoạt động",
        uploadFile: "Tải hình ảnh",
        uploading: "Đang tải lên",
        messageSyncAll:
          "Đồng bộ dữ liệu với Golf Soft sẽ ghi đè lên dữ liệu hiện tại. Xác nhận đồng bộ ?",
        updateOrder: "Cập nhật thứ tự",
        supportPayLater: "Hỗ trợ trả sau",
      },
      fnb: {
        outlet: {
          propertyName: "Cơ sở",
          outletName: "Nhà hàng",
          code: "Code",
          active: "Trạng thái",
          inactive: "Inactive",
          translations: "Phiên dịch",
          action: "Thao tác",
        },
        menu: {
          code: "Menu code",
          name: "Menu name",
          outlet: "Outlet",
          translations: "Translations",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          image: "Image",
        },
        menuItem: {
          code: "Item code",
          name: "Item name",
          tags: "Tags",
          closeItem: "Closed",
          closeItemInternal: "Closed internally",
          salePrice: "Sale price",
          description: "Description",
          active: "Yes",
          inactive: "No",
          unauthorized: "Your account is not authorized to perform this action!",
        },
        menuGroup: {
          groupCode: "Group code",
          groupName: "Group name",
          translations: "Translations",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
        },
        option: {
          name: "Name",
          code: "Code",
          translations: "Translations",
        },
        product: {
          name: "Tên",
          code: "Mã",
          shortName: "Tên ngắn",
          totalPrice: "Giá",
          translations: "Phiên dịch",
          status: "Trạng thái",
          action: "Thao tác",
        }
      },
    },
    btbOrderReport: {
      title: "Báo cáo đơn hàng BTB",
      hotelName: "Khách sạn",
      fullname: "Họ tên người đặt",
      email: "Email người đặt",
      phoneNumber: "SĐT người đặt",
      transactionDate: "Ngày đặt",
      arrivalDate: "Ngày CI",
      titleArrivalDate: "Ngày đến",
      departureDate: "Ngày CO",
      stayNight: "Số đêm",
      villaOwnerCode: "Mã căn sử dụng",
      itineraryNumber: "Mã hành trình",
      roomConfirmationNumber: "Mã xác nhận",
      roomTypeName: "Loại phòng",
      ratePlanCode: "Rate",
      fullnameCustomer: "Khách chính",
      total: "Điểm thanh toán",
      export: "Xuất file Excel",
    },
    vinwondertaggroup: {
      nameVI: "Tên tab hiển thị (tiếng Việt)",
      code: "Code (giá trị parameter trên URL)",
      nameEN: "Tên tab hiển thị (tiếng Anh)",
      nameKO: "Tên tab hiển thị (tiếng Hàn)",
      nameZh: "Tên tab hiển thị (tiếng Trung)",
      nameRu: "Tên tab hiển thị (tiếng Nga)",
      nameHI: "Tên tab hiển thị (tiếng Ấn)",
      applyForSuppliers: "Áp dụng trên các NCC",
      filterFollowSupplier: "Filter theo NCC",
      name: "Tên",
      codeIndex: "Code",
      supplierNamesConfiged: "Nhà cung cấp đã link",
      totalSkuConfiged: "SKUs đã link",
      isActive: "Trạng thái",
      action: "Thao tác",
      translations: "Phiên dịch",
      orderCode: "Thứ tự hiển thị",
      nameFollowSupplier: "Tên hiển thị",
      isDefault: "Mặc định",
      siteType: "Hiển thị cho trang",
    },
    orderGolf: {
      info: "Thông tin Tee Time & người chơi",
      teeTime: "Tee Time",
      infoItem: "Thông tin người chơi",
      date: "Ngày chơi",
      time: "Giờ phát bóng",
      golf: "Sân Golf",
      courtType: "Loại sân",
      holes: "Số lỗ",
      teeBox: "Điểm phát bóng",
      numberPlayer: "Số người chơi",
      customerType: "Loại khách",
      customerName: "Tên khách",
      customerCode: "MCode",
      voucherCode: "Mã Voucher",
      voucherAmount: "Phụ thu Voucher",
      amount: "Thành tiền",
      no: "STT",
      paymentInfo: "Chi tiết thanh toán",
      cashBeforePromotion: "Thành tiền trước khuyến mại",
      useVoucher: "Sử dụng Voucher (dành cho Đại lý)",
      countVC: "Số Voucher đã sử dụng",
      surcharge: "Phụ thu",
      deposit: "Trừ tài khoản Deposit (dành cho Đại lý)",
      total: "Tổng tiền",
      category: "Hạng mục",
      serviceType: "Loại dịch vụ",
    },
  },
};
